"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  DEFAULT_SEARCH_PARAMS_ACCESS_TOKEN_STRATEGY: () => DEFAULT_SEARCH_PARAMS_ACCESS_TOKEN_STRATEGY,
  EXTERNAL_ENVIRONMENT_DEFAULT_DATA_SHARING_MODE: () => EXTERNAL_ENVIRONMENT_DEFAULT_DATA_SHARING_MODE,
  EXTERNAL_ENVIRONMENT_SYNC_API_KEY_HEADER: () => EXTERNAL_ENVIRONMENT_SYNC_API_KEY_HEADER,
  EXTERNAL_ENVIRONMENT_SYNC_CONTRACT_VERSION: () => EXTERNAL_ENVIRONMENT_SYNC_CONTRACT_VERSION,
  EXTERNAL_ENVIRONMENT_SYNC_DETAIL_URL_MAX_LENGTH: () => EXTERNAL_ENVIRONMENT_SYNC_DETAIL_URL_MAX_LENGTH,
  EXTERNAL_ENVIRONMENT_SYNC_MAX_BATCH_SIZE: () => EXTERNAL_ENVIRONMENT_SYNC_MAX_BATCH_SIZE,
  INSPECTION_COST_USAGE_ANALYSIS_DEFAULT_WINDOW_DAYS: () => INSPECTION_COST_USAGE_ANALYSIS_DEFAULT_WINDOW_DAYS,
  INSPECTION_COST_USAGE_ANALYSIS_MAX_WINDOW_DAYS: () => INSPECTION_COST_USAGE_ANALYSIS_MAX_WINDOW_DAYS,
  INSPECTION_RESULT_BY_LEGACY_VEREDICT: () => INSPECTION_RESULT_BY_LEGACY_VEREDICT,
  InspectionCompletedBy: () => import_ai_constants4.InspectionCompletedBy,
  InspectionResult: () => import_ai_constants4.InspectionResult,
  MAX_EVAL_ANALYSIS_SELECTION_LABELS: () => MAX_EVAL_ANALYSIS_SELECTION_LABELS,
  VerificationStatusEnum: () => VerificationStatusEnum,
  actionSources: () => actionSources,
  addonPlanSchema: () => addonPlanSchema,
  addonPlanSchemaBase: () => addonPlanSchemaBase,
  aggregatePaginateUsersRequestQuery: () => aggregatePaginateUsersRequestQuery,
  aggregatePaginateUsersResponseBody: () => aggregatePaginateUsersResponseBody,
  aggregatedAssetTypes: () => aggregatedAssetTypes,
  aggregatedFileAssetTypes: () => aggregatedFileAssetTypes,
  applyAddonPlanCustomValidations: () => applyAddonPlanCustomValidations,
  applyInvoiceRefinements: () => applyInvoiceRefinements,
  assetsSchema: () => assetsSchema,
  assignDatasetOntologyLabelColors: () => assignDatasetOntologyLabelColors,
  autoinspectorDatasetAnnotationGroupSchema: () => autoinspectorDatasetAnnotationGroupSchema,
  autoinspectorDatasetAnnotationSchema: () => autoinspectorDatasetAnnotationSchema,
  autoinspectorDatasetAnnotationTargetSchema: () => autoinspectorDatasetAnnotationTargetSchema,
  autoinspectorDatasetAnnotationTypeByTaskType: () => autoinspectorDatasetAnnotationTypeByTaskType,
  autoinspectorDatasetAssetSchema: () => autoinspectorDatasetAssetSchema,
  autoinspectorDatasetAssetSourceSchema: () => autoinspectorDatasetAssetSourceSchema,
  autoinspectorDatasetBboxSchema: () => autoinspectorDatasetBboxSchema,
  autoinspectorDatasetFormatExample: () => autoinspectorDatasetFormatExample,
  autoinspectorDatasetFormatHeaderJsonSchema: () => autoinspectorDatasetFormatHeaderJsonSchema,
  autoinspectorDatasetFormatHeaderSchema: () => autoinspectorDatasetFormatHeaderSchema,
  autoinspectorDatasetFormatJsonSchema: () => autoinspectorDatasetFormatJsonSchema,
  autoinspectorDatasetFormatLineSchema: () => autoinspectorDatasetFormatLineSchema,
  autoinspectorDatasetFormatMediaTypes: () => autoinspectorDatasetFormatMediaTypes,
  autoinspectorDatasetFormatRecordLineJsonSchema: () => autoinspectorDatasetFormatRecordLineJsonSchema,
  autoinspectorDatasetFormatRecordLineSchema: () => autoinspectorDatasetFormatRecordLineSchema,
  autoinspectorDatasetFormatSchema: () => autoinspectorDatasetFormatSchema,
  autoinspectorDatasetFormatTaskTypes: () => autoinspectorDatasetFormatTaskTypes,
  autoinspectorDatasetMediaTypesByTaskType: () => autoinspectorDatasetMediaTypesByTaskType,
  autoinspectorDatasetMemberSchema: () => autoinspectorDatasetMemberSchema,
  autoinspectorDatasetPointSchema: () => autoinspectorDatasetPointSchema,
  autoinspectorDatasetRecordSchema: () => autoinspectorDatasetRecordSchema,
  autoinspectorDatasetSnapshotSchema: () => autoinspectorDatasetSnapshotSchema,
  autoinspectorDatasetTextAnnotationSchema: () => autoinspectorDatasetTextAnnotationSchema,
  autoinspectorDatasetViewSchema: () => autoinspectorDatasetViewSchema,
  autoinspectorEvalAnalysisConfigSchema: () => autoinspectorEvalAnalysisConfigSchema,
  autoinspectorEvalAnalysisGroupThresholdSchema: () => autoinspectorEvalAnalysisGroupThresholdSchema,
  autoinspectorEvalAnalysisGroupValueSchema: () => autoinspectorEvalAnalysisGroupValueSchema,
  autoinspectorEvalAnalysisKnobSchema: () => autoinspectorEvalAnalysisKnobSchema,
  autoinspectorEvalAnalysisLabelGroupThresholdSchema: () => autoinspectorEvalAnalysisLabelGroupThresholdSchema,
  autoinspectorEvalAnalysisLabelThresholdSchema: () => autoinspectorEvalAnalysisLabelThresholdSchema,
  autoinspectorEvalAnalysisSelectionRequestSchema: () => autoinspectorEvalAnalysisSelectionRequestSchema,
  autoinspectorEvalLabelAttributeFilterSchema: () => autoinspectorEvalLabelAttributeFilterSchema,
  autoinspectorEvalResultFormatClassificationRecordExample: () => autoinspectorEvalResultFormatClassificationRecordExample,
  autoinspectorEvalResultFormatDetectionRecordExample: () => autoinspectorEvalResultFormatDetectionRecordExample,
  autoinspectorEvalResultFormatErrorRecordExample: () => autoinspectorEvalResultFormatErrorRecordExample,
  autoinspectorEvalResultFormatExample: () => autoinspectorEvalResultFormatExample,
  autoinspectorEvalResultFormatInstanceListRecordExample: () => autoinspectorEvalResultFormatInstanceListRecordExample,
  autoinspectorEvalResultFormatInstanceSegmentationRecordExample: () => autoinspectorEvalResultFormatInstanceSegmentationRecordExample,
  autoinspectorEvalResultFormatLineSchema: () => autoinspectorEvalResultFormatLineSchema,
  autoinspectorEvalResultFormatOcrRecordExample: () => autoinspectorEvalResultFormatOcrRecordExample,
  autoinspectorEvalResultFormatProcessedItemJsonSchema: () => autoinspectorEvalResultFormatProcessedItemJsonSchema,
  autoinspectorEvalResultFormatProcessedItemSchema: () => autoinspectorEvalResultFormatProcessedItemSchema,
  autoinspectorEvalResultFormatRecordLineJsonSchema: () => autoinspectorEvalResultFormatRecordLineJsonSchema,
  autoinspectorEvalResultFormatRecordLineSchema: () => autoinspectorEvalResultFormatRecordLineSchema,
  autoinspectorEvalResultFormatSkippedRecordExample: () => autoinspectorEvalResultFormatSkippedRecordExample,
  autoinspectorEvalResultFormatTargetSchema: () => autoinspectorEvalResultFormatTargetSchema,
  backofficeReviewSchema: () => backofficeReviewSchema,
  backofficeReviewStageSchema: () => backofficeReviewStageSchema,
  batchSendInspectionsRequestBody: () => batchSendInspectionsRequestBody,
  batchSendInspectionsResponseBody: () => batchSendInspectionsResponseBody,
  buildInspectionDetailImageUrlDiagnostics: () => buildInspectionDetailImageUrlDiagnostics,
  buildUserName: () => buildUserName,
  carddDamageAssetSchema: () => carddDamageAssetSchema,
  carddDamageNames: () => carddDamageNames,
  carddDamageSeverities: () => carddDamageSeverities,
  carddDamageSizes: () => carddDamageSizes,
  carddGroupDamageSchema: () => carddGroupDamageSchema,
  carddGroupOutputSchema: () => carddGroupOutputSchema,
  carddImageDamageSchema: () => carddImageDamageSchema,
  carddImageDimensionsSchema: () => carddImageDimensionsSchema,
  carddImageResultSchema: () => carddImageResultSchema,
  carddPolygonPointSchema: () => carddPolygonPointSchema,
  carddUnknownPartName: () => carddUnknownPartName,
  commitStagedInferenceResultsResponseBody: () => commitStagedInferenceResultsResponseBody,
  companySchema: () => companySchema,
  computeStatusFromDates: () => computeStatusFromDates,
  convertHexToRgbaString: () => convertHexToRgbaString,
  countEvalAnalysisCombinations: () => countEvalAnalysisCombinations,
  createAuthorizationURLRequestBody: () => createAuthorizationURLRequestBody,
  createAuthorizationURLResponseBody: () => createAuthorizationURLResponseBody,
  createInspectionAnnotationRequestBody: () => createInspectionAnnotationRequestBody,
  createInspectionAnnotationResponseBody: () => createInspectionAnnotationResponseBody,
  createInspectionPublicApiV2ResponseBodySchema: () => createInspectionPublicApiV2ResponseBodySchema,
  createInvoiceRequestBody: () => createInvoiceRequestBody,
  createInvoiceResponseBody: () => createInvoiceResponseBody,
  createSubscriptionRequestBody: () => createSubscriptionRequestBody,
  createSubscriptionRequestParams: () => createSubscriptionRequestParams,
  createSubscriptionResponseBody: () => createSubscriptionResponseBody,
  createWebhookPublicApiV2RequestBodySchema: () => createWebhookPublicApiV2RequestBodySchema,
  createWebhookPublicApiV2ResponseBodySchema: () => createWebhookPublicApiV2ResponseBodySchema,
  createZodTypeSafeEnumOpenApi: () => createZodTypeSafeEnumOpenApi,
  damageCostAnalysisJobSchema: () => damageCostAnalysisJobSchema,
  damageCostAnalysisStatusSchema: () => damageCostAnalysisStatusSchema,
  dataTableFiltersSchema: () => dataTableFiltersSchema,
  dataTableRequestQuerySchema: () => dataTableRequestQuerySchema,
  dataTableSortSchema: () => dataTableSortSchema,
  defaultInspectionTableColumns: () => defaultInspectionTableColumns,
  deleteInspectionAnnotationResponseBody: () => deleteInspectionAnnotationResponseBody,
  deleteWebhookPublicApiV2ResponseBodySchema: () => deleteWebhookPublicApiV2ResponseBodySchema,
  downloadInspectionsReportRequestBody: () => downloadInspectionsReportRequestBody,
  evalOptimizationCellSchema: () => evalOptimizationCellSchema,
  evalOptimizationObjectiveSchema: () => evalOptimizationObjectiveSchema,
  evalOptimizationRequestSchema: () => evalOptimizationRequestSchema,
  evalOptimizationResponseSchema: () => evalOptimizationResponseSchema,
  executeSegmentationSimulationRequestBody: () => executeSegmentationSimulationRequestBody,
  executeSegmentationSimulationResponseBody: () => executeSegmentationSimulationResponseBody,
  externalEnvironmentCostUsageTokenDirections: () => externalEnvironmentCostUsageTokenDirections,
  externalEnvironmentDataClasses: () => externalEnvironmentDataClasses,
  externalEnvironmentDataSharingModes: () => externalEnvironmentDataSharingModes,
  externalEnvironmentDataSharingSchema: () => externalEnvironmentDataSharingSchema,
  externalEnvironmentPipelineCostKinds: () => externalEnvironmentPipelineCostKinds,
  externalEnvironmentSyncAcceptedItemStatuses: () => externalEnvironmentSyncAcceptedItemStatuses,
  externalEnvironmentSyncAssetBindingSchema: () => externalEnvironmentSyncAssetBindingSchema,
  externalEnvironmentSyncAssetContentSchema: () => externalEnvironmentSyncAssetContentSchema,
  externalEnvironmentSyncAssetTypes: () => externalEnvironmentSyncAssetTypes,
  externalEnvironmentSyncContractAlignment: () => externalEnvironmentSyncContractAlignment,
  externalEnvironmentSyncContractVersions: () => externalEnvironmentSyncContractVersions,
  externalEnvironmentSyncDetailUrlSchema: () => externalEnvironmentSyncDetailUrlSchema,
  externalEnvironmentSyncInferenceContentSchema: () => externalEnvironmentSyncInferenceContentSchema,
  externalEnvironmentSyncInferenceStatuses: () => externalEnvironmentSyncInferenceStatuses,
  externalEnvironmentSyncInspectionResults: () => externalEnvironmentSyncInspectionResults,
  externalEnvironmentSyncInspectionStatuses: () => externalEnvironmentSyncInspectionStatuses,
  externalEnvironmentSyncJsonSchemaDocumentSchema: () => externalEnvironmentSyncJsonSchemaDocumentSchema,
  externalEnvironmentSyncJsonValueSchema: () => externalEnvironmentSyncJsonValueSchema,
  externalEnvironmentSyncKeySchema: () => externalEnvironmentSyncKeySchema,
  externalEnvironmentSyncObjectIdSchema: () => externalEnvironmentSyncObjectIdSchema,
  externalEnvironmentSyncRejectionReasons: () => externalEnvironmentSyncRejectionReasons,
  externalEnvironmentSyncRejectionRetryability: () => externalEnvironmentSyncRejectionRetryability,
  externalEnvironmentSyncValidationReasoningSchema: () => externalEnvironmentSyncValidationReasoningSchema,
  externalEnvironmentSyncValidationResults: () => externalEnvironmentSyncValidationResults,
  extractCalendarDate: () => extractCalendarDate,
  formatDateToLocale: () => formatDateToLocale,
  formatDateToLocaleDays: () => formatDateToLocaleDays,
  getCompaniesPaginationResponseBody: () => getCompaniesPaginationResponseBody,
  getCurrentDate: () => getCurrentDate,
  getTestingCurrentDate: () => getTestingCurrentDate,
  getVehicleAngleModelUrlResponseBody: () => getVehicleAngleModelUrlResponseBody,
  getVehicleCompletenessModelConfigResponseBody: () => getVehicleCompletenessModelConfigResponseBody,
  homeStatsDateWindowUnits: () => homeStatsDateWindowUnits,
  identityProviders: () => identityProviders,
  inspectionAnnotationAttachmentSchema: () => inspectionAnnotationAttachmentSchema,
  inspectionAnnotationMentionSchema: () => inspectionAnnotationMentionSchema,
  inspectionAnnotationSchema: () => inspectionAnnotationSchema,
  inspectionAnnotationTargetSchema: () => inspectionAnnotationTargetSchema,
  inspectionAssetContentAvailabilities: () => inspectionAssetContentAvailabilities,
  inspectionAssetProcessedWebhookPayloadAssetSchema: () => inspectionAssetProcessedWebhookPayloadAssetSchema,
  inspectionAssetProcessedWebhookPayloadSchema: () => inspectionAssetProcessedWebhookPayloadSchema,
  inspectionChangelogStatusFilters: () => inspectionChangelogStatusFilters,
  inspectionClientCompletedEventV2Schema: () => inspectionClientCompletedEventV2Schema,
  inspectionClientCompletedPayloadV2Schema: () => inspectionClientCompletedPayloadV2Schema,
  inspectionClientCompletionResponseBody: () => inspectionClientCompletionResponseBody,
  inspectionCostUsageAggregateSchema: () => inspectionCostUsageAggregateSchema,
  inspectionCostUsageAnalysisBaseQuery: () => inspectionCostUsageAnalysisBaseQuery,
  inspectionCostUsageAnalysisCategoryTotalSchema: () => inspectionCostUsageAnalysisCategoryTotalSchema,
  inspectionCostUsageAnalysisCompanyDriverRowSchema: () => inspectionCostUsageAnalysisCompanyDriverRowSchema,
  inspectionCostUsageAnalysisDeliveryChannelTotalSchema: () => inspectionCostUsageAnalysisDeliveryChannelTotalSchema,
  inspectionCostUsageAnalysisDriverDimensionSchema: () => inspectionCostUsageAnalysisDriverDimensionSchema,
  inspectionCostUsageAnalysisDriverDimensions: () => inspectionCostUsageAnalysisDriverDimensions,
  inspectionCostUsageAnalysisDriverRowSchema: () => inspectionCostUsageAnalysisDriverRowSchema,
  inspectionCostUsageAnalysisDriverSortFieldSchema: () => inspectionCostUsageAnalysisDriverSortFieldSchema,
  inspectionCostUsageAnalysisDriverSortFields: () => inspectionCostUsageAnalysisDriverSortFields,
  inspectionCostUsageAnalysisDriversRequestQuery: () => inspectionCostUsageAnalysisDriversRequestQuery,
  inspectionCostUsageAnalysisDriversResponseBody: () => inspectionCostUsageAnalysisDriversResponseBody,
  inspectionCostUsageAnalysisInspectionRowSchema: () => inspectionCostUsageAnalysisInspectionRowSchema,
  inspectionCostUsageAnalysisInspectionsRequestQuery: () => inspectionCostUsageAnalysisInspectionsRequestQuery,
  inspectionCostUsageAnalysisInspectionsResponseBody: () => inspectionCostUsageAnalysisInspectionsResponseBody,
  inspectionCostUsageAnalysisModelVersionDriverRowSchema: () => inspectionCostUsageAnalysisModelVersionDriverRowSchema,
  inspectionCostUsageAnalysisRequestQuery: () => inspectionCostUsageAnalysisRequestQuery,
  inspectionCostUsageAnalysisResponseBody: () => inspectionCostUsageAnalysisResponseBody,
  inspectionCostUsageAnalysisSortDirectionSchema: () => inspectionCostUsageAnalysisSortDirectionSchema,
  inspectionCostUsageAnalysisSummarySchema: () => inspectionCostUsageAnalysisSummarySchema,
  inspectionCostUsageAnalysisTemplateDriverRowSchema: () => inspectionCostUsageAnalysisTemplateDriverRowSchema,
  inspectionCostUsageAnalysisTrendPointSchema: () => inspectionCostUsageAnalysisTrendPointSchema,
  inspectionCostUsagePricingCostUsageSchema: () => inspectionCostUsagePricingCostUsageSchema,
  inspectionCostUsagePricingHistoryItemSchema: () => inspectionCostUsagePricingHistoryItemSchema,
  inspectionCostUsagePricingItemSchema: () => inspectionCostUsagePricingItemSchema,
  inspectionCostUsagePricingKeyByDeliveryChannel: () => inspectionCostUsagePricingKeyByDeliveryChannel,
  inspectionCostUsagePricingKeySchema: () => inspectionCostUsagePricingKeySchema,
  inspectionCostUsageReportAssetDeclarationSchema: () => inspectionCostUsageReportAssetDeclarationSchema,
  inspectionCostUsageReportCategorySchema: () => inspectionCostUsageReportCategorySchema,
  inspectionCostUsageReportLineItemSchema: () => inspectionCostUsageReportLineItemSchema,
  inspectionCostUsageReportSourceSchema: () => inspectionCostUsageReportSourceSchema,
  inspectionCostUsageReportStatusSchema: () => inspectionCostUsageReportStatusSchema,
  inspectionDetailDamagesResponseBody: () => inspectionDetailDamagesResponseBody,
  inspectionDetailIframeRequestQuerySchema: () => inspectionDetailIframeRequestQuerySchema,
  inspectionDetailImageErrorAssetContextSchema: () => inspectionDetailImageErrorAssetContextSchema,
  inspectionDetailImageErrorBrowserContextSchema: () => inspectionDetailImageErrorBrowserContextSchema,
  inspectionDetailImageErrorEvents: () => inspectionDetailImageErrorEvents,
  inspectionDetailImageErrorFailureSchema: () => inspectionDetailImageErrorFailureSchema,
  inspectionDetailImageErrorPageContextSchema: () => inspectionDetailImageErrorPageContextSchema,
  inspectionDetailImageErrorReportRequestBodySchema: () => inspectionDetailImageErrorReportRequestBodySchema,
  inspectionDetailImageErrorReportResponseBodySchema: () => inspectionDetailImageErrorReportResponseBodySchema,
  inspectionDetailImagePerformanceContextSchema: () => inspectionDetailImagePerformanceContextSchema,
  inspectionDetailImagePerformanceEntrySchema: () => inspectionDetailImagePerformanceEntrySchema,
  inspectionDetailImageRedactedQueryParamKinds: () => inspectionDetailImageRedactedQueryParamKinds,
  inspectionDetailImageRenderContexts: () => inspectionDetailImageRenderContexts,
  inspectionDetailImageSupportedFileExtensions: () => inspectionDetailImageSupportedFileExtensions,
  inspectionDetailImageUrlDiagnosticsSchema: () => inspectionDetailImageUrlDiagnosticsSchema,
  inspectionDetailImageUrlExpiryStates: () => inspectionDetailImageUrlExpiryStates,
  inspectionLinkStatusUpdatedWebhookEventPayloadSchema: () => inspectionLinkStatusUpdatedWebhookEventPayloadSchema,
  inspectionLinkStatusUpdatedWebhookPayloadSchema: () => inspectionLinkStatusUpdatedWebhookPayloadSchema,
  inspectionOriginSummarySchema: () => inspectionOriginSummarySchema,
  inspectionResults: () => import_ai_constants4.inspectionResults,
  inspectionSamplingListItemSchema: () => inspectionSamplingListItemSchema,
  invitationTokenHeaderName: () => invitationTokenHeaderName,
  invitationTokenRequestQuery: () => invitationTokenRequestQuery,
  inviteUsersRequestBody: () => inviteUsersRequestBody,
  inviteUsersResponseBody: () => inviteUsersResponseBody,
  invoiceRequestParams: () => invoiceRequestParams,
  isCalendarDateWithinBounds: () => isCalendarDateWithinBounds,
  isInspectionDetailImageTelemetryEligible: () => isInspectionDetailImageTelemetryEligible,
  isMongoObjectIdString: () => isMongoObjectIdString,
  isRepresentableEvalAnalysisCombinationCount: () => isRepresentableEvalAnalysisCombinationCount,
  listAllCompaniesResponseBody: () => listAllCompaniesResponseBody,
  listAssetInferenceChangelogsRequestQuery: () => listAssetInferenceChangelogsRequestQuery,
  listCompaniesRequestQuery: () => listCompaniesRequestQuery,
  listCompanySubscriptionsResponseBody: () => listCompanySubscriptionsResponseBody,
  listInferenceChangelogsResponseBodySchema: () => listInferenceChangelogsResponseBodySchema,
  listInspectionAnnotationsResponseBody: () => listInspectionAnnotationsResponseBody,
  listInspectionChangelogsRequestQuery: () => listInspectionChangelogsRequestQuery,
  listInspectionChangelogsResponseBodySchema: () => listInspectionChangelogsResponseBodySchema,
  listInspectionCostUsagePricingResponseBody: () => listInspectionCostUsagePricingResponseBody,
  listInspectionSamplingRequestQuery: () => listInspectionSamplingRequestQuery,
  listInspectionSamplingResponseBody: () => listInspectionSamplingResponseBody,
  listInvoicesRequestQuery: () => listInvoicesRequestQuery,
  listInvoicesResponseBody: () => listInvoicesResponseBody,
  listOfficeInspectionsRequestQuery: () => listOfficeInspectionsRequestQuery,
  listOfficeInspectionsResponseBody: () => listOfficeInspectionsResponseBody,
  listOfficeNotificationsRequestQuery: () => listOfficeNotificationsRequestQuery,
  listOfficeNotificationsResponseBody: () => listOfficeNotificationsResponseBody,
  listTemplatesPublicApiV2RequestQuerySchema: () => listTemplatesPublicApiV2RequestQuerySchema,
  listTemplatesPublicApiV2ResponseBodySchema: () => listTemplatesPublicApiV2ResponseBodySchema,
  listWebhooksPublicApiV2ItemSchema: () => listWebhooksPublicApiV2ItemSchema,
  listWebhooksPublicApiV2RequestQuerySchema: () => listWebhooksPublicApiV2RequestQuerySchema,
  listWebhooksPublicApiV2ResponseBodySchema: () => listWebhooksPublicApiV2ResponseBodySchema,
  loginBouncedRequestQuery: () => loginBouncedRequestQuery,
  loginUserIDPRequestBody: () => loginUserIDPRequestBody,
  loginUserRequestBody: () => loginUserRequestBody,
  modelOperationalDiagnosticsIndicatorSchema: () => modelOperationalDiagnosticsIndicatorSchema,
  modelOperationalDiagnosticsMetadataSchema: () => modelOperationalDiagnosticsMetadataSchema,
  modelOperationalDiagnosticsResponseBodySchema: () => modelOperationalDiagnosticsResponseBodySchema,
  modelOperationalDiagnosticsStatusSchema: () => modelOperationalDiagnosticsStatusSchema,
  mongoObjectIdStringSchema: () => mongoObjectIdStringSchema,
  normalizeEmail: () => normalizeEmail,
  officeInspectionDetailAssetSchema: () => officeInspectionDetailAssetSchema,
  officeInspectionDetailInferenceSchema: () => officeInspectionDetailInferenceSchema,
  officeInspectionDetailValidationSchema: () => officeInspectionDetailValidationSchema,
  officeInspectionListItemSchema: () => officeInspectionListItemSchema,
  officeNotificationListStatuses: () => officeNotificationListStatuses,
  officeNotificationMetadataSchema: () => officeNotificationMetadataSchema,
  officeNotificationSchema: () => officeNotificationSchema,
  officeUpdateTemplateRequestBody: () => officeUpdateTemplateRequestBody,
  onboardingInviteUsersRequestBody: () => onboardingInviteUsersRequestBody,
  persistedDeclaredAssetSchema: () => persistedDeclaredAssetSchema,
  planLimitSchema: () => planLimitSchema,
  planSchema: () => planSchema,
  prepareInvoiceDownloadRequestParams: () => prepareInvoiceDownloadRequestParams,
  prepareInvoiceDownloadResponseBody: () => prepareInvoiceDownloadResponseBody,
  presignInspectionAnnotationAttachmentRequestBody: () => presignInspectionAnnotationAttachmentRequestBody,
  presignInspectionAnnotationAttachmentResponseBody: () => presignInspectionAnnotationAttachmentResponseBody,
  publicInspectionAssetBindingSchema: () => publicInspectionAssetBindingSchema,
  publicInspectionInferenceSchema: () => publicInspectionInferenceSchema,
  publicInspectionInferenceValueSchema: () => publicInspectionInferenceValueSchema,
  publicInspectionTemplateValidationSchema: () => publicInspectionTemplateValidationSchema,
  publicInspectionValidationSchema: () => publicInspectionValidationSchema,
  publicSpecTemplateBindingAssetTypes: () => publicSpecTemplateBindingAssetTypes,
  publicSpecTemplateInferenceSchema: () => publicSpecTemplateInferenceSchema,
  publicSpecTemplateValidationSchema: () => publicSpecTemplateValidationSchema,
  readOfficeNotificationResponseBody: () => readOfficeNotificationResponseBody,
  redactInspectionDetailImageErrorSensitiveText: () => redactInspectionDetailImageErrorSensitiveText,
  registerClientInspectionEventRequestBody: () => registerClientInspectionEventRequestBody,
  registerClientInspectionEventResponseBody: () => registerClientInspectionEventResponseBody,
  registerCompanyRequestBody: () => registerCompanyRequestBody,
  registerCompanyResponseBody: () => registerCompanyResponseBody,
  registerEmailMembershipInvitationRequestBody: () => registerEmailMembershipInvitationRequestBody,
  registerEmailMembershipInvitationRequestParams: () => registerEmailMembershipInvitationRequestParams,
  registerEmailMembershipInvitationResponseBody: () => registerEmailMembershipInvitationResponseBody,
  registerInspectionErrorRequestBody: () => registerInspectionErrorRequestBody,
  registerInvitationIDPRequestBody: () => registerInvitationIDPRequestBody,
  registerUserEventRequestBody: () => registerUserEventRequestBody,
  registerUserGuestRequestBody: () => registerUserGuestRequestBody,
  requiredErrorFieldMessage: () => requiredErrorFieldMessage,
  resendInvitationEmailAdminRequestBody: () => resendInvitationEmailAdminRequestBody,
  resendInvitationEmailAdminResponseBody: () => resendInvitationEmailAdminResponseBody,
  resolveDatasetOntologyLabelColorHex: () => resolveDatasetOntologyLabelColorHex,
  resolveInspectionCostUsageAnalysisDateRange: () => resolveInspectionCostUsageAnalysisDateRange,
  resolveInspectionDetailImageSourceExtension: () => resolveInspectionDetailImageSourceExtension,
  retrieveActiveWeeksStreakRequestQuery: () => retrieveActiveWeeksStreakRequestQuery,
  retrieveActiveWeeksStreakResponseBody: () => retrieveActiveWeeksStreakResponseBody,
  retrieveActivityStatsRequestBody: () => retrieveActivityStatsRequestBody,
  retrieveActivityStatsResponseBody: () => retrieveActivityStatsResponseBody,
  retrieveCompanyRequestParams: () => retrieveCompanyRequestParams,
  retrieveCompanyResponseBody: () => retrieveCompanyResponseBody,
  retrieveCompanySubscriptionRequestQuery: () => retrieveCompanySubscriptionRequestQuery,
  retrieveCompanySubscriptionResponseBody: () => retrieveCompanySubscriptionResponseBody,
  retrieveDamageCostAnalysisRequestParams: () => retrieveDamageCostAnalysisRequestParams,
  retrieveDamageCostAnalysisResponseBody: () => retrieveDamageCostAnalysisResponseBody,
  retrieveGuestRequestParams: () => retrieveGuestRequestParams,
  retrieveGuestRequestQuery: () => retrieveGuestRequestQuery,
  retrieveGuestResponseBody: () => retrieveGuestResponseBody,
  retrieveHomeStatsCalendarToDateRequestBodySchema: () => retrieveHomeStatsCalendarToDateRequestBodySchema,
  retrieveHomeStatsInTheLastRequestBodySchema: () => retrieveHomeStatsInTheLastRequestBodySchema,
  retrieveHomeStatsRequestBody: () => retrieveHomeStatsRequestBody,
  retrieveHomeStatsResponseBody: () => retrieveHomeStatsResponseBody,
  retrieveInspectionCostUsageReportsParams: () => retrieveInspectionCostUsageReportsParams,
  retrieveInspectionCostUsageReportsResponseBody: () => retrieveInspectionCostUsageReportsResponseBody,
  retrieveInspectionProgressResponseBody: () => retrieveInspectionProgressResponseBody,
  retrieveInspectionPublicApiV2ResponseBodySchema: () => retrieveInspectionPublicApiV2ResponseBodySchema,
  retrieveInspectionSummaryRequestParams: () => retrieveInspectionSummaryRequestParams,
  retrieveMembershipFromInvitationRequestParams: () => retrieveMembershipFromInvitationRequestParams,
  retrieveMembershipFromInvitationResponseBody: () => retrieveMembershipFromInvitationResponseBody,
  retrieveOfficeInspectionDetailParamsSchema: () => retrieveOfficeInspectionDetailParamsSchema,
  retrieveOfficeInspectionDetailResponseBodySchema: () => retrieveOfficeInspectionDetailResponseBodySchema,
  retrieveSamplingAccuracyMetricsRequestQuery: () => retrieveSamplingAccuracyMetricsRequestQuery,
  retrieveSamplingAccuracyMetricsResponseBody: () => retrieveSamplingAccuracyMetricsResponseBody,
  retrieveSegmentationEvolutionRequestQuery: () => retrieveSegmentationEvolutionRequestQuery,
  retrieveSegmentationEvolutionResponseBody: () => retrieveSegmentationEvolutionResponseBody,
  retrieveSubscriptionRequestParams: () => retrieveSubscriptionRequestParams,
  retrieveSyncCheckpointResponseBodySchema: () => retrieveSyncCheckpointResponseBodySchema,
  retrieveSyncEnvironmentResponseBodySchema: () => retrieveSyncEnvironmentResponseBodySchema,
  retrieveTemplatePublicApiV2RequestParamsSchema: () => retrieveTemplatePublicApiV2RequestParamsSchema,
  retrieveTemplatePublicApiV2RequestQuerySchema: () => retrieveTemplatePublicApiV2RequestQuerySchema,
  retrieveTemplatePublicApiV2ResponseAssetsExample: () => retrieveTemplatePublicApiV2ResponseAssetsExample,
  retrieveTemplatePublicApiV2ResponseBodyExample: () => retrieveTemplatePublicApiV2ResponseBodyExample,
  retrieveTemplatePublicApiV2ResponseBodySchema: () => retrieveTemplatePublicApiV2ResponseBodySchema,
  retrieveTemplatePublicApiV2ResponseInferencesExample: () => retrieveTemplatePublicApiV2ResponseInferencesExample,
  retrieveTemplatePublicApiV2ResponseSchemaExample: () => retrieveTemplatePublicApiV2ResponseSchemaExample,
  retrieveTemplatePublicApiV2ResponseValidationsExample: () => retrieveTemplatePublicApiV2ResponseValidationsExample,
  reviewInspectionSamplingResponseBody: () => reviewInspectionSamplingResponseBody,
  rollbackInspectionSamplingReviewResponseBody: () => rollbackInspectionSamplingReviewResponseBody,
  samplingAccuracyTemplateMetricSchema: () => samplingAccuracyTemplateMetricSchema,
  searchPlanRequestQuery: () => searchPlanRequestQuery,
  searchPlanResponseBody: () => searchPlanResponseBody,
  signInMethodSchema: () => signInMethodSchema,
  similaritySearchRequestParams: () => similaritySearchRequestParams,
  similaritySearchRequestQuery: () => similaritySearchRequestQuery,
  similaritySearchResponseBody: () => similaritySearchResponseBody,
  similaritySearchSupportedAssetTypes: () => similaritySearchSupportedAssetTypes,
  sortLogicRules: () => sortLogicRules,
  sortValidationsByOrder: () => sortValidationsByOrder,
  startDamageCostAnalysisRequestParams: () => startDamageCostAnalysisRequestParams,
  startDamageCostAnalysisResponseBody: () => startDamageCostAnalysisResponseBody,
  subscribeToAddonPlanRequestBody: () => subscribeToAddonPlanRequestBody,
  syncBatchResponseBodySchema: () => syncBatchResponseBodySchema,
  syncCostUsageReportBindingV1Schema: () => syncCostUsageReportBindingV1Schema,
  syncCostUsageReportChargeV1Schema: () => syncCostUsageReportChargeV1Schema,
  syncCostUsageReportParamsSchema: () => syncCostUsageReportParamsSchema,
  syncCostUsageReportV1Schema: () => syncCostUsageReportV1Schema,
  syncCostUsageReportsBatchRequestBodySchema: () => syncCostUsageReportsBatchRequestBodySchema,
  syncCostUsageUnitV1Schema: () => syncCostUsageUnitV1Schema,
  syncImplementedModelVersionReferenceV1Schema: () => syncImplementedModelVersionReferenceV1Schema,
  syncInspectionAssetV1Schema: () => syncInspectionAssetV1Schema,
  syncInspectionInferenceV1Schema: () => syncInspectionInferenceV1Schema,
  syncInspectionParamsSchema: () => syncInspectionParamsSchema,
  syncInspectionV1Schema: () => syncInspectionV1Schema,
  syncInspectionValidationV1Schema: () => syncInspectionValidationV1Schema,
  syncInspectionsBatchRequestBodySchema: () => syncInspectionsBatchRequestBodySchema,
  syncItemResultV1Schema: () => syncItemResultV1Schema,
  syncModelV1Schema: () => syncModelV1Schema,
  syncModelVersionReferenceV1Schema: () => syncModelVersionReferenceV1Schema,
  syncModelVersionV1Schema: () => syncModelVersionV1Schema,
  syncModelsBatchRequestBodySchema: () => syncModelsBatchRequestBodySchema,
  syncPipelineCostV1Schema: () => syncPipelineCostV1Schema,
  templateInputWalkaroundAssetSchema: () => templateInputWalkaroundAssetSchema,
  templateInputWalkaroundSchema: () => templateInputWalkaroundSchema,
  templateValidationFeedbackSchema: () => templateValidationFeedbackSchema,
  timeAgo: () => timeAgo,
  toInspectionResultOption: () => toInspectionResultOption,
  tokenizeFileRequestBody: () => tokenizeFileRequestBody,
  updateCompanyConfigRequestBody: () => updateCompanyConfigRequestBody,
  updateCompanyRequestBody: () => updateCompanyRequestBody,
  updateCompanyRequestParams: () => updateCompanyRequestParams,
  updateInspectionCostUsagePricingParams: () => updateInspectionCostUsagePricingParams,
  updateInspectionCostUsagePricingRequestBody: () => updateInspectionCostUsagePricingRequestBody,
  updateInspectionCostUsagePricingResponseBody: () => updateInspectionCostUsagePricingResponseBody,
  updateInvoiceRequestBody: () => updateInvoiceRequestBody,
  updatePlanRequestBody: () => updatePlanRequestBody,
  updatePlanRequestParams: () => updatePlanRequestParams,
  updateSubscriptionRequestBody: () => updateSubscriptionRequestBody,
  updateTemplateRequestParams: () => updateTemplateRequestParams,
  userActivityBaseSchema: () => userActivityBaseSchema,
  variableActionReferences: () => variableActionReferences,
  vehicleCompletenessModelContractSchema: () => vehicleCompletenessModelContractSchema,
  webhookApiVersionPublicApiV2Schema: () => webhookApiVersionPublicApiV2Schema,
  webhookEventPublicApiV2Schema: () => webhookEventPublicApiV2Schema,
  webhookPublicApiV2EventsSpec: () => webhookPublicApiV2EventsSpec
});
module.exports = __toCommonJS(src_exports);

// src/interfaces/template.interface.ts
var variableActionReferences = [
  "variable",
  "constant",
  "input",
  "image"
];

// src/contracts/company.contract.ts
var import_zod = __toESM(require("zod"));
var listAllCompaniesResponseBody = import_zod.default.object({
  companies: import_zod.default.array(
    import_zod.default.object({
      _id: import_zod.default.string(),
      fantasyName: import_zod.default.string(),
      societyReason: import_zod.default.string()
    })
  )
});

// src/contracts/data-table.ts
var import_zod2 = require("zod");
var dataTableSortSchema = import_zod2.z.object({
  id: import_zod2.z.string(),
  desc: import_zod2.z.union([
    import_zod2.z.string().transform((value) => value === "true"),
    import_zod2.z.boolean()
  ])
});
var dataTableFiltersSchema = import_zod2.z.object({
  id: import_zod2.z.string(),
  value: import_zod2.z.string().transform(
    (value) => import_zod2.z.coerce.number().safeParse(value).success ? /* @__PURE__ */ new Date(+value) : value
  ).transform(
    (value) => value === "true" || value === "false" ? value === "true" : value
  ).transform((value) => value === "null" ? null : value),
  operator: import_zod2.z.enum(["eq", "ne", "gt", "gte", "lt", "lte"]),
  variant: import_zod2.z.string().nullish()
});
var dataTableRequestQuerySchema = import_zod2.z.object({
  page: import_zod2.z.coerce.number().min(1, "Page must be greater than 0").default(1),
  perPage: import_zod2.z.coerce.number().min(1, "Limit must be greater than 0").max(50).default(10),
  search: import_zod2.z.string().nullish(),
  filters: import_zod2.z.array(dataTableFiltersSchema).default([]),
  joinOperator: import_zod2.z.enum(["and", "or"]).default("and"),
  sort: import_zod2.z.array(dataTableSortSchema).default([])
});

// src/contracts/office.contracts.ts
var import_ai_constants3 = require("ai-constants");
var import_zod7 = require("zod");

// src/contracts/inspection-cost-usage.contract.ts
var import_ai_constants = require("ai-constants");
var import_date_fns = require("date-fns");
var import_zod3 = require("zod");
var costUsageDateSchema = import_zod3.z.union([import_zod3.z.string(), import_zod3.z.date()]);
var costUsageAnalysisDateQuerySchema = import_zod3.z.union([import_zod3.z.string(), import_zod3.z.date()]);
var INSPECTION_COST_USAGE_ANALYSIS_MAX_WINDOW_DAYS = 60;
var INSPECTION_COST_USAGE_ANALYSIS_DEFAULT_WINDOW_DAYS = 30;
var parseCostUsageAnalysisDate = (value) => {
  if (!value)
    return void 0;
  const date = value instanceof Date ? value : (0, import_date_fns.parseISO)(value);
  return (0, import_date_fns.isValid)(date) ? date : void 0;
};
var validateCostUsageAnalysisDateRange = (query, ctx) => {
  const from = parseCostUsageAnalysisDate(query.from);
  const to = parseCostUsageAnalysisDate(query.to);
  if (query.from && !from) {
    ctx.addIssue({
      code: import_zod3.z.ZodIssueCode.custom,
      path: ["from"],
      message: "from must be a valid date"
    });
  }
  if (query.to && !to) {
    ctx.addIssue({
      code: import_zod3.z.ZodIssueCode.custom,
      path: ["to"],
      message: "to must be a valid date"
    });
  }
  if (query.from && !from || query.to && !to)
    return;
  const range = resolveInspectionCostUsageAnalysisDateRange(query);
  const inclusiveDays = (0, import_date_fns.differenceInCalendarDays)(range.to, range.from) + 1;
  if (inclusiveDays < 1) {
    ctx.addIssue({
      code: import_zod3.z.ZodIssueCode.custom,
      path: ["to"],
      message: "to must be after from"
    });
  }
  if (inclusiveDays > INSPECTION_COST_USAGE_ANALYSIS_MAX_WINDOW_DAYS) {
    ctx.addIssue({
      code: import_zod3.z.ZodIssueCode.custom,
      path: ["to"],
      message: `Date range cannot be greater than ${INSPECTION_COST_USAGE_ANALYSIS_MAX_WINDOW_DAYS} days`
    });
  }
};
var resolveInspectionCostUsageAnalysisDateRange = ({
  from,
  to
}) => {
  const resolvedTo = (0, import_date_fns.endOfDay)(parseCostUsageAnalysisDate(to) ?? /* @__PURE__ */ new Date());
  const resolvedFrom = (0, import_date_fns.startOfDay)(
    parseCostUsageAnalysisDate(from) ?? (0, import_date_fns.subDays)(
      resolvedTo,
      INSPECTION_COST_USAGE_ANALYSIS_DEFAULT_WINDOW_DAYS - 1
    )
  );
  return {
    from: resolvedFrom,
    to: resolvedTo
  };
};
var inspectionCostUsagePricingKeySchema = import_zod3.z.enum(
  import_ai_constants.inspectionCostUsagePricingKeys
);
var inspectionCostUsageReportCategorySchema = import_zod3.z.enum(
  import_ai_constants.inspectionCostUsageReportCategories
);
var inspectionCostUsageReportSourceSchema = import_zod3.z.enum(
  import_ai_constants.inspectionCostUsageReportSources
);
var inspectionCostUsageReportStatusSchema = import_zod3.z.enum(
  import_ai_constants.inspectionCostUsageReportStatuses
);
var inspectionCostUsageAggregateSchema = import_zod3.z.object({
  currency: import_zod3.z.literal(import_ai_constants.COST_USAGE_CURRENCY_USD),
  totalUsdMicros: import_zod3.z.number(),
  reportCount: import_zod3.z.number(),
  updatedAt: costUsageDateSchema
});
var inspectionCostUsageReportAssetDeclarationSchema = import_zod3.z.object({
  type: import_zod3.z.enum(import_ai_constants.processableAssetTypes),
  identifier: import_zod3.z.string(),
  instanceId: import_zod3.z.string().optional(),
  label: import_zod3.z.string()
});
var inspectionCostUsageReportLineItemSchema = import_zod3.z.object({
  id: import_zod3.z.string(),
  category: inspectionCostUsageReportCategorySchema,
  source: inspectionCostUsageReportSourceSchema,
  status: inspectionCostUsageReportStatusSchema,
  amountUsdMicros: import_zod3.z.number(),
  currency: import_zod3.z.literal(import_ai_constants.COST_USAGE_CURRENCY_USD),
  modelId: import_zod3.z.string().optional(),
  modelName: import_zod3.z.string().optional(),
  modelVersionId: import_zod3.z.string().optional(),
  modelVersionName: import_zod3.z.string().optional(),
  modelVersionRole: import_zod3.z.string().optional(),
  ravelExecutionId: import_zod3.z.string().optional(),
  ravelDashboardTraceUrl: import_zod3.z.string().min(1).optional(),
  notificationChannel: import_zod3.z.enum(import_ai_constants.notificationDeliveryCostUsageChannels).optional(),
  notificationEvent: import_zod3.z.string().optional(),
  notificationMessageId: import_zod3.z.string().optional(),
  pricingRevision: import_zod3.z.number().optional(),
  inspectionAssetDeclarations: import_zod3.z.array(
    inspectionCostUsageReportAssetDeclarationSchema
  ),
  createdAt: costUsageDateSchema,
  resolvedAt: costUsageDateSchema.optional()
});
var retrieveInspectionCostUsageReportsParams = import_zod3.z.object({
  id: import_zod3.z.string().min(1)
});
var retrieveInspectionCostUsageReportsResponseBody = import_zod3.z.object({
  aggregate: inspectionCostUsageAggregateSchema.nullable(),
  reports: import_zod3.z.array(inspectionCostUsageReportLineItemSchema)
});
var inspectionCostUsagePricingCostUsageSchema = import_zod3.z.object({
  currency: import_zod3.z.literal(import_ai_constants.COST_USAGE_CURRENCY_USD),
  amountUsdMicros: import_zod3.z.number()
});
var inspectionCostUsagePricingHistoryItemSchema = import_zod3.z.object({
  from: inspectionCostUsagePricingCostUsageSchema.optional(),
  to: inspectionCostUsagePricingCostUsageSchema.optional(),
  createdAt: import_zod3.z.union([import_zod3.z.string(), import_zod3.z.date()])
});
var inspectionCostUsagePricingItemSchema = import_zod3.z.object({
  pricingKey: inspectionCostUsagePricingKeySchema,
  costUsage: inspectionCostUsagePricingCostUsageSchema.nullable(),
  costUsageHistory: import_zod3.z.array(inspectionCostUsagePricingHistoryItemSchema),
  revision: import_zod3.z.number(),
  createdAt: import_zod3.z.union([import_zod3.z.string(), import_zod3.z.date()]).optional(),
  updatedAt: import_zod3.z.union([import_zod3.z.string(), import_zod3.z.date()]).optional()
});
var listInspectionCostUsagePricingResponseBody = import_zod3.z.object({
  items: import_zod3.z.array(inspectionCostUsagePricingItemSchema)
});
var updateInspectionCostUsagePricingParams = import_zod3.z.object({
  pricingKey: inspectionCostUsagePricingKeySchema
});
var updateInspectionCostUsagePricingRequestBody = import_zod3.z.object({
  costUsage: import_zod3.z.object({
    amountUsd: import_zod3.z.number().min(0)
  }).nullable()
}).strict();
var updateInspectionCostUsagePricingResponseBody = inspectionCostUsagePricingItemSchema;
var inspectionCostUsageAnalysisBaseQuery = import_zod3.z.object({
  from: costUsageAnalysisDateQuerySchema.optional(),
  to: costUsageAnalysisDateQuerySchema.optional(),
  companyId: import_zod3.z.string().min(1).optional(),
  templateId: import_zod3.z.string().min(1).optional()
}).superRefine(validateCostUsageAnalysisDateRange);
var inspectionCostUsageAnalysisRequestQuery = inspectionCostUsageAnalysisBaseQuery;
var inspectionCostUsageAnalysisSummarySchema = import_zod3.z.object({
  currency: import_zod3.z.literal(import_ai_constants.COST_USAGE_CURRENCY_USD),
  totalResolvedUsdMicros: import_zod3.z.number(),
  pendingUsdMicros: import_zod3.z.number(),
  resolvedReportCount: import_zod3.z.number(),
  pendingReportCount: import_zod3.z.number(),
  inspectionsWithCostCount: import_zod3.z.number(),
  clientCompletedInspectionCount: import_zod3.z.number(),
  averageResolvedUsdMicrosPerInspection: import_zod3.z.number(),
  pricePerClientCompletedInspectionUsdMicros: import_zod3.z.number().nullable(),
  lastResolvedAt: costUsageDateSchema.optional()
});
var inspectionCostUsageAnalysisTrendPointSchema = import_zod3.z.object({
  date: import_zod3.z.string(),
  inferenceUsdMicros: import_zod3.z.number(),
  notificationDeliveryUsdMicros: import_zod3.z.number(),
  totalUsdMicros: import_zod3.z.number()
});
var inspectionCostUsageAnalysisCategoryTotalSchema = import_zod3.z.object({
  category: inspectionCostUsageReportCategorySchema,
  totalUsdMicros: import_zod3.z.number(),
  reportCount: import_zod3.z.number()
});
var inspectionCostUsageAnalysisDeliveryChannelTotalSchema = import_zod3.z.object({
  channel: import_zod3.z.enum(import_ai_constants.notificationDeliveryCostUsageChannels),
  pricingKey: inspectionCostUsagePricingKeySchema,
  pricingRevision: import_zod3.z.number().optional(),
  currentPriceUsdMicros: import_zod3.z.number().nullable(),
  totalUsdMicros: import_zod3.z.number(),
  reportCount: import_zod3.z.number()
});
var inspectionCostUsageAnalysisResponseBody = import_zod3.z.object({
  summary: inspectionCostUsageAnalysisSummarySchema,
  dailyTrend: import_zod3.z.array(inspectionCostUsageAnalysisTrendPointSchema),
  categoryTotals: import_zod3.z.array(inspectionCostUsageAnalysisCategoryTotalSchema),
  deliveryChannelTotals: import_zod3.z.array(
    inspectionCostUsageAnalysisDeliveryChannelTotalSchema
  )
});
var inspectionCostUsageAnalysisDriverDimensions = [
  "company",
  "template",
  "model_version"
];
var inspectionCostUsageAnalysisDriverDimensionSchema = import_zod3.z.enum(
  inspectionCostUsageAnalysisDriverDimensions
);
var inspectionCostUsageAnalysisDriverSortFields = [
  "totalUsdMicros",
  "pricePerInspectionUsdMicros",
  "pricePerExecutionUsdMicros"
];
var inspectionCostUsageAnalysisDriverSortFieldSchema = import_zod3.z.enum(
  inspectionCostUsageAnalysisDriverSortFields
);
var inspectionCostUsageAnalysisSortDirectionSchema = import_zod3.z.enum(
  import_ai_constants.inspectionCostUsageAnalysisSortDirections
);
var inspectionCostUsageAnalysisPaginationQuery = import_zod3.z.object({
  page: import_zod3.z.coerce.number().int().min(1).optional(),
  perPage: import_zod3.z.coerce.number().int().min(1).max(50).optional()
});
var inspectionCostUsageAnalysisCompanyDriversSortQuery = import_zod3.z.object({
  dimension: import_zod3.z.literal("company"),
  sortField: import_zod3.z.enum(["totalUsdMicros", "pricePerInspectionUsdMicros"]).optional(),
  sortDirection: inspectionCostUsageAnalysisSortDirectionSchema.optional()
});
var inspectionCostUsageAnalysisTemplateDriversSortQuery = import_zod3.z.object({
  dimension: import_zod3.z.literal("template"),
  sortField: import_zod3.z.enum(["totalUsdMicros", "pricePerInspectionUsdMicros"]).optional(),
  sortDirection: inspectionCostUsageAnalysisSortDirectionSchema.optional()
});
var inspectionCostUsageAnalysisModelVersionDriversSortQuery = import_zod3.z.object({
  dimension: import_zod3.z.literal("model_version"),
  sortField: import_zod3.z.enum(["totalUsdMicros", "pricePerExecutionUsdMicros"]).optional(),
  sortDirection: inspectionCostUsageAnalysisSortDirectionSchema.optional()
});
var inspectionCostUsageAnalysisDriversSortQuery = import_zod3.z.discriminatedUnion(
  "dimension",
  [
    inspectionCostUsageAnalysisCompanyDriversSortQuery,
    inspectionCostUsageAnalysisTemplateDriversSortQuery,
    inspectionCostUsageAnalysisModelVersionDriversSortQuery
  ]
);
var inspectionCostUsageAnalysisDriversSortDtoQuery = import_zod3.z.object({
  dimension: inspectionCostUsageAnalysisDriverDimensionSchema,
  sortField: inspectionCostUsageAnalysisDriverSortFieldSchema.optional(),
  sortDirection: inspectionCostUsageAnalysisSortDirectionSchema.optional()
}).superRefine((query, ctx) => {
  const result = inspectionCostUsageAnalysisDriversSortQuery.safeParse(query);
  if (result.success)
    return;
  result.error.issues.forEach((issue) => ctx.addIssue(issue));
});
var inspectionCostUsageAnalysisDriversRequestQuery = inspectionCostUsageAnalysisBaseQuery.and(inspectionCostUsageAnalysisPaginationQuery).and(inspectionCostUsageAnalysisDriversSortDtoQuery);
var inspectionCostUsageAnalysisCompanyDriverRowSchema = import_zod3.z.object({
  dimension: import_zod3.z.literal("company"),
  companyId: import_zod3.z.string(),
  companyName: import_zod3.z.string(),
  totalUsdMicros: import_zod3.z.number(),
  inspectionCount: import_zod3.z.number(),
  clientCompletedInspectionCount: import_zod3.z.number(),
  pricePerInspectionUsdMicros: import_zod3.z.number().nullable(),
  reportCount: import_zod3.z.number()
});
var inspectionCostUsageAnalysisTemplateDriverRowSchema = import_zod3.z.object({
  dimension: import_zod3.z.literal("template"),
  templateId: import_zod3.z.string(),
  templateName: import_zod3.z.string(),
  companyName: import_zod3.z.string(),
  totalUsdMicros: import_zod3.z.number(),
  inspectionCount: import_zod3.z.number(),
  clientCompletedInspectionCount: import_zod3.z.number(),
  pricePerInspectionUsdMicros: import_zod3.z.number().nullable(),
  reportCount: import_zod3.z.number()
});
var inspectionCostUsageAnalysisModelVersionDriverRowSchema = import_zod3.z.object({
  dimension: import_zod3.z.literal("model_version"),
  modelId: import_zod3.z.string().optional(),
  modelName: import_zod3.z.string().optional(),
  modelVersionId: import_zod3.z.string(),
  modelVersionName: import_zod3.z.string().optional(),
  modelVersionRole: import_zod3.z.string().optional(),
  totalUsdMicros: import_zod3.z.number(),
  pricePerExecutionUsdMicros: import_zod3.z.number(),
  inspectionCount: import_zod3.z.number(),
  reportCount: import_zod3.z.number()
});
var inspectionCostUsageAnalysisDriverRowSchema = import_zod3.z.discriminatedUnion(
  "dimension",
  [
    inspectionCostUsageAnalysisCompanyDriverRowSchema,
    inspectionCostUsageAnalysisTemplateDriverRowSchema,
    inspectionCostUsageAnalysisModelVersionDriverRowSchema
  ]
);
var inspectionCostUsageAnalysisDriversResponseBody = import_zod3.z.object({
  dimension: inspectionCostUsageAnalysisDriverDimensionSchema,
  rows: import_zod3.z.array(inspectionCostUsageAnalysisDriverRowSchema),
  page: import_zod3.z.number(),
  perPage: import_zod3.z.number(),
  hasNextPage: import_zod3.z.boolean()
});
var inspectionCostUsageAnalysisInspectionsRequestQuery = inspectionCostUsageAnalysisBaseQuery.and(
  inspectionCostUsageAnalysisPaginationQuery
);
var inspectionCostUsageAnalysisInspectionRowSchema = import_zod3.z.object({
  _id: import_zod3.z.string(),
  producer: import_zod3.z.object({
    email: import_zod3.z.string().optional(),
    companyName: import_zod3.z.string().optional()
  }),
  status: import_zod3.z.enum(import_ai_constants.inspectionStatus),
  template: import_zod3.z.object({
    name: import_zod3.z.string()
  }),
  result: import_zod3.z.enum(import_ai_constants.inspectionResults).nullish(),
  costUsage: inspectionCostUsageAggregateSchema,
  initDate: costUsageDateSchema.nullish(),
  finishDate: costUsageDateSchema.nullish(),
  createdAt: costUsageDateSchema,
  type: import_zod3.z.enum(import_ai_constants.inspectionTypes)
});
var inspectionCostUsageAnalysisInspectionsResponseBody = import_zod3.z.object({
  rows: import_zod3.z.array(inspectionCostUsageAnalysisInspectionRowSchema),
  page: import_zod3.z.number(),
  perPage: import_zod3.z.number(),
  hasNextPage: import_zod3.z.boolean()
});
var inspectionCostUsagePricingKeyByDeliveryChannel = import_ai_constants.inspectionCostUsageNotificationDeliveryPricingKeyByChannel;

// src/contracts/inspection-sampling.contract.ts
var import_ai_constants2 = require("ai-constants");
var import_zod5 = require("zod");

// src/contracts/pagination.contract.ts
var import_zod4 = require("zod");
var createPaginationResponseSchema = (itemSchema) => import_zod4.z.object({
  items: import_zod4.z.array(itemSchema),
  meta: import_zod4.z.object({
    itemCount: import_zod4.z.number(),
    totalItems: import_zod4.z.number().nullish(),
    itemsPerPage: import_zod4.z.number(),
    totalPages: import_zod4.z.number().nullish(),
    currentPage: import_zod4.z.number()
  })
});

// src/contracts/inspection-sampling.contract.ts
var backofficeReviewStageSchema = import_zod5.z.object({
  status: import_zod5.z.enum(import_ai_constants2.backofficeReviewStageStatuses),
  patchCount: import_zod5.z.number(),
  lastStagedAt: import_zod5.z.coerce.date().nullish(),
  lastUpdatedByUserId: import_zod5.z.string().nullish(),
  lastUpdatedByUserEmail: import_zod5.z.string().nullish(),
  lastCommittedAt: import_zod5.z.coerce.date().nullish(),
  lastCommittedByUserId: import_zod5.z.string().nullish(),
  lastCommittedByUserEmail: import_zod5.z.string().nullish()
});
var backofficeReviewSchema = import_zod5.z.object({
  status: import_zod5.z.enum(import_ai_constants2.backofficeReviewStatuses),
  reviewedAt: import_zod5.z.coerce.date().nullish(),
  reviewedByUserId: import_zod5.z.string().nullish(),
  reviewedByUserEmail: import_zod5.z.string().nullish(),
  hadCriticalInferenceCorrections: import_zod5.z.boolean().nullish(),
  simulatedResult: import_zod5.z.enum(import_ai_constants2.inspectionResults).nullish(),
  stage: backofficeReviewStageSchema.nullish()
});
var listInspectionSamplingRequestQuery = import_zod5.z.object({
  page: import_zod5.z.coerce.number().int().min(1).default(1),
  perPage: import_zod5.z.coerce.number().int().min(1).max(50).default(import_ai_constants2.INSPECTION_SAMPLING_DEFAULT_PER_PAGE),
  from: import_zod5.z.coerce.date().nullish(),
  to: import_zod5.z.coerce.date().nullish(),
  status: import_zod5.z.enum(import_ai_constants2.inspectionSamplingStatuses).default("pending"),
  templatePersistentIds: import_zod5.z.array(import_zod5.z.string()).nullish()
});
var inspectionSamplingListItemSchema = import_zod5.z.object({
  _id: import_zod5.z.string(),
  producer: import_zod5.z.object({
    companyId: import_zod5.z.string().nullish(),
    userId: import_zod5.z.string().nullish(),
    membershipId: import_zod5.z.string().nullish(),
    firstName: import_zod5.z.string().nullish(),
    email: import_zod5.z.string().nullish(),
    companySocietyReason: import_zod5.z.string().nullish()
  }),
  status: import_zod5.z.enum(import_ai_constants2.inspectionStatus),
  template: import_zod5.z.object({
    name: import_zod5.z.string(),
    persistentId: import_zod5.z.string().nullish()
  }),
  result: import_zod5.z.enum(import_ai_constants2.inspectionResults).nullish(),
  createdAt: import_zod5.z.coerce.date(),
  type: import_zod5.z.enum(import_ai_constants2.inspectionTypes),
  backofficeReview: backofficeReviewSchema.nullish()
});
var listInspectionSamplingResponseBody = createPaginationResponseSchema(inspectionSamplingListItemSchema);
var reviewInspectionSamplingResponseBody = import_zod5.z.object({
  reviewed: import_zod5.z.literal(true),
  hadCriticalInferenceCorrections: import_zod5.z.boolean(),
  simulatedResult: import_zod5.z.enum(import_ai_constants2.inspectionResults).nullish(),
  currentResult: import_zod5.z.enum(import_ai_constants2.inspectionResults).nullish()
});
var rollbackInspectionSamplingReviewResponseBody = import_zod5.z.object({
  reviewed: import_zod5.z.literal(false)
});
var commitStagedInferenceResultsResponseBody = import_zod5.z.object({
  committed: import_zod5.z.literal(true),
  result: import_zod5.z.enum(import_ai_constants2.inspectionResults).nullish()
});
var retrieveSamplingAccuracyMetricsRequestQuery = import_zod5.z.object({
  from: import_zod5.z.coerce.date().nullish(),
  to: import_zod5.z.coerce.date().nullish(),
  templatePersistentIds: import_zod5.z.array(import_zod5.z.string()).nullish()
});
var samplingAccuracyMetricSchema = import_zod5.z.object({
  totalReviewed: import_zod5.z.number(),
  withCriticalCorrections: import_zod5.z.number(),
  accuracyPercentage: import_zod5.z.number()
});
var samplingAccuracyTemplateMetricSchema = samplingAccuracyMetricSchema.extend({
  templatePersistentId: import_zod5.z.string().nullish(),
  templateName: import_zod5.z.string().nullish()
});
var retrieveSamplingAccuracyMetricsResponseBody = import_zod5.z.object({
  overall: samplingAccuracyMetricSchema,
  templates: import_zod5.z.array(samplingAccuracyTemplateMetricSchema)
});

// src/contracts/external-environment-sync.contract.ts
var import_zod6 = require("zod");
var EXTERNAL_ENVIRONMENT_SYNC_CONTRACT_VERSION = "v1";
var externalEnvironmentSyncContractVersions = [
  EXTERNAL_ENVIRONMENT_SYNC_CONTRACT_VERSION
];
var EXTERNAL_ENVIRONMENT_SYNC_API_KEY_HEADER = "x-external-environment-key";
var EXTERNAL_ENVIRONMENT_SYNC_MAX_BATCH_SIZE = 100;
var externalEnvironmentSyncInspectionStatuses = [
  "created",
  "started",
  "blocked",
  "processing",
  "completed"
];
var externalEnvironmentSyncInspectionResults = [
  "approved",
  "disapproved",
  "error"
];
var externalEnvironmentSyncAssetTypes = [
  "image",
  "input",
  "document"
];
var externalEnvironmentSyncValidationResults = [
  "approved",
  "disapproved"
];
var externalEnvironmentDataClasses = [
  "asset_values",
  "inference_values",
  "validation_reasoning"
];
var externalEnvironmentDataSharingModes = [
  "shared",
  "withheld"
];
var EXTERNAL_ENVIRONMENT_DEFAULT_DATA_SHARING_MODE = "withheld";
var externalEnvironmentSyncInferenceStatuses = [
  "processed",
  "failed"
];
var externalEnvironmentSyncRejectionReasons = [
  "inspection_id_conflict",
  "company_not_allowed",
  "template_not_found",
  "template_not_allowed",
  "data_class_not_shared",
  "inspection_not_owned",
  "model_version_not_registered",
  "model_version_pricing_unavailable",
  "model_version_conflict",
  "implemented_model_version_not_found",
  "detail_url_not_allowed"
];
var externalEnvironmentSyncRejectionRetryability = {
  inspection_id_conflict: false,
  company_not_allowed: false,
  template_not_found: false,
  template_not_allowed: false,
  data_class_not_shared: false,
  inspection_not_owned: false,
  model_version_not_registered: true,
  model_version_pricing_unavailable: false,
  model_version_conflict: false,
  implemented_model_version_not_found: false,
  detail_url_not_allowed: false
};
var externalEnvironmentPipelineCostKinds = [
  "amount",
  "pricing_multiplier",
  "model_version_default"
];
var externalEnvironmentCostUsageTokenDirections = [
  "input",
  "output",
  "cached_input",
  "reasoning",
  "tool_input"
];
var externalEnvironmentSyncJsonValueSchema = import_zod6.z.lazy(
  () => import_zod6.z.union([
    import_zod6.z.string(),
    import_zod6.z.number(),
    import_zod6.z.boolean(),
    import_zod6.z.null(),
    import_zod6.z.array(externalEnvironmentSyncJsonValueSchema),
    import_zod6.z.record(externalEnvironmentSyncJsonValueSchema)
  ])
);
var externalEnvironmentSyncJsonSchemaDocumentSchema = import_zod6.z.record(
  externalEnvironmentSyncJsonValueSchema
);
var externalEnvironmentSyncObjectIdSchema = import_zod6.z.string().regex(/^[a-f\d]{24}$/i, "Must be a 24 hex characters ObjectId");
var externalEnvironmentSyncDateTimeSchema = import_zod6.z.string().datetime({ offset: true });
var externalEnvironmentSyncKeySchema = import_zod6.z.string().regex(
  /^[a-z0-9][a-z0-9_.:-]{0,127}$/,
  "Must be a lowercase key up to 128 characters"
);
var inspectionAssetContentAvailabilities = [
  "available",
  "withheld"
];
var externalEnvironmentSyncWithheldContentSchema = import_zod6.z.object({
  availability: import_zod6.z.literal("withheld")
}).strict();
var externalEnvironmentSyncAssetContentSchema = import_zod6.z.discriminatedUnion(
  "availability",
  [
    import_zod6.z.object({
      availability: import_zod6.z.literal("available"),
      value: externalEnvironmentSyncJsonValueSchema
    }).strict(),
    externalEnvironmentSyncWithheldContentSchema
  ]
);
var externalEnvironmentSyncInferenceContentSchema = import_zod6.z.discriminatedUnion("availability", [
  import_zod6.z.object({
    availability: import_zod6.z.literal("available"),
    value: externalEnvironmentSyncJsonValueSchema
  }).strict(),
  externalEnvironmentSyncWithheldContentSchema
]);
var externalEnvironmentSyncValidationReasoningSchema = import_zod6.z.discriminatedUnion("availability", [
  import_zod6.z.object({
    availability: import_zod6.z.literal("available"),
    reasoning: import_zod6.z.string()
  }).strict(),
  externalEnvironmentSyncWithheldContentSchema
]);
var externalEnvironmentSyncAssetBindingSchema = import_zod6.z.object({
  type: import_zod6.z.enum(externalEnvironmentSyncAssetTypes),
  identifier: import_zod6.z.string().min(1),
  instanceId: import_zod6.z.string().min(1).optional()
}).strict();
var syncInspectionAssetV1Schema = externalEnvironmentSyncAssetBindingSchema.extend({
  label: import_zod6.z.string().min(1).optional(),
  content: externalEnvironmentSyncAssetContentSchema
}).strict();
var syncInspectionInferenceV1Schema = import_zod6.z.object({
  identifier: import_zod6.z.string().min(1),
  title: import_zod6.z.string().min(1).optional(),
  bindings: import_zod6.z.array(externalEnvironmentSyncAssetBindingSchema),
  status: import_zod6.z.enum(externalEnvironmentSyncInferenceStatuses),
  content: externalEnvironmentSyncInferenceContentSchema
}).strict();
var syncInspectionValidationV1Schema = import_zod6.z.object({
  identifier: import_zod6.z.string().min(1),
  title: import_zod6.z.string().min(1).optional(),
  bindings: import_zod6.z.array(externalEnvironmentSyncAssetBindingSchema),
  result: import_zod6.z.enum(externalEnvironmentSyncValidationResults),
  reasoning: externalEnvironmentSyncValidationReasoningSchema
}).strict();
var EXTERNAL_ENVIRONMENT_SYNC_DETAIL_URL_MAX_LENGTH = 2048;
var externalEnvironmentSyncDetailUrlSchema = import_zod6.z.string().max(EXTERNAL_ENVIRONMENT_SYNC_DETAIL_URL_MAX_LENGTH).url().startsWith("https://", "Must be an https URL");
var syncInspectionV1Schema = import_zod6.z.object({
  inspectionId: externalEnvironmentSyncObjectIdSchema,
  sourceUpdatedAt: externalEnvironmentSyncDateTimeSchema,
  companyId: externalEnvironmentSyncObjectIdSchema,
  templateId: externalEnvironmentSyncObjectIdSchema,
  templateRevision: import_zod6.z.object({
    sourceUpdatedAt: externalEnvironmentSyncDateTimeSchema.optional(),
    versionHash: import_zod6.z.string().min(1).optional()
  }).strict().optional(),
  status: import_zod6.z.enum(externalEnvironmentSyncInspectionStatuses),
  result: import_zod6.z.enum(externalEnvironmentSyncInspectionResults).optional(),
  detailUrl: externalEnvironmentSyncDetailUrlSchema.optional(),
  testing: import_zod6.z.boolean(),
  createdAt: externalEnvironmentSyncDateTimeSchema,
  startedAt: externalEnvironmentSyncDateTimeSchema.optional(),
  finishedAt: externalEnvironmentSyncDateTimeSchema.optional(),
  assets: import_zod6.z.array(syncInspectionAssetV1Schema),
  inferences: import_zod6.z.array(syncInspectionInferenceV1Schema),
  validations: import_zod6.z.array(syncInspectionValidationV1Schema)
}).strict();
var syncInspectionsBatchRequestBodySchema = import_zod6.z.object({
  inspections: import_zod6.z.array(syncInspectionV1Schema).min(1).max(EXTERNAL_ENVIRONMENT_SYNC_MAX_BATCH_SIZE)
}).strict();
var syncModelVersionReferenceV1Schema = import_zod6.z.discriminatedUnion("kind", [
  import_zod6.z.object({
    kind: import_zod6.z.literal("registered"),
    modelKey: externalEnvironmentSyncKeySchema,
    versionKey: externalEnvironmentSyncKeySchema
  }).strict(),
  import_zod6.z.object({
    kind: import_zod6.z.literal("autoinspector"),
    modelVersionId: externalEnvironmentSyncObjectIdSchema
  }).strict()
]);
var syncPipelineCostV1Schema = import_zod6.z.discriminatedUnion("kind", [
  import_zod6.z.object({
    kind: import_zod6.z.literal("amount"),
    amountUsdMicros: import_zod6.z.number().int().nonnegative()
  }).strict(),
  import_zod6.z.object({
    kind: import_zod6.z.literal("pricing_multiplier"),
    multiplier: import_zod6.z.number().nonnegative()
  }).strict(),
  import_zod6.z.object({
    kind: import_zod6.z.literal("model_version_default")
  }).strict()
]);
var syncCostUsageUnitV1Schema = import_zod6.z.discriminatedUnion("unit", [
  import_zod6.z.object({
    unit: import_zod6.z.literal("tokens"),
    direction: import_zod6.z.enum(externalEnvironmentCostUsageTokenDirections),
    quantity: import_zod6.z.number().int().nonnegative(),
    provider: import_zod6.z.string().min(1),
    model: import_zod6.z.string().min(1)
  }).strict(),
  import_zod6.z.object({
    unit: import_zod6.z.literal("requests"),
    quantity: import_zod6.z.number().int().nonnegative(),
    provider: import_zod6.z.string().min(1),
    operation: import_zod6.z.string().min(1)
  }).strict()
]);
var syncCostUsageReportBindingV1Schema = import_zod6.z.discriminatedUnion("kind", [
  import_zod6.z.object({
    kind: import_zod6.z.literal("inspection"),
    inspectionId: externalEnvironmentSyncObjectIdSchema,
    assets: import_zod6.z.array(externalEnvironmentSyncAssetBindingSchema)
  }).strict()
]);
var syncCostUsageReportChargeV1Schema = import_zod6.z.discriminatedUnion(
  "category",
  [
    import_zod6.z.object({
      category: import_zod6.z.literal("inference"),
      modelVersion: syncModelVersionReferenceV1Schema,
      cost: syncPipelineCostV1Schema,
      usage: import_zod6.z.array(syncCostUsageUnitV1Schema)
    }).strict()
  ]
);
var syncCostUsageReportV1Schema = import_zod6.z.object({
  sourceReportId: import_zod6.z.string().min(1).max(512),
  sourceUpdatedAt: externalEnvironmentSyncDateTimeSchema,
  occurredAt: externalEnvironmentSyncDateTimeSchema,
  binding: syncCostUsageReportBindingV1Schema,
  charge: syncCostUsageReportChargeV1Schema
}).strict();
var syncCostUsageReportsBatchRequestBodySchema = import_zod6.z.object({
  costUsageReports: import_zod6.z.array(syncCostUsageReportV1Schema).min(1).max(EXTERNAL_ENVIRONMENT_SYNC_MAX_BATCH_SIZE)
}).strict();
var syncImplementedModelVersionReferenceV1Schema = import_zod6.z.discriminatedUnion("kind", [
  import_zod6.z.object({
    kind: import_zod6.z.literal("model_version_id"),
    modelVersionId: externalEnvironmentSyncObjectIdSchema
  }).strict(),
  import_zod6.z.object({
    kind: import_zod6.z.literal("model_version_external_id"),
    externalId: import_zod6.z.string().min(1)
  }).strict()
]);
var syncModelVersionV1Schema = import_zod6.z.object({
  versionKey: externalEnvironmentSyncKeySchema,
  input: externalEnvironmentSyncJsonSchemaDocumentSchema,
  output: externalEnvironmentSyncJsonSchemaDocumentSchema,
  parametersSchema: externalEnvironmentSyncJsonSchemaDocumentSchema.optional(),
  implements: syncImplementedModelVersionReferenceV1Schema.optional(),
  costUsage: import_zod6.z.object({
    perRunUsdMicros: import_zod6.z.number().int().nonnegative()
  }).strict().optional()
}).strict();
var syncModelV1Schema = import_zod6.z.object({
  modelKey: externalEnvironmentSyncKeySchema,
  name: import_zod6.z.string().min(1).max(200),
  description: import_zod6.z.string().max(2e3),
  version: syncModelVersionV1Schema
}).strict();
var syncModelsBatchRequestBodySchema = import_zod6.z.object({
  models: import_zod6.z.array(syncModelV1Schema).min(1).max(EXTERNAL_ENVIRONMENT_SYNC_MAX_BATCH_SIZE)
}).strict();
var syncInspectionParamsSchema = import_zod6.z.object({
  inspectionId: externalEnvironmentSyncObjectIdSchema
}).strict();
var syncCostUsageReportParamsSchema = import_zod6.z.object({
  sourceReportId: import_zod6.z.string().min(1).max(512)
}).strict();
var externalEnvironmentSyncAcceptedItemStatuses = [
  "created",
  "updated",
  "unchanged",
  "ignored_stale",
  "pending_inspection",
  "deleted"
];
var syncItemResultV1Schema = import_zod6.z.discriminatedUnion("status", [
  import_zod6.z.object({
    id: import_zod6.z.string(),
    status: import_zod6.z.enum(externalEnvironmentSyncAcceptedItemStatuses)
  }).strict(),
  import_zod6.z.object({
    id: import_zod6.z.string(),
    status: import_zod6.z.literal("rejected"),
    reason: import_zod6.z.enum(externalEnvironmentSyncRejectionReasons),
    retryable: import_zod6.z.boolean()
  }).strict()
]);
var syncBatchResponseBodySchema = import_zod6.z.object({
  results: import_zod6.z.array(syncItemResultV1Schema)
}).strict();
var externalEnvironmentDataSharingModeSchema = import_zod6.z.enum(
  externalEnvironmentDataSharingModes
);
var externalEnvironmentDataSharingSchema = import_zod6.z.object({
  asset_values: externalEnvironmentDataSharingModeSchema,
  inference_values: externalEnvironmentDataSharingModeSchema,
  validation_reasoning: externalEnvironmentDataSharingModeSchema
}).strict();
var retrieveSyncEnvironmentResponseBodySchema = import_zod6.z.object({
  environmentId: import_zod6.z.string(),
  key: import_zod6.z.string(),
  displayName: import_zod6.z.string(),
  contractVersion: import_zod6.z.literal(EXTERNAL_ENVIRONMENT_SYNC_CONTRACT_VERSION),
  allowedCompanyIds: import_zod6.z.array(import_zod6.z.string()),
  allowedTemplateIds: import_zod6.z.array(import_zod6.z.string()),
  dataSharing: externalEnvironmentDataSharingSchema
}).strict();
var syncCheckpointSchema = import_zod6.z.object({
  lastSourceUpdatedAt: import_zod6.z.string().nullable(),
  count: import_zod6.z.number().int().nonnegative()
}).strict();
var retrieveSyncCheckpointResponseBodySchema = import_zod6.z.object({
  inspections: syncCheckpointSchema,
  costUsageReports: syncCheckpointSchema
}).strict();

// src/contracts/office.contracts.ts
var inspectionOriginSummarySchema = import_zod7.z.object({
  kind: import_zod7.z.enum(import_ai_constants3.inspectionOriginKinds),
  environmentId: import_zod7.z.string(),
  environmentKey: import_zod7.z.string(),
  environmentDisplayName: import_zod7.z.string(),
  sourceUpdatedAt: import_zod7.z.union([import_zod7.z.string(), import_zod7.z.date()]),
  syncedAt: import_zod7.z.union([import_zod7.z.string(), import_zod7.z.date()]),
  detailUrl: import_zod7.z.string().nullish()
});
var listOfficeInspectionsRequestQuery = dataTableRequestQuerySchema.extend({});
var officeInspectionListItemSchema = import_zod7.z.object({
  _id: import_zod7.z.string(),
  producer: import_zod7.z.object({
    companyId: import_zod7.z.string().nullish(),
    userId: import_zod7.z.string().nullish(),
    membershipId: import_zod7.z.string().nullish(),
    firstName: import_zod7.z.string().nullish(),
    email: import_zod7.z.string().nullish(),
    companySocietyReason: import_zod7.z.string().nullish()
  }),
  status: import_zod7.z.enum(import_ai_constants3.inspectionStatus),
  template: import_zod7.z.object({
    name: import_zod7.z.string()
  }),
  veredict: import_zod7.z.boolean().nullish(),
  result: import_zod7.z.enum(import_ai_constants3.inspectionResults).nullish(),
  backofficeReview: backofficeReviewSchema.nullish(),
  costUsage: inspectionCostUsageAggregateSchema.nullish(),
  origin: inspectionOriginSummarySchema.nullish(),
  initDate: import_zod7.z.union([import_zod7.z.string(), import_zod7.z.null(), import_zod7.z.date()]),
  finishDate: import_zod7.z.union([import_zod7.z.string(), import_zod7.z.null(), import_zod7.z.date()]),
  createdAt: import_zod7.z.union([import_zod7.z.string(), import_zod7.z.date()]),
  type: import_zod7.z.enum(import_ai_constants3.inspectionTypes)
});
var listOfficeInspectionsResponseBody = createPaginationResponseSchema(
  officeInspectionListItemSchema
);
var retrieveInspectionSummaryRequestParams = import_zod7.z.object({
  inspectionId: import_zod7.z.string().min(1, "Inspection ID is required")
});
var retrieveOfficeInspectionDetailParamsSchema = import_zod7.z.object({
  id: import_zod7.z.string().min(1, "Inspection ID is required")
});
var officeInspectionDetailAssetSchema = externalEnvironmentSyncAssetBindingSchema.extend({
  label: import_zod7.z.string(),
  content: externalEnvironmentSyncAssetContentSchema
});
var officeInspectionDetailInferenceSchema = import_zod7.z.object({
  identifier: import_zod7.z.string(),
  title: import_zod7.z.string(),
  bindings: import_zod7.z.array(externalEnvironmentSyncAssetBindingSchema),
  status: import_zod7.z.enum(externalEnvironmentSyncInferenceStatuses),
  content: externalEnvironmentSyncInferenceContentSchema
});
var officeInspectionDetailValidationSchema = import_zod7.z.object({
  identifier: import_zod7.z.string(),
  title: import_zod7.z.string(),
  bindings: import_zod7.z.array(externalEnvironmentSyncAssetBindingSchema),
  result: import_zod7.z.enum(externalEnvironmentSyncValidationResults),
  reasoning: externalEnvironmentSyncValidationReasoningSchema.nullable()
});
var officeInspectionDetailBaseSchema = import_zod7.z.object({
  inspectionId: import_zod7.z.string(),
  status: import_zod7.z.enum(import_ai_constants3.inspectionStatus),
  result: import_zod7.z.enum(import_ai_constants3.inspectionResults).nullish(),
  testing: import_zod7.z.boolean(),
  createdAt: import_zod7.z.union([import_zod7.z.string(), import_zod7.z.date()]),
  startedAt: import_zod7.z.union([import_zod7.z.string(), import_zod7.z.date()]).nullish(),
  finishedAt: import_zod7.z.union([import_zod7.z.string(), import_zod7.z.date()]).nullish(),
  companyId: import_zod7.z.string(),
  template: import_zod7.z.object({
    id: import_zod7.z.string(),
    name: import_zod7.z.string(),
    type: import_zod7.z.enum(import_ai_constants3.inspectionTypes)
  }),
  assets: import_zod7.z.array(officeInspectionDetailAssetSchema),
  inferences: import_zod7.z.array(officeInspectionDetailInferenceSchema),
  validations: import_zod7.z.array(officeInspectionDetailValidationSchema),
  costUsage: inspectionCostUsageAggregateSchema.nullish()
});
var retrieveOfficeInspectionDetailResponseBodySchema = import_zod7.z.discriminatedUnion("source", [
  officeInspectionDetailBaseSchema.extend({
    source: import_zod7.z.literal("autoinspector")
  }),
  officeInspectionDetailBaseSchema.extend({
    source: import_zod7.z.literal("external_environment"),
    origin: inspectionOriginSummarySchema
  })
]);

// src/contracts/inspection.contract.ts
var import_zod8 = require("zod");
var import_ai_constants4 = require("ai-constants");
var inspectionDetailDamagesResponseBody = import_zod8.z.object({
  damages: import_zod8.z.object({
    grouped: import_zod8.z.array(
      import_zod8.z.object({
        image: import_zod8.z.object({
          _id: import_zod8.z.any(),
          templateImageIdentifier: import_zod8.z.string(),
          label: import_zod8.z.string()
        }),
        damages: import_zod8.z.array(
          import_zod8.z.object({
            part: import_zod8.z.string(),
            severity: import_zod8.z.string(),
            damage: import_zod8.z.string()
          })
        )
      })
    ),
    declared: import_zod8.z.boolean(),
    inferred: import_zod8.z.boolean()
  })
});
var damageCostAnalysisStatusSchema = import_zod8.z.enum([
  "queued",
  "working",
  "completed",
  "failed"
]);
var startDamageCostAnalysisRequestParams = import_zod8.z.object({
  inspectionId: import_zod8.z.string()
});
var damageCostAnalysisJobSchema = import_zod8.z.object({
  _id: import_zod8.z.string(),
  inspectionId: import_zod8.z.string(),
  status: damageCostAnalysisStatusSchema,
  reasoning: import_zod8.z.string().nullish(),
  report: import_zod8.z.string().nullish(),
  errorMessage: import_zod8.z.string().nullish(),
  modelId: import_zod8.z.string().nullish(),
  startedAt: import_zod8.z.string().nullish(),
  completedAt: import_zod8.z.string().nullish(),
  createdAt: import_zod8.z.string(),
  updatedAt: import_zod8.z.string()
});
var startDamageCostAnalysisResponseBody = import_zod8.z.object({
  job: damageCostAnalysisJobSchema
});
var retrieveDamageCostAnalysisRequestParams = import_zod8.z.object({
  inspectionId: import_zod8.z.string()
});
var retrieveDamageCostAnalysisResponseBody = import_zod8.z.object({
  job: damageCostAnalysisJobSchema.nullable()
});

// src/contracts/model.contract.ts
var import_zod9 = require("zod");
var modelOperationalDiagnosticsMetadataSchema = import_zod9.z.object({
  key: import_zod9.z.string().min(1),
  label: import_zod9.z.string().min(1),
  description: import_zod9.z.string().min(1).optional()
});
var modelOperationalDiagnosticsStatusSchema = import_zod9.z.enum([
  "healthy",
  "degraded",
  "unavailable"
]);
var modelOperationalDiagnosticsIndicatorBaseSchema = import_zod9.z.object({
  key: import_zod9.z.string(),
  label: import_zod9.z.string()
});
var modelOperationalDiagnosticsIndicatorSchema = import_zod9.z.discriminatedUnion(
  "type",
  [
    modelOperationalDiagnosticsIndicatorBaseSchema.extend({
      type: import_zod9.z.literal("text"),
      value: import_zod9.z.string()
    }),
    modelOperationalDiagnosticsIndicatorBaseSchema.extend({
      type: import_zod9.z.literal("numeric"),
      value: import_zod9.z.number()
    }),
    modelOperationalDiagnosticsIndicatorBaseSchema.extend({
      type: import_zod9.z.literal("ratio"),
      current: import_zod9.z.number(),
      total: import_zod9.z.number()
    })
  ]
);
var modelOperationalDiagnosticsResponseBodySchema = import_zod9.z.object({
  status: modelOperationalDiagnosticsStatusSchema,
  checkedAt: import_zod9.z.string().datetime(),
  message: import_zod9.z.string().optional(),
  indicators: import_zod9.z.array(modelOperationalDiagnosticsIndicatorSchema)
});

// src/contracts/inference-changelog.contract.ts
var import_ai_constants5 = require("ai-constants");
var import_zod10 = require("zod");
var jsonPatchSchema = import_zod10.z.object({
  op: import_zod10.z.enum(import_ai_constants5.jsonPatchOperations),
  path: import_zod10.z.string(),
  displayPath: import_zod10.z.string(),
  oldValue: import_zod10.z.any(),
  value: import_zod10.z.any(),
  changeReason: import_zod10.z.string().nullish()
});
var actionSources = ["api", "user"];
var inferenceChangelogAssetSchema = import_zod10.z.object({
  type: import_zod10.z.enum(import_ai_constants5.processableAssetTypes),
  identifier: import_zod10.z.string()
});
var inferenceChangelogSchema = import_zod10.z.object({
  _id: import_zod10.z.any().nullish(),
  modelVersionId: import_zod10.z.any(),
  modelId: import_zod10.z.any(),
  assets: import_zod10.z.array(inferenceChangelogAssetSchema),
  changedFromAssetType: import_zod10.z.enum(import_ai_constants5.processableAssetTypes),
  changedFromAssetIdentifier: import_zod10.z.string(),
  inspectionId: import_zod10.z.any(),
  patches: import_zod10.z.array(jsonPatchSchema),
  updatedByUserEmail: import_zod10.z.string().nullish(),
  updatedByUserFullName: import_zod10.z.string().nullish(),
  assetInstanceIds: import_zod10.z.array(import_zod10.z.any()).nullish(),
  updatedByUsername: import_zod10.z.string().nullish(),
  updatedByUserId: import_zod10.z.any().nullish(),
  source: import_zod10.z.enum(actionSources).optional(),
  origin: import_zod10.z.enum(import_ai_constants5.inferenceChangelogOrigins).nullish(),
  committedAt: import_zod10.z.coerce.date().nullish(),
  createdAt: import_zod10.z.coerce.date().nullish(),
  validationReference: import_zod10.z.object({
    templateValidationVersionId: import_zod10.z.any(),
    name: import_zod10.z.string(),
    valid: import_zod10.z.boolean()
  }).nullish()
});
var listInferenceChangelogsResponseBodySchema = import_zod10.z.object({
  changelogs: import_zod10.z.array(inferenceChangelogSchema)
});
var inspectionChangelogStatusFilters = [
  "uncommitted",
  "committed",
  "all"
];
var listInspectionChangelogsRequestQuery = import_zod10.z.object({
  status: import_zod10.z.enum(inspectionChangelogStatusFilters).optional()
});
var listInspectionChangelogsResponseBodySchema = import_zod10.z.object({
  changelogs: import_zod10.z.array(inferenceChangelogSchema)
});
var mongoObjectIdStringSchema = import_zod10.z.string().regex(/^[a-f\d]{24}$/i);
var isMongoObjectIdString = (value) => mongoObjectIdStringSchema.safeParse(value).success;
var listAssetInferenceChangelogsRequestQuery = import_zod10.z.object({
  assetType: import_zod10.z.enum(import_ai_constants5.processableAssetTypes),
  assetIdentifier: import_zod10.z.string(),
  assetInstanceId: mongoObjectIdStringSchema.nullish()
});

// src/contracts/inspection-annotation.contract.ts
var import_ai_constants6 = require("ai-constants");
var import_zod11 = require("zod");
var inspectionAnnotationAssetReferenceSchema = import_zod11.z.object({
  assetType: import_zod11.z.string().nullish(),
  identifier: import_zod11.z.string(),
  instanceId: import_zod11.z.string().nullish()
});
var assetAnnotationReferenceSchema = import_zod11.z.object({
  type: import_zod11.z.literal("asset"),
  assetType: import_zod11.z.string(),
  identifier: import_zod11.z.string(),
  instanceId: import_zod11.z.string().nullish(),
  label: import_zod11.z.string()
});
var inferenceAnnotationReferenceSchema = import_zod11.z.object({
  type: import_zod11.z.literal("inference"),
  label: import_zod11.z.string(),
  jsonPath: import_zod11.z.string().nullish(),
  inferenceResultId: import_zod11.z.string().nullish(),
  asset: inspectionAnnotationAssetReferenceSchema.nullish()
});
var validationAnnotationReferenceSchema = import_zod11.z.object({
  type: import_zod11.z.literal("validation"),
  name: import_zod11.z.string(),
  correlationId: import_zod11.z.string()
});
var changelogPatchAnnotationReferenceSchema = import_zod11.z.object({
  type: import_zod11.z.literal("changelog-patch"),
  changelogId: import_zod11.z.string(),
  patchIndex: import_zod11.z.number().int().min(0),
  label: import_zod11.z.string()
});
var damagesTableAnnotationReferenceSchema = import_zod11.z.object({
  type: import_zod11.z.literal("damages-table"),
  label: import_zod11.z.string()
});
var damageAnnotationReferenceSchema = import_zod11.z.object({
  type: import_zod11.z.literal("damage"),
  part: import_zod11.z.string(),
  damage: import_zod11.z.string(),
  severity: import_zod11.z.string().nullish(),
  imageId: import_zod11.z.string().nullish(),
  label: import_zod11.z.string()
});
var userAnnotationReferenceSchema = import_zod11.z.object({
  type: import_zod11.z.literal("user"),
  userId: import_zod11.z.string(),
  email: import_zod11.z.string(),
  label: import_zod11.z.string()
});
var inspectionAnnotationTargetSchema = import_zod11.z.discriminatedUnion("type", [
  assetAnnotationReferenceSchema,
  inferenceAnnotationReferenceSchema,
  validationAnnotationReferenceSchema,
  changelogPatchAnnotationReferenceSchema,
  damagesTableAnnotationReferenceSchema,
  damageAnnotationReferenceSchema
]);
var inspectionAnnotationMentionSchema = import_zod11.z.discriminatedUnion("type", [
  assetAnnotationReferenceSchema,
  inferenceAnnotationReferenceSchema,
  validationAnnotationReferenceSchema,
  changelogPatchAnnotationReferenceSchema,
  damagesTableAnnotationReferenceSchema,
  damageAnnotationReferenceSchema,
  userAnnotationReferenceSchema
]);
var inspectionAnnotationAttachmentSchema = import_zod11.z.object({
  key: import_zod11.z.string(),
  url: import_zod11.z.string().nullish()
});
var inspectionAnnotationSchema = import_zod11.z.object({
  _id: import_zod11.z.string(),
  inspectionId: import_zod11.z.string(),
  message: import_zod11.z.string(),
  mentions: import_zod11.z.array(inspectionAnnotationMentionSchema),
  target: inspectionAnnotationTargetSchema.nullish(),
  parentAnnotationId: import_zod11.z.string().nullish(),
  attachments: import_zod11.z.array(inspectionAnnotationAttachmentSchema).nullish(),
  createdByUserId: import_zod11.z.string().nullish(),
  createdByUserEmail: import_zod11.z.string().nullish(),
  createdAt: import_zod11.z.coerce.date()
});
var createInspectionAnnotationRequestBody = import_zod11.z.object({
  message: import_zod11.z.string().min(1).max(import_ai_constants6.INSPECTION_ANNOTATION_MESSAGE_MAX_LENGTH),
  mentions: import_zod11.z.array(inspectionAnnotationMentionSchema).max(import_ai_constants6.INSPECTION_ANNOTATION_MENTIONS_MAX_COUNT).default([]),
  target: inspectionAnnotationTargetSchema.nullish(),
  parentAnnotationId: import_zod11.z.string().nullish(),
  attachments: import_zod11.z.array(
    import_zod11.z.object({
      key: import_zod11.z.string()
    })
  ).max(import_ai_constants6.INSPECTION_ANNOTATION_ATTACHMENTS_MAX_COUNT).default([])
});
var createInspectionAnnotationResponseBody = import_zod11.z.object({
  annotation: inspectionAnnotationSchema
});
var listInspectionAnnotationsResponseBody = import_zod11.z.object({
  annotations: import_zod11.z.array(inspectionAnnotationSchema)
});
var deleteInspectionAnnotationResponseBody = import_zod11.z.object({
  deleted: import_zod11.z.literal(true)
});
var presignInspectionAnnotationAttachmentRequestBody = import_zod11.z.object({
  filename: import_zod11.z.string().min(1).max(200),
  contentType: import_zod11.z.string().regex(/^image\//)
});
var presignInspectionAnnotationAttachmentResponseBody = import_zod11.z.object({
  key: import_zod11.z.string(),
  uploadUrl: import_zod11.z.string()
});

// src/contracts/office-notification.contract.ts
var import_ai_constants7 = require("ai-constants");
var import_zod12 = require("zod");
var officeNotificationMetadataSchema = import_zod12.z.object({
  inspectionId: import_zod12.z.string(),
  inspectionType: import_zod12.z.string().nullish(),
  annotationId: import_zod12.z.string()
});
var officeNotificationSchema = import_zod12.z.object({
  _id: import_zod12.z.string(),
  event: import_zod12.z.enum(import_ai_constants7.officeNotificationEvents),
  message: import_zod12.z.string(),
  metadata: officeNotificationMetadataSchema,
  readAt: import_zod12.z.coerce.date().nullish(),
  createdByUserEmail: import_zod12.z.string().nullish(),
  createdAt: import_zod12.z.coerce.date()
});
var officeNotificationListStatuses = ["all", "unread", "read"];
var listOfficeNotificationsRequestQuery = import_zod12.z.object({
  status: import_zod12.z.enum(officeNotificationListStatuses).default("all")
});
var listOfficeNotificationsResponseBody = import_zod12.z.object({
  notifications: import_zod12.z.array(officeNotificationSchema),
  unreadCount: import_zod12.z.number()
});
var readOfficeNotificationResponseBody = import_zod12.z.object({
  read: import_zod12.z.literal(true)
});

// src/contracts/external-environment-sync.contract-alignment.ts
var externalEnvironmentSyncContractAlignment = {
  inspectionStatuses: true,
  inspectionResults: true,
  assetTypes: true
};

// src/contracts/inspection-detail-image-error.contract.ts
var import_zod13 = require("zod");
var inspectionDetailImageErrorEvents = [
  "image_load_error",
  "refresh_error"
];
var inspectionDetailImageRenderContexts = [
  "thumbnail",
  "dialog",
  "inline"
];
var inspectionDetailImageUrlExpiryStates = [
  "expired",
  "not_expired",
  "missing_expires",
  "invalid_expires",
  "unparseable_url"
];
var inspectionDetailImageRedactedQueryParamKinds = [
  "cloudfront_signature",
  "cloudfront_key_pair_id",
  "cloudfront_policy",
  "access_token",
  "auth_token",
  "aws_credential",
  "other_sensitive"
];
var inspectionDetailImageSupportedFileExtensions = [
  "jpg",
  "jpeg",
  "png",
  "webp"
];
var inspectionDetailKnownNonImageFileExtensions = [
  "avi",
  "csv",
  "doc",
  "docx",
  "json",
  "mkv",
  "mov",
  "mp4",
  "pdf",
  "ppt",
  "pptx",
  "svg",
  "txt",
  "webm",
  "xls",
  "xlsx"
];
var inspectionDetailGenericBinaryMimeTypes = [
  "application/octet-stream",
  "binary/octet-stream"
];
var resolveMimeTypeSource = (mimeType) => {
  if (!mimeType)
    return "unknown";
  const normalizedMimeType = mimeType.toLowerCase().split(";")[0].trim();
  if (normalizedMimeType.startsWith("image/"))
    return "image";
  if (inspectionDetailGenericBinaryMimeTypes.some(
    (genericMimeType) => genericMimeType === normalizedMimeType
  ))
    return "unknown";
  return "non_image";
};
var resolveDataUrlMimeType = (source) => {
  const match = /^data:([^;,]+)/i.exec(source);
  return match == null ? void 0 : match[1];
};
var resolveInspectionDetailImageSourceExtension = (source) => {
  const sanitizedSource = source.split("?")[0].split("#")[0];
  const filename = sanitizedSource.split("/").pop();
  const extension = (filename == null ? void 0 : filename.includes(".")) ? filename.split(".").pop() : "";
  const normalizedExtension = extension == null ? void 0 : extension.toLowerCase();
  if (!(normalizedExtension == null ? void 0 : normalizedExtension.match(/^[a-z0-9]{1,32}$/)))
    return void 0;
  return normalizedExtension;
};
var resolveFileExtensionSource = (source) => {
  if (!source)
    return "unknown";
  const extension = resolveInspectionDetailImageSourceExtension(source);
  if (!extension)
    return "unknown";
  if (inspectionDetailImageSupportedFileExtensions.some(
    (supportedExtension) => supportedExtension === extension
  ))
    return "image";
  if (inspectionDetailKnownNonImageFileExtensions.some(
    (nonImageExtension) => nonImageExtension === extension
  ))
    return "non_image";
  return "unknown";
};
var resolveDataUrlSource = (source) => source ? resolveMimeTypeSource(resolveDataUrlMimeType(source)) : "unknown";
var resolveInspectionDetailImageSource = ({
  fileType,
  mimeType,
  originalSource,
  source
}) => {
  const explicitMimeType = mimeType || (fileType.includes("/") ? fileType : void 0);
  const sourceResolutions = [
    resolveMimeTypeSource(explicitMimeType),
    resolveDataUrlSource(source),
    resolveFileExtensionSource(source),
    resolveDataUrlSource(originalSource),
    resolveFileExtensionSource(originalSource)
  ];
  if (sourceResolutions.includes("non_image"))
    return "non_image";
  if (sourceResolutions.includes("image"))
    return "image";
  return "unknown";
};
var inspectionDetailImageTelemetryEligibilityByFileType = {
  image: (sourceResolution) => sourceResolution !== "non_image",
  file: (sourceResolution) => sourceResolution === "image"
};
var isInspectionDetailImageTelemetryFileType = (fileType) => fileType === "image" || fileType === "file";
var isInspectionDetailImageTelemetryEligible = (input) => {
  const sourceResolution = resolveInspectionDetailImageSource(input);
  if (sourceResolution === "non_image")
    return false;
  if (input.assetType === "image")
    return true;
  if (!isInspectionDetailImageTelemetryFileType(input.fileType))
    return false;
  return inspectionDetailImageTelemetryEligibilityByFileType[input.fileType](
    sourceResolution
  );
};
var optionalShortStringSchema = import_zod13.z.string().max(512).optional();
var optionalLongStringSchema = import_zod13.z.string().max(4096).optional();
var inspectionDetailImageUrlDiagnosticsSchema = import_zod13.z.object({
  sanitizedUrl: optionalLongStringSchema,
  protocol: optionalShortStringSchema,
  host: optionalShortStringSchema,
  pathname: optionalLongStringSchema,
  queryParamKeys: import_zod13.z.array(import_zod13.z.string().max(128)).max(64),
  redactedQueryParamKinds: import_zod13.z.array(import_zod13.z.enum(inspectionDetailImageRedactedQueryParamKinds)).max(64),
  hasCloudFrontSignatureQueryParam: import_zod13.z.boolean(),
  hasAccessTokenQueryParam: import_zod13.z.boolean(),
  expiryState: import_zod13.z.enum(inspectionDetailImageUrlExpiryStates),
  expiresAtUnixSeconds: import_zod13.z.number().optional(),
  secondsUntilExpiry: import_zod13.z.number().optional()
}).strict();
var sensitiveQueryParamSpecs = [
  {
    kind: "cloudfront_signature",
    matches: (key) => {
      const normalizedKey = key.toLowerCase();
      if (normalizedKey === "signature")
        return true;
      if (normalizedKey === "x-amz-signature")
        return true;
      return false;
    }
  },
  {
    kind: "cloudfront_key_pair_id",
    matches: (key) => key.toLowerCase() === "key-pair-id"
  },
  {
    kind: "cloudfront_policy",
    matches: (key) => key.toLowerCase() === "policy"
  },
  {
    kind: "access_token",
    matches: (key) => {
      const normalizedKey = key.toLowerCase();
      if (normalizedKey === "accesstoken")
        return true;
      if (normalizedKey === "access_token")
        return true;
      return false;
    }
  },
  {
    kind: "auth_token",
    matches: (key) => {
      const normalizedKey = key.toLowerCase();
      if (normalizedKey.includes("authorization"))
        return true;
      if (normalizedKey.includes("token"))
        return true;
      return false;
    }
  },
  {
    kind: "aws_credential",
    matches: (key) => {
      const normalizedKey = key.toLowerCase();
      if (normalizedKey === "x-amz-credential")
        return true;
      if (normalizedKey === "x-amz-security-token")
        return true;
      return false;
    }
  }
];
var sensitiveTextRedactionSpecs = [
  {
    pattern: /([?&]?)(Signature|X-Amz-Signature)=[^&"'\s]+/gi,
    replacement: "$1redacted_query_param=[redacted]"
  },
  {
    pattern: /([?&]?)(accessToken|access_token)=[^&"'\s]+/gi,
    replacement: "$1redacted_query_param=[redacted]"
  },
  {
    pattern: /([?&]?)(Policy|Key-Pair-Id|X-Amz-Credential|X-Amz-Security-Token)=[^&"'\s]+/gi,
    replacement: "$1redacted_query_param=[redacted]"
  },
  {
    pattern: /([?&]?)(token|authorization)=[^&"'\s]+/gi,
    replacement: "$1redacted_query_param=[redacted]"
  }
];
var parseUrl = (rawUrl) => {
  try {
    return new URL(rawUrl, "https://dashboard.autoinspector.local");
  } catch {
    return null;
  }
};
var addUniqueString = (values, value) => {
  if (values.includes(value))
    return;
  values.push(value);
};
var resolveRedactedQueryParamKind = (key) => {
  const matchedSpec = sensitiveQueryParamSpecs.find((spec) => spec.matches(key));
  if (matchedSpec)
    return matchedSpec.kind;
  const normalizedKey = key.toLowerCase();
  if (normalizedKey.startsWith("x-amz-"))
    return "aws_credential";
  if (normalizedKey.includes("secret"))
    return "other_sensitive";
  return void 0;
};
var resolveSanitizedQueryValue = (key, value) => {
  if (key === "Expires")
    return value;
  return "[redacted]";
};
var buildExpiryDiagnostics = (searchParams, nowMs) => {
  const expires = searchParams.get("Expires");
  if (!expires)
    return {
      expiryState: "missing_expires"
    };
  const expiresAtUnixSeconds = Number(expires);
  if (!Number.isFinite(expiresAtUnixSeconds))
    return {
      expiryState: "invalid_expires"
    };
  const nowUnixSeconds = Math.floor(nowMs / 1e3);
  const secondsUntilExpiry = expiresAtUnixSeconds - nowUnixSeconds;
  if (secondsUntilExpiry < 0)
    return {
      expiryState: "expired",
      expiresAtUnixSeconds,
      secondsUntilExpiry
    };
  return {
    expiryState: "not_expired",
    expiresAtUnixSeconds,
    secondsUntilExpiry
  };
};
var redactInspectionDetailImageErrorSensitiveText = (value) => sensitiveTextRedactionSpecs.reduce(
  (sanitizedValue, spec) => sanitizedValue.replace(spec.pattern, spec.replacement),
  value
);
var buildInspectionDetailImageUrlDiagnostics = (rawUrl, nowMs = Date.now()) => {
  const dataUrlMimeType = resolveDataUrlMimeType(rawUrl);
  if (rawUrl.toLowerCase().startsWith("data:"))
    return {
      sanitizedUrl: `data:${dataUrlMimeType || "application/octet-stream"},[redacted]`,
      protocol: "data:",
      queryParamKeys: [],
      redactedQueryParamKinds: [],
      hasCloudFrontSignatureQueryParam: false,
      hasAccessTokenQueryParam: false,
      expiryState: "missing_expires"
    };
  const parsedUrl = parseUrl(rawUrl);
  if (!parsedUrl)
    return {
      queryParamKeys: [],
      redactedQueryParamKinds: [],
      hasCloudFrontSignatureQueryParam: false,
      hasAccessTokenQueryParam: false,
      expiryState: "unparseable_url"
    };
  const queryParamKeys = [];
  const redactedQueryParamKinds = [];
  const sanitizedSearchParams = new URLSearchParams();
  parsedUrl.searchParams.forEach((value, key) => {
    const redactedKind = resolveRedactedQueryParamKind(key);
    if (redactedKind) {
      addUniqueString(redactedQueryParamKinds, redactedKind);
      return;
    }
    addUniqueString(queryParamKeys, key);
    sanitizedSearchParams.append(key, resolveSanitizedQueryValue(key, value));
  });
  redactedQueryParamKinds.forEach((kind) => {
    sanitizedSearchParams.append("redacted", kind);
  });
  const sanitizedSearch = sanitizedSearchParams.toString();
  const sanitizedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${parsedUrl.pathname}${sanitizedSearch ? `?${sanitizedSearch}` : ""}`;
  const expiryDiagnostics = buildExpiryDiagnostics(
    parsedUrl.searchParams,
    nowMs
  );
  return {
    sanitizedUrl,
    protocol: parsedUrl.protocol,
    host: parsedUrl.host,
    pathname: parsedUrl.pathname,
    queryParamKeys,
    redactedQueryParamKinds,
    hasCloudFrontSignatureQueryParam: redactedQueryParamKinds.includes(
      "cloudfront_signature"
    ),
    hasAccessTokenQueryParam: redactedQueryParamKinds.includes("access_token"),
    ...expiryDiagnostics
  };
};
var inspectionDetailImageErrorAssetContextSchema = import_zod13.z.object({
  id: import_zod13.z.string().min(1).max(256),
  instanceId: optionalShortStringSchema,
  specIdentifier: optionalShortStringSchema,
  label: import_zod13.z.string().min(1).max(512),
  assetType: import_zod13.z.string().min(1).max(128),
  fileType: import_zod13.z.string().min(1).max(128),
  mimeType: optionalShortStringSchema,
  sourceExtension: import_zod13.z.string().regex(/^[a-z0-9]{1,32}$/).optional()
}).strict();
var inspectionDetailImageErrorBrowserContextSchema = import_zod13.z.object({
  userAgent: optionalLongStringSchema,
  language: optionalShortStringSchema,
  viewport: import_zod13.z.object({
    width: import_zod13.z.number(),
    height: import_zod13.z.number()
  }).strict().optional(),
  screen: import_zod13.z.object({
    width: import_zod13.z.number(),
    height: import_zod13.z.number()
  }).strict().optional(),
  devicePixelRatio: import_zod13.z.number().optional(),
  online: import_zod13.z.boolean().optional(),
  visibilityState: optionalShortStringSchema,
  connection: import_zod13.z.object({
    effectiveType: optionalShortStringSchema,
    downlink: import_zod13.z.number().optional(),
    rtt: import_zod13.z.number().optional(),
    saveData: import_zod13.z.boolean().optional()
  }).strict().optional()
}).strict();
var inspectionDetailImageErrorPageContextSchema = import_zod13.z.object({
  url: optionalLongStringSchema,
  path: optionalLongStringSchema
}).strict();
var inspectionDetailImagePerformanceEntrySchema = import_zod13.z.object({
  name: optionalLongStringSchema,
  initiatorType: optionalShortStringSchema,
  startTime: import_zod13.z.number().optional(),
  duration: import_zod13.z.number().optional(),
  transferSize: import_zod13.z.number().optional(),
  encodedBodySize: import_zod13.z.number().optional(),
  decodedBodySize: import_zod13.z.number().optional(),
  nextHopProtocol: optionalShortStringSchema
}).strict();
var inspectionDetailImagePerformanceContextSchema = import_zod13.z.object({
  resourceEntries: import_zod13.z.array(inspectionDetailImagePerformanceEntrySchema).max(5)
}).strict();
var inspectionDetailImageErrorFailureSchema = import_zod13.z.object({
  name: optionalShortStringSchema,
  message: optionalLongStringSchema,
  status: import_zod13.z.number().optional(),
  statusText: optionalShortStringSchema,
  code: optionalShortStringSchema
}).strict();
var inspectionDetailImageErrorReportRequestBodySchema = import_zod13.z.object({
  event: import_zod13.z.enum(inspectionDetailImageErrorEvents),
  occurredAt: import_zod13.z.string().datetime(),
  asset: inspectionDetailImageErrorAssetContextSchema,
  renderContext: import_zod13.z.enum(inspectionDetailImageRenderContexts),
  url: inspectionDetailImageUrlDiagnosticsSchema,
  browser: inspectionDetailImageErrorBrowserContextSchema.optional(),
  page: inspectionDetailImageErrorPageContextSchema.optional(),
  performance: inspectionDetailImagePerformanceContextSchema.optional(),
  error: inspectionDetailImageErrorFailureSchema.optional()
}).strict();
var inspectionDetailImageErrorReportResponseBodySchema = import_zod13.z.object({
  message: import_zod13.z.literal("accepted"),
  reportId: import_zod13.z.string().uuid()
}).strict();

// src/contracts/template-validation.contract.ts
var import_ai_constants8 = require("ai-constants");
var import_zod14 = __toESM(require("zod"));
var templateValidationFeedbackSchema = import_zod14.default.object({
  enabled: import_zod14.default.boolean(),
  message: import_zod14.default.string().trim().optional()
}).superRefine((feedback, context) => {
  if (!feedback.enabled)
    return;
  if (!feedback.message)
    context.addIssue({
      code: import_zod14.default.ZodIssueCode.custom,
      message: "Feedback message is required when feedback is enabled",
      path: ["message"]
    });
  if (feedback.message && feedback.message.length > import_ai_constants8.TEMPLATE_VALIDATION_FEEDBACK_MESSAGE_MAX_LENGTH)
    context.addIssue({
      code: import_zod14.default.ZodIssueCode.too_big,
      inclusive: true,
      maximum: import_ai_constants8.TEMPLATE_VALIDATION_FEEDBACK_MESSAGE_MAX_LENGTH,
      message: `Feedback message must contain at most ${import_ai_constants8.TEMPLATE_VALIDATION_FEEDBACK_MESSAGE_MAX_LENGTH} characters`,
      path: ["message"],
      type: "string"
    });
});

// src/schemas/inspection.ts
var import_ai_constants10 = require("ai-constants");
var import_zod15 = __toESM(require("zod"));

// src/table.ts
var import_ai_constants9 = require("ai-constants");
var import_i11n = require("i11n");

// src/utils/date.ts
var import_date_fns2 = require("date-fns");
var import_date_fns_tz = require("date-fns-tz");
var import_es = __toESM(require("date-fns/locale/es"));
var getZonedDate = (date, timezone) => {
  if (!date)
    return;
  const safeDate = new Date(date);
  if (Number.isNaN(safeDate.valueOf()))
    return;
  if (!timezone)
    return safeDate;
  return (0, import_date_fns_tz.utcToZonedTime)(safeDate, timezone);
};
var formatDateToLocale = (date, dateFormat = "P", context) => {
  if (!date)
    return;
  if (context == null ? void 0 : context.timezone) {
    return (0, import_date_fns_tz.formatInTimeZone)(date, context.timezone, dateFormat, {
      locale: import_es.default
    });
  }
  const zonedDate = getZonedDate(date);
  if (!zonedDate)
    return;
  return (0, import_date_fns2.format)(zonedDate, dateFormat, {
    locale: import_es.default
  });
};
var formatDateToLocaleDays = (date, dateFormat = "P", context) => {
  if (!date)
    return;
  if (context == null ? void 0 : context.timezone) {
    return (0, import_date_fns_tz.formatInTimeZone)(date, context.timezone, dateFormat, {
      locale: import_es.default
    });
  }
  const dt = new Date(date);
  if (Number.isNaN(dt.valueOf()))
    return;
  const dtDateOnly = new Date(dt.valueOf() + dt.getTimezoneOffset() * 60 * 1e3);
  return (0, import_date_fns2.format)(dtDateOnly, dateFormat, {
    locale: import_es.default
  });
};
var timeAgo = (date, context) => {
  if (!date)
    return;
  const target = getZonedDate(date, context == null ? void 0 : context.timezone);
  if (!target)
    return;
  const now = getZonedDate(/* @__PURE__ */ new Date(), context == null ? void 0 : context.timezone) ?? /* @__PURE__ */ new Date();
  return (0, import_date_fns2.formatDistance)(target, now, {
    addSuffix: true,
    locale: import_es.default
  });
};
var getTestingCurrentDate = () => {
  const rawDate = process.env.NEXT_PUBLIC_TEST_CURRENT_DATE;
  if (!rawDate)
    return null;
  const parsed = new Date(rawDate);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};
var getCurrentDate = () => getTestingCurrentDate() ?? /* @__PURE__ */ new Date();

// src/table.ts
var toInspectionResultOption = (result) => {
  if (result)
    return result;
  return import_ai_constants9.inspectionWithoutResult;
};
var defaultInspectionTableColumns = [
  {
    id: "name",
    header: "Nombre",
    mapper: (row) => {
      var _a, _b, _c, _d;
      const first = ((_b = (_a = row.consumer) == null ? void 0 : _a.firstName) == null ? void 0 : _b.toLowerCase()) ?? "";
      const last = ((_d = (_c = row.consumer) == null ? void 0 : _c.lastName) == null ? void 0 : _d.toLowerCase()) ?? "";
      const name = `${first} ${last}`.trim();
      return name || "-";
    }
  },
  {
    id: "identification",
    header: "DNI",
    mapper: (row) => {
      var _a;
      return ((_a = row.consumer) == null ? void 0 : _a.identification) ?? "-";
    }
  },
  {
    id: "inspectionId",
    header: "ID de inspecci\xF3n",
    mapper: (row) => row._id ?? "-"
  },
  {
    id: "createdAt",
    header: "Creada",
    mapper: (row, context) => formatDateToLocale(row.createdAt ?? null, "Pp", context) ?? ""
  },
  {
    id: "finishDate",
    header: "Finalizada",
    mapper: (row, context) => formatDateToLocale(row.finishDate ?? null, "Pp", context) ?? ""
  },
  {
    id: "type",
    header: "Tipo",
    mapper: (row) => row.type ? (0, import_i11n.t)(row.type) : ""
  },
  {
    id: "status",
    header: "Estado",
    mapper: (row) => {
      if (!row.status)
        return "";
      if (row.status === "completed" && row.result)
        return (0, import_i11n.t)(`inspection.result.${row.result}.label`);
      return (0, import_i11n.t)(row.status);
    }
  },
  {
    id: "template",
    header: "Plantilla",
    withoutLink: true,
    mapper: (row) => {
      var _a;
      return ((_a = row.template) == null ? void 0 : _a.name) ?? "";
    }
  },
  {
    id: "producer",
    header: "Creador",
    mapper: (row) => {
      var _a, _b, _c, _d, _e;
      if ((_a = row.producer) == null ? void 0 : _a.user)
        return [(_c = (_b = row.producer) == null ? void 0 : _b.user) == null ? void 0 : _c.firstName, (_e = (_d = row.producer) == null ? void 0 : _d.user) == null ? void 0 : _e.lastName].filter(Boolean).join(" ");
      return row.mode ?? "";
    }
  },
  {
    id: "review",
    header: "Revisi\xF3n",
    mapper: (row) => row.review ? (0, import_i11n.t)(row.review) : ""
  }
];
var table_default = defaultInspectionTableColumns;

// src/schemas/inspection.ts
var retrieveInspectionProgressResponseBody = import_zod15.default.object({
  _id: import_zod15.default.string(),
  status: import_zod15.default.enum(import_ai_constants10.inspectionStatus),
  notificationEvents: import_zod15.default.array(
    import_zod15.default.object({
      _id: import_zod15.default.string(),
      channel: import_zod15.default.enum(import_ai_constants10.notificationEventChannels),
      event: import_zod15.default.enum(import_ai_constants10.notificationEvents),
      metadata: import_zod15.default.object({
        inspectionId: import_zod15.default.string()
      })
    })
  ),
  accessCode: import_zod15.default.string()
});
var getVehicleAngleModelUrlResponseBody = import_zod15.default.object({
  modelKey: import_zod15.default.string().min(1),
  url: import_zod15.default.string().min(1)
});
var vehicleCompletenessModelContractSchema = import_zod15.default.object({
  policyVersion: import_zod15.default.string().min(1),
  input: import_zod15.default.object({
    batch: import_zod15.default.literal(1),
    channels: import_zod15.default.literal(3),
    height: import_zod15.default.literal(320),
    width: import_zod15.default.literal(320),
    colorSpace: import_zod15.default.literal("rgb"),
    dataType: import_zod15.default.literal("float32"),
    preprocessing: import_zod15.default.literal("letterbox-rgb-float32-320-v1"),
    letterboxPaddingValue: import_zod15.default.literal(114),
    resizeRounding: import_zod15.default.literal("half_up"),
    normalization: import_zod15.default.object({
      minimum: import_zod15.default.literal(0),
      maximum: import_zod15.default.literal(1)
    })
  }),
  output: import_zod15.default.object({
    anchorCount: import_zod15.default.literal(3234),
    boxes: import_zod15.default.object({
      name: import_zod15.default.string().min(1),
      shape: import_zod15.default.tuple([import_zod15.default.literal(1), import_zod15.default.literal(3234), import_zod15.default.literal(4)]),
      format: import_zod15.default.literal("xyxy")
    }),
    logits: import_zod15.default.object({
      name: import_zod15.default.string().min(1),
      shape: import_zod15.default.tuple([import_zod15.default.literal(1), import_zod15.default.literal(3234), import_zod15.default.literal(2)])
    })
  }),
  classes: import_zod15.default.tuple([import_zod15.default.literal("background"), import_zod15.default.literal("vehicle")]).readonly(),
  confidenceThreshold: import_zod15.default.number().min(0).max(1),
  nmsIouThreshold: import_zod15.default.number().min(0).max(1),
  minimumBorderGapRatio: import_zod15.default.number().min(0).max(0.5)
});
var getVehicleCompletenessModelConfigResponseBody = import_zod15.default.discriminatedUnion("status", [
  import_zod15.default.object({ status: import_zod15.default.literal("disabled") }),
  import_zod15.default.object({
    status: import_zod15.default.literal("ready"),
    modelKey: import_zod15.default.string().min(1),
    url: import_zod15.default.string().min(1),
    sha256: import_zod15.default.string().regex(/^[a-f0-9]{64}$/),
    contract: vehicleCompletenessModelContractSchema
  })
]);
var registerInspectionErrorRequestBody = import_zod15.default.object({
  name: import_zod15.default.string(),
  message: import_zod15.default.string(),
  stack: import_zod15.default.string().nullish(),
  url: import_zod15.default.string(),
  runtime: import_zod15.default.enum(["client", "server"])
});
var registerClientInspectionEventRequestBody = import_zod15.default.object({
  events: import_zod15.default.array(
    import_zod15.default.discriminatedUnion("event", [
      import_zod15.default.object({
        event: import_zod15.default.literal("vehicle_360_manual_capture_lifecycle"),
        data: import_zod15.default.object({
          action: import_zod15.default.enum(import_ai_constants10.vehicle360ManualLifecycleActions),
          angle: import_zod15.default.enum(import_ai_constants10.VEHICLE_ANGLE_LABELS).optional(),
          attempts_remaining: import_zod15.default.number().optional(),
          duration_ms: import_zod15.default.number().optional(),
          unix_timestamp_seconds: import_zod15.default.number()
        })
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("vehicle_360_capability_probed"),
        data: import_zod15.default.discriminatedUnion("model_session_outcome", [
          import_zod15.default.object({
            samples_ms: import_zod15.default.array(import_zod15.default.number()).length(5),
            median_ms: import_zod15.default.number(),
            selected_mode: import_zod15.default.enum(import_ai_constants10.vehicle360SelectedCapabilityModes),
            reason: import_zod15.default.enum(import_ai_constants10.vehicle360ManualSwitchReasons).optional(),
            camera_width: import_zod15.default.number(),
            camera_height: import_zod15.default.number(),
            browser_family: import_zod15.default.string(),
            model_session_outcome: import_zod15.default.literal(import_ai_constants10.vehicle360ModelSessionOutcomes[0]),
            unix_timestamp_seconds: import_zod15.default.number()
          }),
          import_zod15.default.object({
            samples_ms: import_zod15.default.array(import_zod15.default.number()).length(0),
            selected_mode: import_zod15.default.literal("manual"),
            reason: import_zod15.default.enum(import_ai_constants10.vehicle360ModelErrorManualSwitchReasons),
            camera_width: import_zod15.default.number(),
            camera_height: import_zod15.default.number(),
            browser_family: import_zod15.default.string(),
            model_session_outcome: import_zod15.default.literal(import_ai_constants10.vehicle360ModelSessionOutcomes[1]),
            unix_timestamp_seconds: import_zod15.default.number()
          })
        ])
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("inspection_app_webview_wall_viewed"),
        data: import_zod15.default.object({
          unix_timestamp_seconds: import_zod15.default.number()
        })
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("inspection_app_no_file_selected"),
        data: import_zod15.default.object({
          unix_timestamp_seconds: import_zod15.default.number()
        })
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("inspection_app_wrong_file_selected"),
        data: import_zod15.default.object({
          unix_timestamp_seconds: import_zod15.default.number(),
          file_name: import_zod15.default.string(),
          file_size_bytes: import_zod15.default.number().nullish(),
          file_mime_type: import_zod15.default.string().nullish()
        })
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("inspection_app_opened"),
        data: import_zod15.default.object({
          unix_timestamp_seconds: import_zod15.default.number(),
          source: import_zod15.default.enum(import_ai_constants10.inspectionLinkSources).nullish(),
          destination: import_zod15.default.string().nullish(),
          channel: import_zod15.default.enum(import_ai_constants10.notificationEventChannels).nullish()
        })
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("poor_connection_detected"),
        data: import_zod15.default.object({
          base_bandwidth_kbps: import_zod15.default.number(),
          file_size_bytes: import_zod15.default.number(),
          tolerated_upload_ms: import_zod15.default.number(),
          connection_type: import_zod15.default.enum(import_ai_constants10.navigatorConnectionTypes).default("unknown"),
          unix_timestamp_seconds: import_zod15.default.number(),
          section_identifier: import_zod15.default.string().nullish()
        })
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("inspection_section_viewed"),
        data: import_zod15.default.object({
          section_identifier: import_zod15.default.string(),
          unix_timestamp_seconds: import_zod15.default.number()
        })
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("inspection_section_completed"),
        data: import_zod15.default.object({
          section_identifier: import_zod15.default.string(),
          unix_timestamp_seconds: import_zod15.default.number()
        })
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("inspection_accordion_item_completed"),
        data: import_zod15.default.object({
          section_identifier: import_zod15.default.string(),
          accordion_identifier: import_zod15.default.string(),
          accordion_item_identifier: import_zod15.default.string(),
          unix_timestamp_seconds: import_zod15.default.number()
        })
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("inspection_app_visibility_active"),
        data: import_zod15.default.object({
          section_identifier: import_zod15.default.string().nullish(),
          last_active_timestamp: import_zod15.default.number(),
          inactive_duration_ms: import_zod15.default.number(),
          unix_timestamp_seconds: import_zod15.default.number()
        })
      }),
      import_zod15.default.object({
        event: import_zod15.default.literal("inspection_app_visibility_inactive"),
        data: import_zod15.default.object({
          section_identifier: import_zod15.default.string().nullish(),
          last_active_timestamp: import_zod15.default.number(),
          active_duration_ms: import_zod15.default.number(),
          unix_timestamp_seconds: import_zod15.default.number()
        })
      })
    ])
  )
});
var registerClientInspectionEventResponseBody = import_zod15.default.object({
  registered: import_zod15.default.boolean()
});
var downloadInspectionsReportRequestBody = import_zod15.default.object({
  timezone: import_zod15.default.string(),
  columns: import_zod15.default.array(
    import_zod15.default.discriminatedUnion("type", [
      import_zod15.default.object({
        type: import_zod15.default.literal("default"),
        id: import_zod15.default.string().refine(
          (id) => table_default.some((c) => c.id === id),
          {
            message: "Invalid column id"
          }
        )
      }),
      import_zod15.default.object({
        type: import_zod15.default.literal("custom"),
        path: import_zod15.default.string()
      })
    ])
  )
});
var objectIdSchema = import_zod15.default.string().regex(/^[a-fA-F0-9]{24}$/);
var batchSendInspectionsRequestBody = import_zod15.default.object({
  deliveries: import_zod15.default.array(
    import_zod15.default.object({
      inspectionId: objectIdSchema,
      destination: import_zod15.default.string().email()
    })
  ).min(1).max(import_ai_constants10.BATCH_SEND_INSPECTIONS_MAX_DELIVERIES).refine(
    (deliveries) => new Set(deliveries.map((delivery) => delivery.inspectionId)).size === deliveries.length,
    {
      message: "Duplicated inspectionId in deliveries"
    }
  )
});
var batchSendInspectionsResponseBody = import_zod15.default.object({
  sent: import_zod15.default.array(
    import_zod15.default.object({
      inspectionId: import_zod15.default.string()
    })
  ),
  skipped: import_zod15.default.array(
    import_zod15.default.object({
      inspectionId: import_zod15.default.string(),
      reason: import_zod15.default.enum(import_ai_constants10.batchSendInspectionSkipReasons)
    })
  )
});
var DEFAULT_SEARCH_PARAMS_ACCESS_TOKEN_STRATEGY = "oauth";
var inspectionDetailIframeRequestQuerySchema = import_zod15.default.object({
  inspectionId: import_zod15.default.string(),
  inspectionType: import_zod15.default.enum(import_ai_constants10.inspectionTypes),
  accessToken: import_zod15.default.string(),
  strategy: import_zod15.default.enum(["oauth", "presign"]).default(DEFAULT_SEARCH_PARAMS_ACCESS_TOKEN_STRATEGY)
});

// src/schemas/search.ts
var import_zod16 = require("zod");
var import_validator = require("validator");
var import_ai_constants11 = require("ai-constants");
var similaritySearchRequestParams = import_zod16.z.object({
  inspectionId: import_zod16.z.string().refine(import_validator.isMongoId)
});
var similaritySearchSupportedAssetTypes = [
  "input",
  "document",
  "image"
];
var similaritySearchAssetQueryBaseSchema = import_zod16.z.object({
  assetIdentifier: import_zod16.z.string()
});
var similaritySearchInputAssetQuerySchema = similaritySearchAssetQueryBaseSchema.extend({
  assetType: import_zod16.z.literal("input"),
  instanceId: import_zod16.z.string().optional()
});
var similaritySearchDocumentAssetQuerySchema = similaritySearchAssetQueryBaseSchema.extend({
  assetType: import_zod16.z.literal("document"),
  instanceId: import_zod16.z.string().optional()
});
var similaritySearchImageAssetQuerySchema = similaritySearchAssetQueryBaseSchema.extend({
  assetType: import_zod16.z.literal("image"),
  instanceId: import_zod16.z.string()
});
var similaritySearchRequestQuery = import_zod16.z.object({
  query: import_zod16.z.discriminatedUnion("assetType", [
    similaritySearchInputAssetQuerySchema,
    similaritySearchDocumentAssetQuerySchema,
    similaritySearchImageAssetQuerySchema
  ])
});
var similaritySearchResponseBody = import_zod16.z.object({
  matches: import_zod16.z.array(
    import_zod16.z.object({
      sourceData: import_zod16.z.object({
        title: import_zod16.z.string().nullish(),
        webLink: import_zod16.z.string().nullish(),
        fileUrl: import_zod16.z.string().nullish()
      }).nullish(),
      sourceType: import_zod16.z.enum(import_ai_constants11.inspectionFileSourceTypes),
      _id: import_zod16.z.custom(),
      url: import_zod16.z.string(),
      filename: import_zod16.z.string(),
      type: import_zod16.z.string(),
      similarity: import_zod16.z.number(),
      inspection: import_zod16.z.object({
        queryKeys: import_zod16.z.array(
          import_zod16.z.object({
            key: import_zod16.z.string(),
            value: import_zod16.z.string()
          })
        ),
        initDate: import_zod16.z.custom(),
        finishDate: import_zod16.z.custom(),
        createdAt: import_zod16.z.custom(),
        type: import_zod16.z.enum(import_ai_constants11.inspectionTypes),
        _id: import_zod16.z.custom(),
        status: import_zod16.z.enum(import_ai_constants11.inspectionStatus),
        completedBy: import_zod16.z.string().nullish(),
        consumer: import_zod16.z.object({
          firstName: import_zod16.z.string().nullish(),
          lastName: import_zod16.z.string().nullish(),
          identification: import_zod16.z.string().nullish()
        }),
        producer: import_zod16.z.object({
          userId: import_zod16.z.string().nullish(),
          firstName: import_zod16.z.string().nullish()
        })
      })
    })
  )
});

// src/schemas/plan.ts
var import_zod19 = require("zod");

// src/schemas/company.ts
var import_ai_constants12 = require("ai-constants");
var import_zod18 = require("zod");
var import_providers = require("@autoinspector/providers");

// src/schema.ts
var import_zod17 = require("zod");
var createZodTypeSafeEnumOpenApi = (values) => import_zod17.z.enum(values);

// src/utils/normalize-email.ts
var PLUS_ONLY = /\+.*$/;
var PLUS_AND_DOT = /\.|\+.*$/g;
var normalizeableProviders = {
  "gmail.com": {
    cut: PLUS_AND_DOT
  },
  "googlemail.com": {
    cut: PLUS_AND_DOT,
    aliasOf: "gmail.com"
  },
  "hotmail.com": {
    cut: PLUS_ONLY
  },
  "live.com": {
    cut: PLUS_AND_DOT
  },
  "outlook.com": {
    cut: PLUS_ONLY
  }
};
var normalize = (eMail) => {
  var email = eMail.toLowerCase();
  var emailParts = email.split(/@/);
  if (emailParts.length !== 2) {
    return eMail;
  }
  var username = emailParts[0];
  var domain = emailParts[1];
  if (normalizeableProviders.hasOwnProperty(domain)) {
    if (normalizeableProviders[domain].hasOwnProperty("cut")) {
      username = username.replace(normalizeableProviders[domain].cut, "");
    }
    if (normalizeableProviders[domain].hasOwnProperty("aliasOf")) {
      domain = normalizeableProviders[domain].aliasOf;
    }
  }
  return username + "@" + domain;
};
var normalizeEmail = (email = "") => {
  if (typeof email != "string") {
    return email;
  }
  return normalize(email.trim().toLowerCase());
};

// src/schemas/company.ts
var import_validator2 = require("validator");
var policySchema = import_zod18.z.object({
  name: import_zod18.z.string(),
  definition: import_zod18.z.object({
    rules: import_zod18.z.array(
      import_zod18.z.object({
        actions: import_zod18.z.array(
          import_zod18.z.object({
            action: createZodTypeSafeEnumOpenApi(
              import_providers.autoinspectorApiEnums.authzService.constantsRuleActionValues
            ),
            effect: createZodTypeSafeEnumOpenApi(
              import_providers.autoinspectorApiEnums.authzService.constantsPolicyEffectValues
            ),
            scope: createZodTypeSafeEnumOpenApi(
              import_providers.autoinspectorApiEnums.authzService.constantsPolicyScopeValues
            ).nullish()
          })
        ),
        resource: createZodTypeSafeEnumOpenApi(
          import_providers.autoinspectorApiEnums.authzService.constantsPolicyResourceValues
        )
      })
    )
  })
});
var planLimitSchema = import_zod18.z.object({
  overagePricePerUnit: import_zod18.z.number().min(0, "Debe ser mayor o igual a 0").nullish(),
  resource: import_zod18.z.enum(import_ai_constants12.planLimitResources),
  model: import_zod18.z.enum(import_ai_constants12.planLimitModels),
  quantity: import_zod18.z.number().min(0, "Debe ser mayor o igual a 0").or(import_zod18.z.literal(import_ai_constants12.UNLIMITED_MAGIC_NUMBER))
});
var planSchema = import_zod18.z.object({
  name: import_zod18.z.string().min(1),
  period: import_zod18.z.enum(import_ai_constants12.planPeriods),
  currency: import_zod18.z.enum(import_ai_constants12.currencies),
  amount: import_zod18.z.number().min(0),
  limits: import_zod18.z.array(planLimitSchema),
  description: import_zod18.z.string().nullish()
});
var applyAddonPlanCustomValidations = (schema) => (
  //@ts-ignore
  schema.refine(
    (data) => {
      if (!data.startDate && !data.endDate)
        return true;
      if (data.startDate && data.endDate)
        return new Date(data.startDate) < new Date(data.endDate);
      return true;
    },
    {
      message: "La fecha de inicio debe ser anterior a la fecha de fin",
      path: ["startDate", "endDate"]
    }
  )
);
var addonPlanSchemaBase = planSchema.extend({
  startDate: import_zod18.z.coerce.date().nullish(),
  endDate: import_zod18.z.coerce.date().nullish()
});
var addonPlanSchema = applyAddonPlanCustomValidations(addonPlanSchemaBase);
var registerCompanyRequestBody = import_zod18.z.object({
  domain: import_zod18.z.string().min(1, "Campo requerido").regex(/^[a-zA-Z0-9.-]+$/, "Dominio inv\xE1lido").refine((domain) => domain.split(".").length > 1, "Dominio inv\xE1lido"),
  societyReason: import_zod18.z.string().min(1, "Campo requerido"),
  fantasyName: import_zod18.z.string().min(1, "Campo requerido"),
  taxId: import_zod18.z.string().min(1, "Campo requerido"),
  legalAddress: import_zod18.z.string().min(1, "Campo requerido"),
  countryISO: import_zod18.z.string().min(1, "Campo requerido"),
  language: createZodTypeSafeEnumOpenApi(import_ai_constants12.languageISO6391Codes).default(
    import_ai_constants12.DEFAULT_COMPANY_LANGUAGE
  ),
  persons: import_zod18.z.array(
    import_zod18.z.object({
      role: import_zod18.z.enum(import_ai_constants12.companyRegistrationPersonRoles),
      firstName: import_zod18.z.string().min(1, "Campo requerido"),
      lastName: import_zod18.z.string().min(1, "Campo requerido"),
      email: import_zod18.z.string().email("Correo electr\xF3nico inv\xE1lido").transform((email) => normalizeEmail(email))
    })
  ).refine((persons) => persons.some((person) => person.role === "admin"), {
    message: "Debe haber al menos un administrador"
  }),
  subscription: import_zod18.z.object({
    startDate: import_zod18.z.coerce.date({
      errorMap: () => ({
        message: "Campo requerido"
      })
    }),
    endDate: import_zod18.z.coerce.date().nullish(),
    plan: planSchema,
    addonPlans: import_zod18.z.array(addonPlanSchema)
  }),
  policy: policySchema
});
var registerCompanyResponseBody = import_zod18.z.object({
  companyId: import_zod18.z.string(),
  guests: import_zod18.z.array(
    import_zod18.z.object({
      _id: import_zod18.z.any()
    })
  )
});
var companySchema = import_zod18.z.object({
  domain: import_zod18.z.string(),
  fantasyName: import_zod18.z.string(),
  _id: import_zod18.z.string(),
  cuit: import_zod18.z.string(),
  language: createZodTypeSafeEnumOpenApi(import_ai_constants12.languageISO6391Codes),
  industry: import_zod18.z.string(),
  societyReason: import_zod18.z.string(),
  adminOwner: import_zod18.z.string(),
  location: import_zod18.z.object({
    country: import_zod18.z.string(),
    state: import_zod18.z.string(),
    address: import_zod18.z.string()
  }),
  persons: import_zod18.z.array(
    import_zod18.z.object({
      firstName: import_zod18.z.string(),
      lastName: import_zod18.z.string(),
      email: import_zod18.z.string(),
      role: import_zod18.z.enum(import_ai_constants12.companyRegistrationPersonRoles)
    })
  ),
  subscription: import_zod18.z.object({
    plan: import_zod18.z.object({
      name: import_zod18.z.string()
    })
  }),
  authConfig: import_zod18.z.object({
    email: import_zod18.z.boolean(),
    google: import_zod18.z.boolean(),
    microsoft: import_zod18.z.boolean()
  })
});
var getCompaniesPaginationResponseBody = import_zod18.z.object({
  data: import_zod18.z.array(companySchema),
  metadata: import_zod18.z.object({
    totalDocs: import_zod18.z.number(),
    limit: import_zod18.z.number(),
    totalPages: import_zod18.z.number()
  })
});
var resendInvitationEmailAdminRequestBody = import_zod18.z.object({
  companyId: import_zod18.z.string()
});
var resendInvitationEmailAdminResponseBody = import_zod18.z.object({
  sent: import_zod18.z.boolean(),
  email: import_zod18.z.string()
});
var onboardingInviteUsersRequestBody = import_zod18.z.object({
  emails: import_zod18.z.array(
    import_zod18.z.object({
      email: import_zod18.z.string().email({ message: "Correo inv\xE1lido" })
    })
  ).min(1, "M\xEDnimo un correo electr\xF3nico")
});
var retrieveCompanyRequestParams = import_zod18.z.object({
  companyId: import_zod18.z.string().min(1, "Company ID is required").refine(import_validator2.isMongoId)
});
var retrieveCompanyResponseBody = companySchema;
var listCompanySubscriptionsResponseBody = import_zod18.z.object({
  subscriptions: import_zod18.z.array(
    import_zod18.z.object({
      planId: import_zod18.z.any(),
      _id: import_zod18.z.string(),
      plan: registerCompanyRequestBody.shape.subscription.shape.plan.extend({
        _id: import_zod18.z.string()
      }),
      startDate: import_zod18.z.coerce.date(),
      endDate: import_zod18.z.coerce.date().nullish(),
      status: import_zod18.z.enum(import_ai_constants12.subscriptionStatuses)
    })
  )
});
var updateCompanyRequestBody = registerCompanyRequestBody.omit({
  subscription: true,
  policy: true
});
var updateCompanyRequestParams = retrieveCompanyRequestParams;
var VerificationStatusEnum = /* @__PURE__ */ ((VerificationStatusEnum2) => {
  VerificationStatusEnum2["PENDING"] = "pending";
  VerificationStatusEnum2["APPROVED"] = "approved";
  VerificationStatusEnum2["REJECTED"] = "rejected";
  return VerificationStatusEnum2;
})(VerificationStatusEnum || {});
var listCompaniesRequestQuery = dataTableRequestQuerySchema.extend({
  verificationStatus: import_zod18.z.nativeEnum(VerificationStatusEnum).nullish()
});
var aggregatePaginateUsersRequestQuery = dataTableRequestQuerySchema;
var userActivityBaseSchema = import_zod18.z.object({
  week: import_zod18.z.number(),
  year: import_zod18.z.number(),
  count: import_zod18.z.number(),
  inspection_created: import_zod18.z.number(),
  inspection_detail_viewed: import_zod18.z.number(),
  distinctRelevantEventDays: import_zod18.z.array(import_zod18.z.number())
});
var aggregatePaginateUsersResponseBody = createPaginationResponseSchema(
  import_zod18.z.object({
    _id: import_zod18.z.any(),
    email: import_zod18.z.string(),
    firstName: import_zod18.z.string().nullish(),
    lastName: import_zod18.z.string().nullish(),
    userId: import_zod18.z.any().nullish(),
    notificationEvents: import_zod18.z.custom(),
    policy: import_zod18.z.object({
      name: import_zod18.z.string()
    }),
    companySocietyReason: import_zod18.z.string().nullish(),
    companyFantasyName: import_zod18.z.string().nullish(),
    companyId: import_zod18.z.any(),
    createdAt: import_zod18.z.coerce.date(),
    segment: import_zod18.z.object({
      _id: import_zod18.z.any(),
      type: import_zod18.z.enum(import_ai_constants12.userSegmentTypes),
      timestamp: import_zod18.z.coerce.date()
    }).nullish(),
    activity: import_zod18.z.array(userActivityBaseSchema)
  })
).extend({
  percentages: import_zod18.z.array(
    import_zod18.z.object({
      segment: import_zod18.z.enum(import_ai_constants12.userSegmentTypes),
      percentage: import_zod18.z.number(),
      count: import_zod18.z.number()
    })
  )
});
var inviteUsersRequestBody = import_zod18.z.object({
  guests: import_zod18.z.array(
    import_zod18.z.object({
      email: import_zod18.z.string().email().refine(normalizeEmail),
      internalId: import_zod18.z.string().nullish()
    })
  ),
  policy: policySchema
});
var inviteUsersResponseBody = import_zod18.z.object({
  guests: import_zod18.z.array(
    import_zod18.z.object({
      email: import_zod18.z.string()
    })
  )
});
var updateCompanyConfigRequestBody = import_zod18.z.object({
  authConfig: import_zod18.z.object({
    email: import_zod18.z.boolean(),
    google: import_zod18.z.boolean(),
    microsoft: import_zod18.z.boolean()
  })
});

// src/schemas/plan.ts
var searchPlanRequestQuery = import_zod19.z.object({
  search: import_zod19.z.string().optional().nullish(),
  limit: import_zod19.z.number().max(30).default(10)
});
var searchPlanResponseBody = import_zod19.z.object({
  plans: import_zod19.z.array(
    planSchema.extend({
      _id: import_zod19.z.string(),
      subscription: import_zod19.z.object({
        company: import_zod19.z.object({
          fantasyName: import_zod19.z.string()
        })
      })
    })
  )
});
var updatePlanRequestParams = import_zod19.z.object({
  planId: import_zod19.z.string()
});
var updatePlanRequestBody = planSchema;

// src/schemas/stats.ts
var import_ai_constants13 = require("ai-constants");
var import_zod20 = __toESM(require("zod"));
var homeStatsDateWindowUnits = ["day", "month"];
var retrieveHomeStatsRequestBodyBase = import_zod20.default.object({
  timeZone: import_zod20.default.string().min(1, "Required")
});
var retrieveHomeStatsWindowSchema = import_zod20.default.object({
  unit: import_zod20.default.enum(homeStatsDateWindowUnits),
  value: import_zod20.default.number().int().positive()
});
var retrieveHomeStatsInTheLastRequestBodySchema = retrieveHomeStatsRequestBodyBase.extend({
  rangeType: import_zod20.default.literal("in_the_last"),
  window: retrieveHomeStatsWindowSchema
});
var retrieveHomeStatsCalendarToDateRequestBodySchema = retrieveHomeStatsRequestBodyBase.extend({
  rangeType: import_zod20.default.enum(import_ai_constants13.homeStatsCalendarToDateRangeTypes)
});
var retrieveHomeStatsRequestBody = import_zod20.default.discriminatedUnion("rangeType", [
  retrieveHomeStatsInTheLastRequestBodySchema,
  retrieveHomeStatsCalendarToDateRequestBodySchema
]);
var retrieveActivityStatsRequestBody = retrieveHomeStatsRequestBody;
var retrieveActiveWeeksStreakRequestQuery = import_zod20.default.object({
  timeZone: import_zod20.default.string().min(1, "Required")
});
var retrieveActiveWeeksStreakResponseBody = import_zod20.default.object({
  activeWeeksStreak: import_zod20.default.number(),
  currentWeekHasActivity: import_zod20.default.boolean()
});
var activityStatsSummary = import_zod20.default.object({
  inspection_created: import_zod20.default.number(),
  inspection_detail_viewed: import_zod20.default.number(),
  currentWeekHasActivity: import_zod20.default.boolean()
});
var activityStatsItemBase = import_zod20.default.object({
  year: import_zod20.default.number(),
  count: import_zod20.default.number(),
  activeDays: import_zod20.default.number(),
  inspection_created: import_zod20.default.number(),
  inspection_detail_viewed: import_zod20.default.number()
});
var activityStatsItemWeek = activityStatsItemBase.extend({
  week: import_zod20.default.number()
});
var retrieveActivityStatsResponseBody = import_zod20.default.object({
  groupBy: import_zod20.default.literal("week"),
  items: import_zod20.default.array(activityStatsItemWeek),
  summary: activityStatsSummary
});
var retrieveHomeStatsResponseBody = import_zod20.default.object({
  completed: import_zod20.default.number(),
  pending: import_zod20.default.number(),
  expired: import_zod20.default.number(),
  disapprovedValidationsCount: import_zod20.default.number(),
  disapprovedValidationsInspectionsCount: import_zod20.default.number(),
  disapprovedValidationsVariancePercentage: import_zod20.default.number().nullable(),
  timeSavedHours: import_zod20.default.number(),
  timeSavedVariancePercentage: import_zod20.default.number().nullable(),
  averageMinutesPerInspection: import_zod20.default.number().nullable(),
  comparisonPeriodType: import_zod20.default.enum(import_ai_constants13.comparisonPeriodTypes)
});

// src/schemas/auth.ts
var import_zod21 = __toESM(require("zod"));
var identityProviders = ["google", "microsoft"];
var emailSchema = import_zod21.default.string().min(1, "Campo requerido").email({
  message: "Correo electr\xF3nico inv\xE1lido"
}).transform(normalizeEmail);
var createAuthorizationURLRequestBody = import_zod21.default.object({
  idp: import_zod21.default.enum(identityProviders),
  invitationToken: import_zod21.default.string().nullish()
});
var createAuthorizationURLResponseBody = import_zod21.default.object({
  url: import_zod21.default.string()
});
var invitationTokenRequestQuery = import_zod21.default.object({
  token: import_zod21.default.string()
});
var invitationTokenHeaderName = "x-invitation-token";
var retrieveMembershipFromInvitationRequestParams = import_zod21.default.object({
  membershipId: import_zod21.default.string()
});
var retrieveMembershipFromInvitationResponseBody = import_zod21.default.object({
  email: emailSchema,
  firstName: import_zod21.default.string(),
  lastName: import_zod21.default.string(),
  membershipId: import_zod21.default.string(),
  invitationToken: import_zod21.default.string()
});
var registerEmailMembershipInvitationRequestParams = import_zod21.default.object({
  membershipId: import_zod21.default.string().min(1, "Membership ID is required")
});
var registerEmailMembershipInvitationRequestBody = import_zod21.default.object({
  password: import_zod21.default.string().min(8, "M\xEDnimo 8 caracteres")
});
var registerEmailMembershipInvitationResponseBody = import_zod21.default.object({
  email: emailSchema,
  firstName: import_zod21.default.string(),
  lastName: import_zod21.default.string()
});
var loginBouncedRequestQuery = import_zod21.default.object({
  error_code: import_zod21.default.enum([
    "not_found_user",
    "invitation_email_mismatch",
    "user_resource_limit_reached",
    "idp_not_allowed",
    "invalid_id_token"
  ]),
  idp: import_zod21.default.enum(identityProviders).nullish()
});
var loginUserRequestBody = import_zod21.default.object({
  email: emailSchema,
  password: import_zod21.default.string(),
  remember: import_zod21.default.boolean().optional()
});

// src/schemas/template.ts
var import_zod22 = require("zod");
var import_ai_constants14 = require("ai-constants");
var updateTemplateRequestParams = import_zod22.z.object({
  templateId: import_zod22.z.string().min(1)
});
var officeUpdateTemplateRequestBody = import_zod22.z.object({
  type: import_zod22.z.enum(import_ai_constants14.templateTypes)
});
var templateInputWalkaroundAssetSchema = import_zod22.z.object({
  type: import_zod22.z.literal("image"),
  identifier: import_zod22.z.string()
});
var templateInputWalkaroundSchema = import_zod22.z.object({
  enabled: import_zod22.z.boolean(),
  confidence: import_zod22.z.number().optional(),
  capture: import_zod22.z.boolean().optional(),
  assets: import_zod22.z.array(templateInputWalkaroundAssetSchema).optional()
});

// src/schemas/subscription.ts
var import_ai_constants15 = require("ai-constants");
var import_zod23 = __toESM(require("zod"));
var import_validator3 = require("validator");
var updateSubscriptionRequestBody = import_zod23.default.object({
  startDate: import_zod23.default.coerce.date().nullish(),
  endDate: import_zod23.default.coerce.date().nullish(),
  status: import_zod23.default.enum(import_ai_constants15.subscriptionStatuses).nullish(),
  addonPlans: import_zod23.default.array(
    applyAddonPlanCustomValidations(
      addonPlanSchemaBase.extend({
        _id: import_zod23.default.string().nullish(),
        status: import_zod23.default.enum(import_ai_constants15.subscriptionStatuses).nullish()
      })
    )
  ).nullish()
});
var retrieveSubscriptionRequestParams = import_zod23.default.object({
  subscriptionId: import_zod23.default.string()
});
var createSubscriptionRequestBody = registerCompanyRequestBody.shape.subscription.refine(
  (data) => !data.endDate || data.startDate < data.endDate,
  {
    message: "La fecha de inicio debe ser anterior a la fecha de fin",
    path: ["startDate"]
  }
);
var createSubscriptionResponseBody = import_zod23.default.object({
  subscription: import_zod23.default.object({
    _id: import_zod23.default.string(),
    plan: import_zod23.default.object({
      name: import_zod23.default.string()
    })
  })
});
var createSubscriptionRequestParams = import_zod23.default.object({
  companyId: import_zod23.default.string().min(1, "Company ID is required")
});
var prepareInvoiceDownloadRequestParams = import_zod23.default.object({
  invoiceId: import_zod23.default.string().refine(import_validator3.isMongoId)
});
var prepareInvoiceDownloadResponseBody = import_zod23.default.object({
  url: import_zod23.default.string()
});
var subscribeToAddonPlanRequestBody = import_zod23.default.object({
  addonPlanId: import_zod23.default.string()
});

// src/schemas/public-template-v2.ts
var import_ai_constants16 = require("ai-constants");
var import_validator4 = require("validator");
var import_zod24 = __toESM(require("zod"));
var retrieveTemplatePublicApiV2RequestParamsSchema = import_zod24.default.object({
  templateId: import_zod24.default.string().refine(import_validator4.isMongoId, {
    message: "Invalid template id. It should be a 24-character hexadecimal string."
  })
});
var retrieveTemplatePublicApiV2RequestQuerySchema = import_zod24.default.object({
  stage: import_zod24.default.enum(import_ai_constants16.inspectionStages).optional().describe(
    "Stage to consider when building template assets schema. By default all stages are considered."
  )
});
var aggregatedAssetTypes = [...import_ai_constants16.inputTypes, "image"];
var publicSpecTemplateBindingAssetTypes = [
  ...aggregatedAssetTypes,
  "damageDeclaration"
];
var aggregatedFileAssetTypes = [
  ...import_ai_constants16.strictInputTypeFiles,
  "image"
];
var publicSpecAssetBindingSchema = import_zod24.default.object({
  identifier: import_zod24.default.string().nonempty().describe("Identifier of the asset"),
  type: import_zod24.default.enum(publicSpecTemplateBindingAssetTypes).describe("Type of the asset"),
  value: import_zod24.default.string().optional().describe(
    "Declared asset value. Present when needed to disambiguate repeated asset declarations."
  )
});
var commonAssetSchema = import_zod24.default.object({
  identifier: import_zod24.default.string().describe("Asset identifier"),
  label: import_zod24.default.string().describe("Asset label"),
  description: import_zod24.default.string().optional().describe("Asset description"),
  stages: import_zod24.default.array(import_zod24.default.enum(import_ai_constants16.inspectionStages))
});
var assetsSchema = import_zod24.default.array(
  import_zod24.default.discriminatedUnion("type", [
    commonAssetSchema.extend({
      type: import_zod24.default.literal("text"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean(),
        minLength: import_zod24.default.number().optional(),
        maxLength: import_zod24.default.number().optional(),
        email: import_zod24.default.boolean().optional(),
        pattern: import_zod24.default.string().optional()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.literal("numeric"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean(),
        minimum: import_zod24.default.number().optional(),
        maximum: import_zod24.default.number().optional(),
        minDigits: import_zod24.default.number().optional(),
        maxDigits: import_zod24.default.number().optional()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.literal("select"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean()
      }),
      options: import_zod24.default.array(
        import_zod24.default.object({
          label: import_zod24.default.string().describe("Option label")
        })
      )
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.literal("multiselect"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean(),
        minOptions: import_zod24.default.number().optional(),
        maxOptions: import_zod24.default.number().optional()
      }),
      options: import_zod24.default.array(
        import_zod24.default.object({
          label: import_zod24.default.string().describe("Option label")
        })
      )
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.literal("date"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean(),
        minDate: import_zod24.default.string().datetime().optional(),
        maxDate: import_zod24.default.string().datetime().optional()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.enum(["file", "video", "audio"]),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.literal("checkboxGroup"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean(),
        minOptions: import_zod24.default.number().optional(),
        maxOptions: import_zod24.default.number().optional()
      }),
      options: import_zod24.default.array(
        import_zod24.default.object({
          label: import_zod24.default.string().describe("Option label")
        })
      )
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.literal("dialogDecision"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.literal("signature"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.literal("image"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.literal("textarea"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean(),
        minLength: import_zod24.default.number().optional(),
        maxLength: import_zod24.default.number().optional(),
        pattern: import_zod24.default.string().optional()
      })
    }),
    commonAssetSchema.extend({
      type: import_zod24.default.literal("check"),
      validation: import_zod24.default.object({
        required: import_zod24.default.boolean()
      })
    })
  ])
).describe("Template assets spec");
var publicSpecTemplateValidationSchema = import_zod24.default.object({
  identifier: import_zod24.default.string().nonempty().describe(
    "Identifier of the validation. Use this to programmatically reference the validation."
  ),
  title: import_zod24.default.string().nonempty().describe("Human readable validation title"),
  description: import_zod24.default.string().nonempty().describe("Human readable validation description"),
  order: import_zod24.default.number().int().positive().optional().describe("Presentation order configured for the validation"),
  bindings: import_zod24.default.object({
    assets: import_zod24.default.array(publicSpecAssetBindingSchema).describe("Assets dependencies of the validation")
  }).describe("Dependencies of the validation")
}).describe("Validation results");
var publicSpecTemplateInferenceSchema = import_zod24.default.object({
  identifier: import_zod24.default.string().nonempty().describe(
    "Identifier of the inference. Use this to programmatically reference the inference."
  ),
  title: import_zod24.default.string().nonempty().describe("Human readable inference title"),
  bindings: import_zod24.default.object({
    assets: import_zod24.default.array(publicSpecAssetBindingSchema)
  }).describe("To which assets the inference is bound to"),
  schema: import_zod24.default.record(import_zod24.default.string(), import_zod24.default.any()).describe("Inference value JSON Schema")
});
var retrieveTemplatePublicApiV2ResponseSchemaExample = {
  type: ["object"],
  properties: {
    assets: {
      type: ["array"],
      items: {
        discriminator: {
          propertyName: "identifier"
        },
        oneOf: [
          {
            type: ["object"],
            properties: {
              label: {
                type: ["string"],
                enum: ["Nombre"]
              },
              identifier: {
                type: ["string"],
                enum: ["input_799d0410-6f9f-4336-acd1-9dde9af158bd"]
              },
              type: {
                type: ["string"],
                enum: ["text"]
              },
              value: {
                type: ["string"]
              }
            },
            required: ["identifier", "type", "value"]
          },
          {
            type: ["object"],
            properties: {
              label: {
                type: ["string"],
                enum: ["Apellido"]
              },
              identifier: {
                type: ["string"],
                enum: ["input_7c9c6f4b-b74d-4842-b6fa-b59e6e1d57b5"]
              },
              type: {
                type: ["string"],
                enum: ["text"]
              },
              value: {
                type: ["string"]
              }
            },
            required: ["identifier", "type", "value"]
          },
          {
            type: ["object"],
            properties: {
              label: {
                type: ["string"],
                enum: ["File"]
              },
              identifier: {
                type: ["string"],
                enum: ["input_12f97833-f738-42bf-8b7e-10b27ae964b9"]
              },
              type: {
                type: ["string"],
                enum: ["file"]
              },
              value: {
                type: ["string"],
                description: "File Object ID"
              }
            },
            required: ["identifier", "type", "value"]
          }
        ]
      }
    }
  },
  required: ["assets"]
};
var retrieveTemplatePublicApiV2ResponseAssetsExample = [
  {
    identifier: "input_799d0410-6f9f-4336-acd1-9dde9af158bd",
    label: "Nombre",
    type: "text",
    validation: {
      required: true,
      minLength: 2,
      maxLength: 60,
      email: false,
      pattern: "^[A-Za-z]+$"
    },
    description: "Ingresa el nombre del titular",
    stages: ["create"]
  },
  {
    identifier: "input_7c9c6f4b-b74d-4842-b6fa-b59e6e1d57b5",
    label: "Apellido",
    type: "text",
    validation: {
      required: true,
      minLength: 2,
      maxLength: 60,
      email: false
    },
    stages: ["create"]
  },
  {
    identifier: "input_12f97833-f738-42bf-8b7e-10b27ae964b9",
    label: "File",
    type: "file",
    validation: {
      required: true
    },
    stages: ["create"]
  }
];
var retrieveTemplatePublicApiV2ResponseValidationsExample = [
  {
    identifier: "69823dd4f18d7435a9c487b1",
    title: "Validacion de Persona",
    description: "Verifica que en la imagen de selfie sea una persona",
    bindings: {
      assets: [
        {
          identifier: "image_b1ac0f90-34d4-4049-a807-a752bb36eb4f",
          type: "image"
        }
      ]
    }
  }
];
var retrieveTemplatePublicApiV2ResponseInferencesExample = [
  {
    identifier: "vehicle_brand",
    title: "Vehicle Brand",
    bindings: {
      assets: [
        {
          type: "image",
          identifier: "image_3416b703-2aad-4beb-9cf1-422b3eeda98f"
        }
      ]
    },
    schema: {
      type: "string",
      title: "Detected Brand"
    }
  }
];
var retrieveTemplatePublicApiV2ResponseBodySchema = import_zod24.default.object({
  _id: import_zod24.default.string().describe("Template ID"),
  name: import_zod24.default.string().describe("Template name"),
  status: import_zod24.default.enum(import_ai_constants16.templateStatus).describe("Template status"),
  createdAt: import_zod24.default.string().datetime().describe("Template creation date"),
  updatedAt: import_zod24.default.string().datetime().describe("Template last update date"),
  publishedAt: import_zod24.default.string().datetime().describe("Template publication date").optional(),
  schema: import_zod24.default.record(import_zod24.default.string(), import_zod24.default.any()).describe("Template assets JSON Schema"),
  assets: assetsSchema,
  validations: import_zod24.default.array(publicSpecTemplateValidationSchema),
  inferences: import_zod24.default.array(publicSpecTemplateInferenceSchema)
});
var retrieveTemplatePublicApiV2ResponseBodyExample = {
  _id: "65f8f2c8a4a5b1c2d3e4f5a6",
  name: "Inspeccion Auto - Produccion",
  status: "published",
  createdAt: "2026-02-17T19:00:00.000Z",
  updatedAt: "2026-02-17T19:30:00.000Z",
  publishedAt: "2026-02-17T19:30:00.000Z",
  schema: retrieveTemplatePublicApiV2ResponseSchemaExample,
  assets: retrieveTemplatePublicApiV2ResponseAssetsExample,
  validations: retrieveTemplatePublicApiV2ResponseValidationsExample,
  inferences: retrieveTemplatePublicApiV2ResponseInferencesExample
};
var listTemplatesPublicApiV2RequestQuerySchema = import_zod24.default.object({
  limit: import_zod24.default.coerce.number().min(1).max(10).default(10),
  page: import_zod24.default.coerce.number().min(1).default(1),
  status: import_zod24.default.enum(import_ai_constants16.templateStatus).optional()
});
var listTemplatesPublicApiV2ResponseBodySchema = import_zod24.default.object({
  data: import_zod24.default.array(
    retrieveTemplatePublicApiV2ResponseBodySchema.omit({
      assets: true,
      inferences: true,
      validations: true,
      schema: true
    })
  ),
  meta: import_zod24.default.object({
    total: import_zod24.default.number().describe("Total number of templates"),
    page: import_zod24.default.number().describe("Current page"),
    limit: import_zod24.default.number().describe("Limit per page"),
    hasMore: import_zod24.default.boolean().describe("If there are more templates to fetch")
  })
});

// src/schemas/public-inspection-v2.ts
var import_ai_constants17 = require("ai-constants");
var import_validator5 = require("validator");
var import_zod25 = __toESM(require("zod"));
var metadataSchema = import_zod25.default.record(import_zod25.default.string().max(50), import_zod25.default.string().max(500)).refine((data) => Object.keys(data).length <= 50, {
  message: "Metadata cannot have more than 50 keys"
});
var createInspectionPublicApiV2ResponseBodySchema = import_zod25.default.object({
  _id: import_zod25.default.string().refine(import_validator5.isMongoId, {
    message: "Invalid inspection id. It should be a 24-character hexadecimal string."
  }),
  magicLink: import_zod25.default.string().nonempty().describe("URL to access the inspection"),
  accessCode: import_zod25.default.string().nonempty().describe("Security code to access the inspection"),
  metadata: metadataSchema,
  status: import_zod25.default.enum(import_ai_constants17.inspectionStatus).describe("Status of the inspection"),
  testing: import_zod25.default.boolean().describe("Whether the inspection was created as a test inspection")
});
var persistedDeclaredAssetSchema = import_zod25.default.discriminatedUnion("type", [
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("text"),
    value: import_zod25.default.string().nonempty()
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("textarea"),
    value: import_zod25.default.string().nonempty()
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("audio"),
    value: import_zod25.default.string().nonempty().describe("File Object ID"),
    url: import_zod25.default.string().nonempty().describe("Presigned URL to access the file")
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("image"),
    value: import_zod25.default.string().nonempty().describe("File Object ID"),
    url: import_zod25.default.string().nonempty().describe("Presigned URL to access the file")
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("video"),
    value: import_zod25.default.string().nonempty().describe("File Object ID"),
    url: import_zod25.default.string().nonempty().describe("Presigned URL to access the file")
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("file"),
    value: import_zod25.default.string().nonempty().describe("File Object ID"),
    url: import_zod25.default.string().nonempty().describe("Presigned URL to access the file")
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("signature"),
    value: import_zod25.default.string().nonempty().describe("File Object ID"),
    url: import_zod25.default.string().nonempty().describe("Presigned URL to access the file")
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("date"),
    value: import_zod25.default.string().nonempty().datetime()
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("select"),
    value: import_zod25.default.string().nonempty()
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("numeric"),
    value: import_zod25.default.number().nonnegative()
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("check"),
    value: import_zod25.default.boolean()
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("multiselect"),
    value: import_zod25.default.array(
      import_zod25.default.object({
        selected: import_zod25.default.string().nonempty()
      })
    )
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("dialogDecision"),
    value: import_zod25.default.boolean()
  }),
  import_zod25.default.object({
    identifier: import_zod25.default.string().nonempty(),
    type: import_zod25.default.literal("checkboxGroup"),
    value: import_zod25.default.array(
      import_zod25.default.object({
        selected: import_zod25.default.string().nonempty()
      })
    )
  })
]);
var validationResults = ["approved", "disapproved"];
var publicInspectionBaseAssetBindingSchema = import_zod25.default.object({
  identifier: import_zod25.default.string().nonempty().describe("Identifier of the asset"),
  type: import_zod25.default.enum(aggregatedAssetTypes).describe("Type of the asset"),
  value: import_zod25.default.string().optional().describe(
    "Declared asset value. Present when needed to disambiguate repeated asset declarations."
  )
});
var publicInspectionAssetBindingSchema = publicInspectionBaseAssetBindingSchema.extend({
  result: import_zod25.default.enum(validationResults).optional().describe(
    "Validation result isolated for this concrete inspection asset declaration when it can be safely determined."
  )
});
var publicInspectionValidationAssetBindingsSchema = import_zod25.default.object({
  assets: import_zod25.default.array(publicInspectionAssetBindingSchema).describe("Assets dependencies of the resource")
}).describe("Dependencies of the resource");
var publicInspectionInferenceAssetBindingsSchema = import_zod25.default.object({
  assets: import_zod25.default.array(publicInspectionBaseAssetBindingSchema).describe("Assets dependencies of the resource")
}).describe("Dependencies of the resource");
var publicInspectionTemplateValidationSchema = publicSpecTemplateValidationSchema.extend({
  bindings: publicInspectionValidationAssetBindingsSchema
});
var publicInspectionValidationSchema = publicInspectionTemplateValidationSchema.extend({
  result: import_zod25.default.enum(validationResults)
});
var publicInspectionInferenceValueSchema = import_zod25.default.union([
  import_zod25.default.string(),
  import_zod25.default.number(),
  import_zod25.default.boolean(),
  import_zod25.default.null(),
  import_zod25.default.array(import_zod25.default.unknown()),
  import_zod25.default.record(import_zod25.default.unknown())
]);
var publicInspectionInferenceSchema = publicSpecTemplateInferenceSchema.extend({
  bindings: publicInspectionInferenceAssetBindingsSchema,
  value: publicInspectionInferenceValueSchema
});
var retrieveInspectionPublicApiV2ResponseBodySchema = createInspectionPublicApiV2ResponseBodySchema.extend({
  createdAt: import_zod25.default.string().datetime(),
  startedAt: import_zod25.default.string().datetime().optional(),
  finishedAt: import_zod25.default.string().datetime().optional(),
  result: import_zod25.default.enum(import_ai_constants17.inspectionResults).describe(
    "Result of the inspection. Only available when the inspection is finished"
  ).optional(),
  validations: import_zod25.default.array(publicInspectionValidationSchema),
  inferences: import_zod25.default.array(publicInspectionInferenceSchema),
  assets: import_zod25.default.array(persistedDeclaredAssetSchema)
});
var inspectionAssetProcessedWebhookPayloadAssetSchema = persistedDeclaredAssetSchema.and(
  import_zod25.default.object({
    validations: import_zod25.default.array(publicInspectionValidationSchema),
    inferences: import_zod25.default.array(publicInspectionInferenceSchema)
  })
);
var inspectionAssetProcessedWebhookPayloadSchema = createInspectionPublicApiV2ResponseBodySchema.extend({
  asset: inspectionAssetProcessedWebhookPayloadAssetSchema
});

// src/schemas/public-webhook-v2.ts
var import_zod_openapi = require("@anatine/zod-openapi");
var import_ai_constants18 = require("ai-constants");
var import_zod26 = __toESM(require("zod"));
var webhookProducerPayloadSchema = import_zod26.default.object({
  companyId: import_zod26.default.string(),
  email: import_zod26.default.string().optional(),
  firstName: import_zod26.default.string().optional(),
  internalId: import_zod26.default.string().optional(),
  lastName: import_zod26.default.string().optional(),
  membershipId: import_zod26.default.string().optional(),
  userId: import_zod26.default.string().optional(),
  username: import_zod26.default.string().optional()
}).passthrough();
var webhookTemplateSummaryPayloadSchema = import_zod26.default.object({
  _id: import_zod26.default.string(),
  name: import_zod26.default.string(),
  type: import_zod26.default.string()
}).passthrough();
var webhookTemplateInputPayloadSchema = import_zod26.default.object({
  identifier: import_zod26.default.string(),
  label: import_zod26.default.string(),
  type: import_zod26.default.string().optional(),
  value: import_zod26.default.unknown().optional()
}).passthrough();
var inspectionStatusWebhookPayloadV1Schema = import_zod26.default.object({
  _id: import_zod26.default.string(),
  magicLink: import_zod26.default.string().optional(),
  metadata: import_zod26.default.record(import_zod26.default.string(), import_zod26.default.unknown()).optional(),
  parentInspectionId: import_zod26.default.string().optional(),
  producer: webhookProducerPayloadSchema,
  status: import_zod26.default.enum(import_ai_constants18.inspectionStatus),
  template: webhookTemplateSummaryPayloadSchema,
  testing: import_zod26.default.boolean(),
  type: import_zod26.default.enum(import_ai_constants18.inspectionTypes)
}).passthrough();
var inspectionImageProcessedItemPayloadSchema = import_zod26.default.object({
  _id: import_zod26.default.string(),
  image: import_zod26.default.object({}).passthrough(),
  type: import_zod26.default.string().optional()
}).passthrough();
var inspectionImageProcessedWebhookPayloadV1Schema = import_zod26.default.object({
  _id: import_zod26.default.string(),
  custom: inspectionImageProcessedItemPayloadSchema.optional(),
  entities: import_zod26.default.array(import_zod26.default.unknown()).optional(),
  identity: inspectionImageProcessedItemPayloadSchema.optional(),
  inspection: import_zod26.default.object({
    image: import_zod26.default.object({}).passthrough()
  }).passthrough().optional(),
  metadata: import_zod26.default.record(import_zod26.default.string(), import_zod26.default.unknown()).optional(),
  producer: webhookProducerPayloadSchema,
  product: inspectionImageProcessedItemPayloadSchema.optional(),
  scope: import_zod26.default.enum(import_ai_constants18.assetTargets),
  template: webhookTemplateSummaryPayloadSchema,
  testing: import_zod26.default.boolean(),
  type: import_zod26.default.enum(import_ai_constants18.inspectionTypes)
}).passthrough();
var inspectionGlobalValidationWebhookPayloadV1Schema = import_zod26.default.object({
  _id: import_zod26.default.string(),
  description: import_zod26.default.string(),
  name: import_zod26.default.string(),
  valid: import_zod26.default.boolean()
}).passthrough();
var inspectionContextSectionWebhookPayloadV1Schema = import_zod26.default.object({
  extraImages: import_zod26.default.array(import_zod26.default.object({}).passthrough()).optional(),
  images: import_zod26.default.array(import_zod26.default.object({}).passthrough()).optional(),
  inputs: import_zod26.default.array(webhookTemplateInputPayloadSchema).optional()
}).passthrough();
var inspectionProductWebhookPayloadV1Schema = import_zod26.default.object({
  _id: import_zod26.default.string(),
  extraImages: import_zod26.default.array(import_zod26.default.object({}).passthrough()).optional(),
  images: import_zod26.default.array(import_zod26.default.object({}).passthrough()).optional(),
  inputs: import_zod26.default.array(webhookTemplateInputPayloadSchema).optional(),
  type: import_zod26.default.string()
}).passthrough();
var inspectionCompletedWebhookPayloadV1Schema = import_zod26.default.object({
  _id: import_zod26.default.string(),
  completedBy: import_zod26.default.enum(import_ai_constants18.inspectionCompletedBy).optional(),
  custom: inspectionContextSectionWebhookPayloadV1Schema.optional(),
  functions: import_zod26.default.array(import_zod26.default.unknown()).optional(),
  globalValidations: import_zod26.default.array(inspectionGlobalValidationWebhookPayloadV1Schema).optional(),
  identity: inspectionContextSectionWebhookPayloadV1Schema.optional(),
  metadata: import_zod26.default.record(import_zod26.default.string(), import_zod26.default.unknown()).optional(),
  producer: webhookProducerPayloadSchema,
  products: import_zod26.default.array(inspectionProductWebhookPayloadV1Schema).optional(),
  status: import_zod26.default.enum(import_ai_constants18.inspectionStatus),
  template: webhookTemplateSummaryPayloadSchema.extend({
    inputs: import_zod26.default.array(webhookTemplateInputPayloadSchema).optional()
  }).passthrough(),
  testing: import_zod26.default.boolean(),
  type: import_zod26.default.enum(import_ai_constants18.inspectionTypes),
  variables: import_zod26.default.array(import_zod26.default.unknown()).optional(),
  veredict: import_zod26.default.enum(import_ai_constants18.inspectionResults)
}).passthrough();
var buildWebhookEventSchema = ({
  description,
  event,
  example,
  payloadSchema,
  title
}) => (0, import_zod_openapi.extendApi)(
  import_zod26.default.object({
    event: import_zod26.default.literal(event),
    payload: payloadSchema
  }),
  {
    title,
    description,
    example
  }
);
var inspectionCompletedWebhookPayloadV1Example = {
  _id: "65f8f73aa4a5b1c2d3e4f5f0",
  metadata: {
    policy_id: "POL-10021"
  },
  producer: {
    companyId: "65f8f2c8a4a5b1c2d3e4f5a6",
    internalId: "user_240"
  },
  status: "completed",
  template: {
    _id: "65f8f2c8a4a5b1c2d3e4f5a6",
    name: "Inspecci\xF3n vehicular",
    type: "car"
  },
  testing: false,
  type: "car",
  veredict: "approved"
};
var inspectionCompletedWebhookPayloadV2Example = {
  _id: "65f8f73aa4a5b1c2d3e4f5f0",
  magicLink: "https://app.autoinspector.ai/inspection/65f8f73aa4a5b1c2d3e4f5f0",
  accessCode: "381144",
  metadata: {
    policy_id: "POL-10021",
    external_claim_id: "CLM-92811"
  },
  status: "completed",
  testing: false,
  createdAt: "2025-03-01T10:00:00.000Z",
  startedAt: "2025-03-01T10:05:00.000Z",
  finishedAt: "2025-03-01T10:20:00.000Z",
  result: "approved",
  validations: [
    {
      identifier: "validation_plate",
      title: "Patente v\xE1lida",
      description: "Valida formato de la patente",
      bindings: {
        assets: [
          {
            identifier: "input_vehicle_plate",
            type: "text"
          }
        ]
      },
      result: "approved"
    }
  ],
  inferences: [
    {
      identifier: "inference_damage_score",
      title: "Puntaje de da\xF1o",
      bindings: {
        assets: [
          {
            identifier: "input_vehicle_plate",
            type: "text"
          }
        ]
      },
      schema: {
        type: "number"
      },
      value: 0.12
    }
  ],
  assets: [
    {
      identifier: "input_vehicle_plate",
      type: "text",
      value: "AB123CD"
    }
  ]
};
var inspectionAssetProcessedWebhookPayloadV2Example = {
  _id: "65f8f73aa4a5b1c2d3e4f5f0",
  magicLink: "https://app.autoinspector.ai/inspection/65f8f73aa4a5b1c2d3e4f5f0",
  accessCode: "381144",
  metadata: {
    sinister_id: "1234567890",
    policy_id: "5912"
  },
  status: "started",
  testing: true,
  asset: {
    identifier: "image_1",
    type: "image",
    value: "65f8f73aa4a5b1c2d3e4f5f1",
    url: "https://files.autoinspector.example/65f8f73aa4a5b1c2d3e4f5f1",
    validations: [
      {
        identifier: "validation_plate",
        title: "Patente v\xE1lida",
        description: "Valida formato de la patente",
        bindings: {
          assets: [
            {
              identifier: "image_1",
              type: "image"
            }
          ]
        },
        result: "approved"
      }
    ],
    inferences: [
      {
        identifier: "patente",
        title: "Patente",
        bindings: {
          assets: [
            {
              identifier: "image_1",
              type: "image"
            }
          ]
        },
        schema: {
          type: "number"
        },
        value: "AB123CD"
      }
    ]
  }
};
var inspectionCreatedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "inspection_created",
  example: {
    event: "inspection_created",
    payload: {
      _id: "651ae032ff786d198dfa4ce4",
      status: "created",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "John",
        lastName: "Doe",
        username: "johndoe",
        email: "johndoe@gmail.com"
      },
      type: "car",
      metadata: {
        my_custom_key: "my_custom_value"
      },
      testing: false,
      template: {
        name: "easy",
        type: "built-in",
        _id: "62be865212ca0918bcabf2a5"
      },
      magicLink: "https://app.autoinspector.ai/inspection/651ae032ff786d198dfa4ce4?accessCode=5087"
    }
  },
  payloadSchema: inspectionStatusWebhookPayloadV1Schema,
  title: "Inspection Created v1",
  description: "When an inspection is created."
});
var childrenInspectionCreatedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "children_inspection_created",
  example: {
    event: "children_inspection_created",
    payload: {
      _id: "657b2dc8fa2a696fcd56946b",
      parentInspectionId: "657b1a7d2f1446f1b9ee0552",
      status: "created",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "Luciano",
        username: "lcnlvrzz",
        email: "lucianoalvarez1212@gmail.com",
        lastName: "Alvarez"
      },
      type: "car",
      metadata: {
        templateId: "657b17d89b8f27657c96c315",
        parentInspectionId: "657b1a7d2f1446f1b9ee0552"
      },
      testing: false,
      template: {
        name: "UNIQUE AUTO CUSTOM",
        type: "created",
        _id: "657b17d89b8f27657c96c315"
      },
      magicLink: "https://app.autoinspector.ai/inspection/651ae032ff786d198dfa4ce4?accessCode=5087"
    }
  },
  payloadSchema: inspectionStatusWebhookPayloadV1Schema,
  title: "Children Inspection Created v1",
  description: "When an inspection is recreated from an expired inspection."
});
var inspectionStartedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "inspection_started",
  example: {
    event: "inspection_started",
    payload: {
      _id: "651ae032ff786d198dfa4ce4",
      status: "started",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "John",
        lastName: "Doe",
        username: "johndoe",
        email: "johndoe@gmail.com"
      },
      type: "car",
      metadata: {
        my_custom_key: "my_custom_value"
      },
      testing: false,
      template: {
        name: "easy",
        type: "built-in",
        _id: "62be865212ca0918bcabf2a5"
      }
    }
  },
  payloadSchema: inspectionStatusWebhookPayloadV1Schema,
  title: "Inspection Started v1",
  description: "When an inspection is started by the user."
});
var inspectionImageProcessedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "image_processed",
  example: {
    event: "image_processed",
    payload: {
      _id: "651ae032ff786d198dfa4ce4",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "John",
        lastName: "Doe",
        username: "johndoe",
        email: "johndoe@gmail.com"
      },
      type: "car",
      metadata: {
        my_custom_key: "my_custom_value"
      },
      testing: false,
      template: {
        name: "easy",
        type: "built-in",
        _id: "62be865212ca0918bcabf2a5"
      },
      entities: [],
      scope: "product",
      product: {
        _id: "651ae032ff786d198dfa4cf1",
        image: {
          entities: [],
          templateImageIdentifier: "image_3e1153f3-66fa-4463-973a-fe277894c9df",
          type: "normal",
          target: "product",
          side: "back",
          processed: true,
          uploadedAt: "2023-10-02T15:29:53.000Z",
          _id: "651ae1f2ff786d198dfa4e20",
          validations: [
            {
              confidence: 99.99993896484375,
              identifier: "candidate_96b69c40-5ef9-46c3-899e-e0ed37ee6d02",
              valid: true,
              validation: "object",
              required: true
            },
            {
              confidence: 95.7,
              identifier: "candidate_04f8f69c-d817-4fe2-b3f8-64ba09f7ebd0",
              valid: true,
              validation: "make",
              required: true
            },
            {
              confidence: 95.7,
              identifier: "candidate_2a66f6bc-77a7-44f3-aea7-bdd4b24c4cce",
              valid: true,
              validation: "model",
              required: true
            },
            {
              confidence: 99,
              identifier: "candidate_b8848e93-1c11-4876-9869-9adaa1f4ab6e",
              valid: true,
              validation: "plate",
              required: true
            },
            {
              confidence: 90,
              identifier: "candidate_696f64c3-b8fe-4382-9905-b539540b709f",
              valid: true,
              validation: "domain",
              required: true
            },
            {
              confidence: 92.80000000000001,
              identifier: "candidate_cd9227dc-3dd3-4f7d-be35-2d139e84cd4d",
              valid: true,
              validation: "angle",
              required: true
            },
            {
              confidence: 99.98935461044312,
              identifier: "candidate_81f1306b-b904-4afa-a1e5-f183a2d040c5",
              valid: true,
              validation: "color",
              required: true
            },
            {
              confidence: 99.99420642852783,
              identifier: "candidate_371b8a6f-b459-412a-8586-fb9af15b90eb",
              valid: true,
              validation: "complete",
              required: true
            },
            {
              confidence: 100,
              identifier: "candidate_d191cd50-5ed7-4b11-88b3-6f35dc5677dd",
              valid: true,
              validation: "date",
              required: false
            },
            {
              confidence: 100,
              identifier: "candidate_328142df-4e12-4009-9774-291266500358",
              valid: true,
              validation: "distance",
              required: false
            },
            {
              confidence: 98.23,
              identifier: "candidate_e16b1d8d-016c-4174-8d5f-9f5ce28f0369",
              valid: true,
              validation: "recaptured",
              required: false
            },
            {
              confidence: 100,
              identifier: "candidate_0665678c-4c72-4c45-b2e1-37c9b6ff4ce4",
              valid: false,
              validation: "damage",
              required: false
            }
          ],
          approved: true,
          src: "https://ai-inspections.s3.amazonaws.com/back-1696260591720.jpeg",
          damages: [
            {
              part: "trunk",
              percentage: 1.97,
              damage: "dent"
            }
          ]
        }
      }
    }
  },
  payloadSchema: inspectionImageProcessedWebhookPayloadV1Schema,
  title: "Image Processed v1",
  description: "When an image is processed and its validations have been executed."
});
var inspectionBlockedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "inspection_blocked",
  example: {
    event: "inspection_blocked",
    payload: {
      _id: "651ae032ff786d198dfa4ce4",
      status: "blocked",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "John",
        lastName: "Doe",
        username: "johndoe",
        email: "johndoe@gmail.com"
      },
      type: "car",
      metadata: {
        my_custom_key: "my_custom_value"
      },
      testing: false,
      template: {
        name: "easy",
        type: "built-in",
        _id: "62be865212ca0918bcabf2a5"
      }
    }
  },
  payloadSchema: inspectionStatusWebhookPayloadV1Schema,
  title: "Inspection Blocked v1",
  description: "When an inspection gets blocked."
});
var inspectionAssetProcessedWebhookEventPayloadV2Schema = buildWebhookEventSchema({
  event: "inspection_asset_processed",
  example: {
    event: "inspection_asset_processed",
    payload: inspectionAssetProcessedWebhookPayloadV2Example
  },
  payloadSchema: inspectionAssetProcessedWebhookPayloadSchema,
  title: "Inspection Asset Processed v1",
  description: "When an inspection asset declaration finishes its individual processing lifecycle"
});
var inspectionCompletedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "inspection_completed",
  example: {
    event: "inspection_completed",
    payload: inspectionCompletedWebhookPayloadV1Example
  },
  payloadSchema: inspectionCompletedWebhookPayloadV1Schema,
  title: "Inspection Completed v1",
  description: "When an inspection is completed and has a final veredict in API version v1 format."
});
var inspectionReviewedWebhookEventPayloadV1Schema = buildWebhookEventSchema({
  event: "inspection_reviewed",
  example: {
    event: "inspection_reviewed",
    payload: {
      _id: "646ee7dc5b7220a2e2ed76b8",
      status: "completed",
      producer: {
        userId: "61478404b9a70800551878b6",
        membershipId: "61c28b777b0c420012bd4a68",
        companyId: "6147843bb9a70800551878bd",
        firstName: "John",
        lastName: "Doe",
        username: "johndoe",
        email: "johndoe@gmail.com"
      },
      metadata: {
        my_custom_key: "my_custom_value"
      },
      testing: false,
      template: {
        _id: "62be865212ca0918bcabf2a5",
        name: "easy",
        type: "built-in",
        inputs: [
          {
            identifier: "input_bf5dd369-3a82-4b0d-b8be-5186da9c07c7",
            label: "Nombre",
            value: "John"
          },
          {
            identifier: "input_db30b856-594e-4799-9ee9-2dacfbe2a338",
            label: "Apellido",
            value: "Doe"
          },
          {
            identifier: "input_79519a40-3047-48c4-b8db-5c95c8b5166a",
            label: "Identificaci\xF3n",
            value: "44188219"
          },
          {
            identifier: "input_1b00981a-1484-4f53-8702-2a6d43fd6662",
            label: "Email",
            value: "johndoe@gmail.com"
          },
          {
            identifier: "input_79bdb79b-c3d4-40d5-905e-bdaf1f1e02cb",
            label: "Ciudad",
            value: "testing"
          },
          {
            identifier: "input_a00ae5cb-e633-4b9a-98b8-863eeac96e5c",
            label: "Pa\xEDs",
            value: "AR"
          },
          {
            identifier: "input_53ca83e7-413a-4435-9c2f-8206630142a8",
            label: "Provincia",
            value: "T"
          },
          {
            identifier: "input_21de8e3a-87c9-474a-9f10-a4dc9ecbf083",
            label: "Sexo",
            value: "male"
          },
          {
            identifier: "input_25dd4378-395d-4fe6-8306-65dcead884b0",
            label: "Nacimiento",
            value: "2002-06-19T00:00:00.000Z"
          },
          {
            identifier: "input_3f8023b1-2062-4679-b455-f69a1211af1e",
            label: "Direcci\xF3n",
            value: "testing 100"
          },
          {
            identifier: "input_f2aaa964-9944-4d04-b86c-33044d00fef6",
            label: "Tel\xE9fono",
            value: "03813635420"
          },
          {
            identifier: "input_35c6a25f-6407-4755-a225-47d72bc02530",
            label: "Patente",
            value: "AZ204SU"
          },
          {
            identifier: "input_9f7a5106-09ae-49ab-a58a-b28952725ce0",
            label: "A\xF1o",
            value: 2020
          },
          {
            identifier: "input_e7f39d45-cf28-422f-a643-4f6e81127065",
            label: "Color",
            value: "grey"
          },
          {
            identifier: "input_23fa1c2b-b87f-4780-92d8-f8665f21288b",
            label: "Uso",
            value: "PRIVADO"
          },
          {
            identifier: "input_8e20f135-42b9-42cc-9ab5-abc4d32cdea3",
            label: "Marca",
            value: "JEEP"
          },
          {
            identifier: "input_0f2e6fb5-ca87-480a-984f-0afa54d5f924",
            label: "Modelo",
            value: "RENEGADE"
          }
        ]
      },
      veredict: "approved",
      type: "car",
      completedBy: "client",
      identity: {
        images: [
          {
            validations: [
              {
                validation: "date",
                _id: "62cd9215ecac9905ccf303d5",
                confidence: 100,
                valid: true
              },
              {
                validation: "distance",
                _id: "62cd9215ecac9905ccf303d6",
                confidence: 100,
                valid: true
              },
              {
                validation: "recaptured",
                _id: "62cd9215ecac9905ccf303d7",
                confidence: 95.01,
                valid: true
              },
              {
                validation: "face_comparison",
                _id: "62cd9215ecac9905ccf303d8",
                confidence: 100,
                valid: true
              }
            ],
            entities: [
              {
                entity: "passport",
                valid: true,
                result: {
                  sex: "M",
                  surname: "CASTILLO",
                  givenNames: "JUAN PABLO",
                  nationality: "ARGENTINA",
                  dateOfBirth: "21 FEB/FEB 87",
                  placeOfBirth: "ARG",
                  dateOfIssue: "13 JUN/JUN 16",
                  dateOfExpiry: "13 JUN/JUN 26",
                  personalNumber: "32815355",
                  authority: "RENAPER",
                  documentNumber: "AAE054537",
                  issuingCountry: "ARG"
                }
              }
            ],
            damages: [],
            side: "pasaporte",
            processed: true,
            uploadedAt: "2022-07-12T15:22:56.000Z",
            _id: "62cd920cecac9905ccf3032d",
            approved: true,
            src: "https://ai-inspections.s3.amazonaws.com/pasaporte-1657639433699.jpeg",
            target: "identity"
          },
          {
            validations: [
              {
                validation: "date",
                _id: "62cd9215ecac9905ccf303d5",
                confidence: 100,
                valid: true
              },
              {
                validation: "distance",
                _id: "62cd9215ecac9905ccf303d6",
                confidence: 100,
                valid: true
              },
              {
                validation: "recaptured",
                _id: "62cd9215ecac9905ccf303d7",
                confidence: 95.01,
                valid: true
              },
              {
                validation: "face_comparison",
                _id: "62cd9215ecac9905ccf303d8",
                confidence: 100,
                valid: true
              },
              {
                validation: "birthdate",
                _id: "62cd9215ecac9905ccf303d9",
                confidence: 100,
                valid: false
              },
              {
                validation: "dni",
                _id: "62cd9215ecac9905ccf303db",
                confidence: 100,
                valid: true
              },
              {
                validation: "full_name",
                _id: "62cd9215ecac9905ccf303de",
                confidence: 100,
                valid: true
              },
              {
                validation: "sex",
                _id: "62cd9215ecac9905ccf303e0",
                confidence: 100,
                valid: true
              },
              {
                validation: "age",
                _id: "62cd9215ecac9905ccf303e2",
                confidence: 100,
                valid: false
              },
              {
                validation: "object",
                _id: "62cd9215ecac9905ccf303e3",
                confidence: 98.41889953613281,
                valid: true
              }
            ],
            damages: [],
            side: "dni",
            processed: true,
            uploadedAt: "2022-07-12T15:23:56.000Z",
            _id: "62cd920cecac9905ccf3039d",
            approved: true,
            src: "https://ai-inspections.s3.amazonaws.com/dni-1657639433699.jpeg",
            target: "identity"
          },
          {
            validations: [
              {
                validation: "date",
                _id: "62cd9210ecac9905ccf303bd",
                confidence: 100,
                valid: true
              },
              {
                validation: "distance",
                _id: "62cd9210ecac9905ccf303be",
                confidence: 100,
                valid: true
              },
              {
                validation: "recaptured",
                _id: "62cd9210ecac9905ccf303bf",
                confidence: 99.95,
                valid: true
              },
              {
                validation: "age",
                _id: "62cd9210ecac9905ccf303c0",
                confidence: 99.99873352050781,
                valid: true
              },
              {
                validation: "face_comparison",
                _id: "62cd9210ecac9905ccf303c1",
                confidence: 0,
                valid: false
              },
              {
                validation: "object",
                _id: "62cd9210ecac9905ccf303c2",
                confidence: 99.8077163696289,
                valid: true
              }
            ],
            damages: [],
            side: "selfie",
            processed: true,
            uploadedAt: "2022-07-12T15:23:56.000Z",
            _id: "62cd920cecac9905ccf303a7",
            approved: true,
            src: "https://ai-inspections.s3.amazonaws.com/selfie-1657639435560.jpeg",
            target: "identity"
          }
        ],
        extraImages: [],
        email: "lucianoalvarez1212@gmail.com",
        firstName: "Luciano",
        identification: "44188219",
        lastName: "Alvarez"
      },
      custom: {
        images: [],
        inputs: [
          {
            label: "Seleccione los accesorios que desea asegurar",
            type: "multiselect",
            identifier: "input_525a71d5-3e1d-47e3-b2f5-1238d33190be",
            value: [
              {
                selected: "Llantas especiales"
              },
              {
                selected: "Radio"
              }
            ]
          }
        ],
        extraImages: []
      },
      products: [
        {
          type: "car",
          car: {
            plate: "AZ204SU",
            color: "grey",
            make: "JEEP",
            model: "RENEGADE",
            use: "PRIVADO",
            year: 2020
          },
          _id: "646ee7dd5b7220a2e2ed76c5",
          extraImages: [],
          inputs: [],
          images: [
            {
              templateImageIdentifier: "image_3e1153f3-66fa-4463-973a-fe277894c9df",
              type: "normal",
              target: "product",
              side: "back",
              processed: true,
              uploadedAt: "2023-05-25T04:46:40.000Z",
              _id: "646ee8305b7220a2e2ed7718",
              validations: [
                {
                  confidence: 99.99993896484375,
                  identifier: "candidate_2b136747-6293-4fe8-abf5-1532a7d97581",
                  valid: true,
                  validation: "object",
                  required: true
                },
                {
                  confidence: 95.7,
                  identifier: "candidate_df69203b-a9f1-4225-bfbb-5df5198b806f",
                  valid: true,
                  validation: "make",
                  required: true
                },
                {
                  confidence: 95.7,
                  identifier: "candidate_20168d44-92b5-4e71-967d-7dbddf042718",
                  valid: true,
                  validation: "model",
                  required: true
                },
                {
                  confidence: 99,
                  identifier: "candidate_f2249ef8-8360-4b35-b8f7-c941dfd9a3ba",
                  valid: true,
                  validation: "plate",
                  required: true
                },
                {
                  confidence: 90,
                  identifier: "candidate_228671dc-c9a2-48d9-b3f0-632f362fc136",
                  valid: true,
                  validation: "domain",
                  required: true
                },
                {
                  confidence: 92.80000000000001,
                  identifier: "candidate_3e18a4b3-7b1d-4cd5-bf69-22dfc5e6f37a",
                  valid: true,
                  validation: "angle",
                  required: true
                },
                {
                  confidence: 99.98935461044312,
                  identifier: "candidate_0748121d-42b8-40f3-8889-90d88cbdf17f",
                  valid: true,
                  validation: "color",
                  required: true
                },
                {
                  confidence: 99.99420642852783,
                  identifier: "candidate_2514b86c-6ba6-4c4f-8eb1-450090ceb819",
                  valid: true,
                  validation: "complete",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_4bb107a9-9c46-430f-835f-541650635caf",
                  valid: true,
                  validation: "date",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_028b92d5-a8cc-4c6e-85fa-220c2927687b",
                  valid: true,
                  validation: "distance",
                  required: false
                },
                {
                  confidence: 98.23,
                  identifier: "candidate_c65a8d0c-62c1-4732-9317-b08237fce958",
                  valid: true,
                  validation: "recaptured",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_c40b3705-64e8-4faa-9648-bea7df4e8389",
                  valid: false,
                  validation: "damage",
                  required: false
                }
              ],
              approved: true,
              src: "https://ai-inspections.s3.amazonaws.com/back-1684989998800.jpeg",
              damages: [
                {
                  part: "trunk",
                  percentage: 1.97,
                  damage: "dent"
                }
              ]
            },
            {
              templateImageIdentifier: "image_69c8e668-7c20-489e-ace8-74d4d5cc833a",
              type: "normal",
              target: "product",
              side: "front",
              processed: true,
              uploadedAt: "2023-05-25T04:46:44.000Z",
              _id: "646ee8345b7220a2e2ed7769",
              validations: [
                {
                  confidence: 99.80770111083984,
                  identifier: "candidate_18276ec7-7502-4ed4-a067-f54f745bb50e",
                  valid: true,
                  validation: "object",
                  required: true
                },
                {
                  confidence: 92.5,
                  identifier: "candidate_2b58b84d-ff4b-4cf1-9615-7f735659de17",
                  valid: true,
                  validation: "make",
                  required: true
                },
                {
                  confidence: 92.5,
                  identifier: "candidate_fa7b952a-cd6a-449c-ba1d-8106e522de41",
                  valid: true,
                  validation: "model",
                  required: true
                },
                {
                  confidence: 99,
                  identifier: "candidate_e7a7b281-2bbc-4b8b-b76f-9acc13f5000f",
                  valid: true,
                  validation: "plate",
                  required: true
                },
                {
                  confidence: 89.7,
                  identifier: "candidate_ef42b770-1721-410e-ae77-93b0fa5c1028",
                  valid: true,
                  validation: "domain",
                  required: true
                },
                {
                  confidence: 90.9,
                  identifier: "candidate_ce035a0a-9d75-4bcd-94bc-b10d806d67c9",
                  valid: true,
                  validation: "angle",
                  required: true
                },
                {
                  confidence: 0.14095206279307604,
                  identifier: "candidate_0ba18bf2-075e-45d0-988a-64a7c9d21b3c",
                  valid: true,
                  validation: "color",
                  required: true
                },
                {
                  confidence: 96.16938829421997,
                  identifier: "candidate_cae171db-1b0a-4351-8bca-052517c31703",
                  valid: true,
                  validation: "complete",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_b2fb826a-06b2-4d82-a9f6-a8a0dd700804",
                  valid: true,
                  validation: "date",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_a7bef5c9-f877-4928-94f4-6417c277395b",
                  valid: true,
                  validation: "distance",
                  required: false
                },
                {
                  confidence: 97.65,
                  identifier: "candidate_36812f63-4a21-492c-9e56-9b3a8426c629",
                  valid: true,
                  validation: "recaptured",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_470dd1b6-c020-44e2-99ea-018decba540d",
                  valid: true,
                  validation: "damage",
                  required: false
                }
              ],
              approved: true,
              src: "https://ai-inspections.s3.amazonaws.com/front-1684990002943.jpeg",
              damages: []
            },
            {
              templateImageIdentifier: "image_36d5963f-c1c3-4f81-86dd-cf26e7e2d965",
              type: "normal",
              target: "product",
              side: "sideLeft",
              processed: true,
              uploadedAt: "2023-05-25T04:46:49.000Z",
              _id: "646ee83a5b7220a2e2ed7779",
              validations: [
                {
                  confidence: 99.4636001586914,
                  identifier: "candidate_cdf7cdf8-b74e-41eb-add0-edbbbb272520",
                  valid: true,
                  validation: "object",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_dbf52417-c8d3-4c1f-b680-e470c8fe79c0",
                  valid: true,
                  validation: "date",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_e8a20066-c99e-48aa-9914-c62a863cc90e",
                  valid: true,
                  validation: "distance",
                  required: false
                },
                {
                  confidence: 99.24,
                  identifier: "candidate_37c278f8-0561-43a9-94b9-b08c118d3ddb",
                  valid: false,
                  validation: "recaptured",
                  required: false
                },
                {
                  confidence: 47.30112850666046,
                  identifier: "candidate_e42c0c0e-61ee-4b16-b6f8-721dc0ef46ad",
                  valid: true,
                  validation: "angle",
                  required: true
                },
                {
                  confidence: 20.524100959300995,
                  identifier: "candidate_7045b92f-fc79-4984-92b1-7fb7524b7754",
                  valid: true,
                  validation: "color",
                  required: true
                },
                {
                  confidence: 99.16438460350037,
                  identifier: "candidate_8f4c77aa-0553-4541-9a96-c55945b02975",
                  valid: true,
                  validation: "complete",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_38cdd9f1-c4a5-4470-ac50-aa918ee253f5",
                  valid: true,
                  validation: "damage",
                  required: false
                }
              ],
              approved: true,
              src: "https://ai-inspections.s3.amazonaws.com/sideleft-1684990007888.jpeg",
              damages: []
            },
            {
              templateImageIdentifier: "image_44849b74-b3a7-4914-9bf5-180a04e27e44",
              type: "normal",
              target: "product",
              side: "sideRight",
              processed: true,
              uploadedAt: "2023-05-25T04:46:52.000Z",
              _id: "646ee83c5b7220a2e2ed7793",
              validations: [
                {
                  confidence: 99.34487915039062,
                  identifier: "candidate_fff0264f-6540-41ab-a96a-a98569c96153",
                  valid: true,
                  validation: "object",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_c8b9bf42-a4ba-4709-ac99-acd58e02b22b",
                  valid: true,
                  validation: "date",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_54faadcc-b7c5-4f87-9cfd-7fe5aa071a5b",
                  valid: true,
                  validation: "distance",
                  required: false
                },
                {
                  confidence: 96.16,
                  identifier: "candidate_b3d3f3b7-17c6-4323-a120-63328ec9fe8f",
                  valid: true,
                  validation: "recaptured",
                  required: false
                },
                {
                  confidence: 99.29338693618774,
                  identifier: "candidate_dc40f817-3483-4d1d-8bbd-46f9b1bb823e",
                  valid: true,
                  validation: "angle",
                  required: true
                },
                {
                  confidence: 98.33864569664001,
                  identifier: "candidate_b5982ae4-3441-4b97-b598-2a45618d97d1",
                  valid: true,
                  validation: "color",
                  required: true
                },
                {
                  confidence: 68.27582120895386,
                  identifier: "candidate_56c5c0f4-dbcf-42c0-9d67-306795251c45",
                  valid: true,
                  validation: "complete",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_607dee9e-672d-43b6-83e8-f52cd6080697",
                  valid: true,
                  validation: "damage",
                  required: false
                }
              ],
              approved: true,
              src: "https://ai-inspections.s3.amazonaws.com/sideright-1684990010964.jpeg",
              damages: []
            },
            {
              templateImageIdentifier: "image_b7118054-16af-4fe8-b6ec-7bf216a553cf",
              type: "normal",
              target: "product",
              side: "id",
              processed: true,
              uploadedAt: "2023-05-25T04:46:56.000Z",
              _id: "646ee8405b7220a2e2ed77aa",
              validations: [
                {
                  confidence: 93.64836120605469,
                  identifier: "candidate_e610ab3e-ed99-4d37-baab-f17f6abd1cab",
                  valid: true,
                  validation: "object",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_8b4d60a7-8966-4c29-b4cb-976ec0ec2ab3",
                  valid: true,
                  validation: "model",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_9eef5161-9344-45a8-b313-37400bb30a79",
                  valid: true,
                  validation: "make",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_d6d80bb8-6edb-4d0e-9aee-7f653ee8a4ee",
                  valid: true,
                  validation: "use",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_ea2175cf-4d2d-4818-a25f-1028f35a52a8",
                  valid: true,
                  validation: "domain",
                  required: true
                },
                {
                  confidence: 100,
                  identifier: "candidate_ec46c9eb-fdf8-4427-9b7b-df20d9a098de",
                  valid: true,
                  validation: "vin",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_5f059ca8-6b97-4d27-9cd8-2ca08f72624a",
                  valid: true,
                  validation: "date",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_a33e7367-b037-4197-b8d6-95ba0c78ccea",
                  valid: true,
                  validation: "distance",
                  required: false
                },
                {
                  confidence: 100,
                  identifier: "candidate_3a25a739-7697-4ba0-a249-9f70fb2b5e44",
                  valid: true,
                  validation: "recaptured",
                  required: false
                }
              ],
              approved: true,
              src: "https://ai-inspections.s3.amazonaws.com/id-1684990015188.jpeg",
              damages: []
            }
          ]
        }
      ]
    }
  },
  payloadSchema: inspectionCompletedWebhookPayloadV1Schema,
  title: "Inspection Reviewed v1",
  description: "When a completed inspection has been reviewed and changed in API version v1 format."
});
var inspectionCompletedWebhookEventPayloadV2Schema = buildWebhookEventSchema({
  event: "inspection_completed",
  example: {
    event: "inspection_completed",
    payload: inspectionCompletedWebhookPayloadV2Example
  },
  payloadSchema: retrieveInspectionPublicApiV2ResponseBodySchema,
  title: "Inspection Completed v2",
  description: "When an inspection is completed and have a result. At this stage assets, inferences and validations were computed."
});
var inspectionClientCompletedPayloadV2Schema = retrieveInspectionPublicApiV2ResponseBodySchema.pick({
  _id: true,
  status: true,
  testing: true,
  createdAt: true,
  startedAt: true,
  finishedAt: true
}).extend({
  metadata: import_zod26.default.record(import_zod26.default.string(), import_zod26.default.string()).describe("Customer-defined inspection metadata")
}).describe(
  "Minimal inspection information available at the moment the user finishes the inspection from Autoinspector App"
);
var inspectionClientCompletedPayloadV2Example = {
  _id: "65f8f73aa4a5b1c2d3e4f5f0",
  metadata: {
    policy_id: "POL-10021",
    external_claim_id: "CLM-92811"
  },
  status: "processing",
  testing: false,
  createdAt: "2025-03-01T10:00:00.000Z",
  startedAt: "2025-03-01T10:05:00.000Z",
  finishedAt: "2025-03-01T10:20:00.000Z"
};
var inspectionClientCompletedEventV2Schema = buildWebhookEventSchema({
  event: "inspection_client_completed",
  example: {
    event: "inspection_client_completed",
    payload: inspectionClientCompletedPayloadV2Example
  },
  payloadSchema: inspectionClientCompletedPayloadV2Schema,
  title: "Inspection Client Completed v2",
  description: "When the user finishes the inspection from Autoinspector App. Assets, inferences and validations are not processed yet at this stage; subscribe to inspection_completed to receive them. The same payload is emitted to the host application when Autoinspector App is embedded in an iframe or a native WebView."
});
var inspectionClientCompletionResponseBody = import_zod26.default.discriminatedUnion(
  "state",
  [
    import_zod26.default.object({ state: import_zod26.default.literal("waiting") }),
    import_zod26.default.object({
      state: import_zod26.default.literal("completed"),
      hostBridgeEvent: inspectionClientCompletedEventV2Schema
    }),
    import_zod26.default.object({ state: import_zod26.default.literal("stopped") })
  ]
);
var inspectionLinkStatusUpdatedWebhookDeliverySchema = import_zod26.default.object({
  channel: import_zod26.default.enum(["email", "whatsapp", "sms"]).describe("Delivery channel used to send the inspection link"),
  recipient: import_zod26.default.string().optional().describe("Recipient address or phone number for the delivery channel"),
  status: import_zod26.default.enum([
    "sent",
    "delivered",
    "opened",
    "failed",
    "unsent",
    "reattempt_scheduled"
  ]).describe("Normalized delivery status for the inspection link"),
  source: import_zod26.default.enum(["initializer", "reminder", "manual", "fallback"]).optional().describe("Origin that triggered the inspection link delivery"),
  updatedAt: import_zod26.default.string().datetime().describe("Timestamp when the delivery status was registered")
}).describe("Normalized inspection link delivery status");
var inspectionLinkStatusUpdatedWebhookPayloadSchema = import_zod26.default.object({
  _id: import_zod26.default.string().describe("Inspection ID"),
  magicLink: import_zod26.default.string().describe("URL to access the inspection"),
  accessCode: import_zod26.default.string().describe("Security code to access the inspection"),
  metadata: import_zod26.default.record(import_zod26.default.string(), import_zod26.default.string()).describe("Customer-defined inspection metadata"),
  status: import_zod26.default.enum(import_ai_constants18.inspectionStatus).describe("Status of the inspection"),
  testing: import_zod26.default.boolean().describe("Whether the inspection was created as a test inspection"),
  delivery: inspectionLinkStatusUpdatedWebhookDeliverySchema.describe(
    "Delivery status update that triggered the webhook"
  )
}).describe("Inspection and normalized delivery status information");
var inspectionLinkStatusUpdatedWebhookEventSchema = import_zod26.default.object({
  event: import_zod26.default.literal("inspection_link_status_updated").describe("Webhook event type"),
  payload: inspectionLinkStatusUpdatedWebhookPayloadSchema.describe(
    "Inspection link status update payload"
  )
});
var inspectionLinkStatusUpdatedWebhookEventExample = {
  event: "inspection_link_status_updated",
  payload: {
    _id: "6a3d6dd978df011206efcf98",
    magicLink: "https://app.autoinspector.ai/inspection/6a3d6dd978df011206efcf98?accessCode=1074",
    accessCode: "1074",
    metadata: {},
    status: "created",
    testing: false,
    delivery: {
      channel: "email",
      status: "opened",
      updatedAt: "2026-06-25T18:05:24.255Z",
      recipient: "johndoe@gmail.com",
      source: "initializer"
    }
  }
};
var inspectionLinkStatusUpdatedWebhookEventPayloadSchema = (0, import_zod_openapi.extendApi)(
  inspectionLinkStatusUpdatedWebhookEventSchema,
  {
    title: "Inspection Link Status Updated v1",
    description: "When the delivery status of an inspection link changes through email, WhatsApp, or SMS.",
    example: inspectionLinkStatusUpdatedWebhookEventExample
  }
);
var webhookEventSchemas = [
  inspectionCreatedWebhookEventPayloadV1Schema,
  childrenInspectionCreatedWebhookEventPayloadV1Schema,
  inspectionStartedWebhookEventPayloadV1Schema,
  inspectionImageProcessedWebhookEventPayloadV1Schema,
  inspectionAssetProcessedWebhookEventPayloadV2Schema,
  inspectionBlockedWebhookEventPayloadV1Schema,
  inspectionCompletedWebhookEventPayloadV1Schema,
  inspectionReviewedWebhookEventPayloadV1Schema,
  inspectionCompletedWebhookEventPayloadV2Schema,
  inspectionClientCompletedEventV2Schema,
  inspectionLinkStatusUpdatedWebhookEventPayloadSchema
];
var webhookEventPublicApiV2Schema = import_zod26.default.union(webhookEventSchemas);
var getSchemaTitle = (schema, fallback) => {
  if (schema.title)
    return schema.title;
  return fallback;
};
var getSchemaDescription = (schema) => {
  if (schema.description)
    return schema.description;
  return void 0;
};
var webhookPublicApiV2EventsSpec = webhookEventSchemas.map(
  (schema) => {
    const jsonSchema = (0, import_zod_openapi.generateSchema)(schema);
    const event = schema.shape.event.value;
    const title = getSchemaTitle(jsonSchema, event);
    return {
      event,
      title,
      description: getSchemaDescription(jsonSchema),
      example: jsonSchema.example,
      schema: jsonSchema
    };
  }
);
var webhookApiVersionPublicApiV2Schema = import_zod26.default.nativeEnum(import_ai_constants18.API_VERSIONS).describe("Webhook payload API version");
var createWebhookPublicApiV2RequestBodySchema = import_zod26.default.object({
  events: import_zod26.default.array(import_zod26.default.enum(import_ai_constants18.webhookEvents)).min(1).describe("Webhook events to subscribe to"),
  endpoint: import_zod26.default.string().url().describe("Target URL where webhook payloads are sent"),
  locked: import_zod26.default.boolean().optional().describe(
    "Whether the webhook should be created in locked mode to prevent later mutations."
  ),
  apiVersion: webhookApiVersionPublicApiV2Schema.default(import_ai_constants18.LATEST_API_VERSION).describe("Webhook payload API version. Defaults to the latest version.")
});
var createWebhookPublicApiV2ResponseBodySchema = import_zod26.default.object({
  message: import_zod26.default.string().describe("Webhook creation result message"),
  _id: import_zod26.default.string().describe("Created webhook identifier"),
  signature: import_zod26.default.string().describe("Webhook signature")
});
var deleteWebhookPublicApiV2ResponseBodySchema = import_zod26.default.object({
  message: import_zod26.default.string().describe("Webhook deletion result message")
});
var listWebhooksPublicApiV2RequestQuerySchema = import_zod26.default.object({
  limit: import_zod26.default.coerce.number().min(1).max(10).default(10),
  page: import_zod26.default.coerce.number().min(1).default(1)
});
var listWebhooksPublicApiV2ItemSchema = import_zod26.default.object({
  _id: import_zod26.default.string().describe("Webhook identifier"),
  endpoint: import_zod26.default.string().url().describe("Target URL where webhook payloads are sent"),
  events: import_zod26.default.array(import_zod26.default.enum(import_ai_constants18.webhookEvents)).describe("Subscribed webhook events"),
  isActive: import_zod26.default.boolean().describe("Whether the webhook is active"),
  apiVersion: webhookApiVersionPublicApiV2Schema.describe(
    "Effective webhook payload API version"
  )
});
var listWebhooksPublicApiV2ResponseBodySchema = import_zod26.default.object({
  data: import_zod26.default.array(listWebhooksPublicApiV2ItemSchema),
  meta: import_zod26.default.object({
    total: import_zod26.default.number().describe("Total number of webhooks"),
    page: import_zod26.default.number().describe("Current page"),
    limit: import_zod26.default.number().describe("Limit per page"),
    hasMore: import_zod26.default.boolean().describe("If there are more webhooks to fetch")
  })
});

// src/schemas/autoinspector-dataset-format.ts
var import_zod_openapi2 = require("@anatine/zod-openapi");
var import_zod27 = require("zod");
var autoinspectorDatasetFormatTaskTypes = [
  "classification",
  "detection",
  "instance_segmentation",
  "ocr"
];
var autoinspectorDatasetFormatMediaTypes = [
  "image",
  "video",
  "document"
];
var autoinspectorDatasetAnnotationTypeByTaskType = {
  classification: "classification",
  detection: "bbox",
  instance_segmentation: "polygon",
  ocr: "text"
};
var autoinspectorDatasetMediaTypesByTaskType = {
  classification: autoinspectorDatasetFormatMediaTypes,
  detection: autoinspectorDatasetFormatMediaTypes,
  instance_segmentation: autoinspectorDatasetFormatMediaTypes,
  ocr: ["image", "document"]
};
var autoinspectorDatasetPointSchema = import_zod27.z.object({
  x: import_zod27.z.number().describe("Coordenada horizontal del punto."),
  y: import_zod27.z.number().describe("Coordenada vertical del punto.")
}).describe("Punto bidimensional expresado como un objeto con x e y.");
var autoinspectorDatasetBboxSchema = import_zod27.z.object({
  height: import_zod27.z.number().describe("Alto del bounding box."),
  width: import_zod27.z.number().describe("Ancho del bounding box."),
  x: import_zod27.z.number().describe("Coordenada horizontal del origen del bounding box."),
  y: import_zod27.z.number().describe("Coordenada vertical del origen del bounding box.")
}).describe("Bounding box expresado como un objeto con x, y, width y height.");
var autoinspectorDatasetAssetTargetSchema = import_zod27.z.object({
  assetId: import_zod27.z.string().default("root").describe(
    "Identificador del asset dentro del registro. Por defecto debe ser el asset ra\xEDz."
  ),
  type: import_zod27.z.literal("asset")
}).describe(
  "Target que indica que la anotaci\xF3n pertenece al asset ra\xEDz o a un miembro adicional del registro agrupado."
);
var autoinspectorDatasetViewTargetSchema = import_zod27.z.object({
  type: import_zod27.z.literal("view"),
  viewId: import_zod27.z.string().describe(
    "Identificador estable de la vista derivada a la que pertenece la anotaci\xF3n."
  )
}).describe(
  "Target que indica que la anotaci\xF3n est\xE1 expresada en el espacio de coordenadas de una vista derivada."
);
var autoinspectorDatasetAnnotationTargetSchema = import_zod27.z.discriminatedUnion("type", [
  autoinspectorDatasetAssetTargetSchema,
  autoinspectorDatasetViewTargetSchema
]).describe(
  "Target opcional que define a qu\xE9 asset o vista derivada pertenece la anotaci\xF3n. Si se omite en clasificaci\xF3n, describe el registro completo; en anotaciones espaciales se interpreta como el asset ra\xEDz."
);
var autoinspectorDatasetAnnotationAttributesSchema = import_zod27.z.record(import_zod27.z.string(), import_zod27.z.unknown()).describe("Atributos adicionales espec\xEDficos del dominio.");
var autoinspectorDatasetLabelSchema = import_zod27.z.object({
  id: import_zod27.z.string().min(1).describe(
    "Identificador can\xF3nico y estable de la label dentro del grupo de anotaciones."
  ),
  name: import_zod27.z.string().min(1).describe("Nombre legible de la label dentro del grupo de anotaciones.")
}).describe("Definici\xF3n de una label declarada por un grupo de anotaciones.");
var autoinspectorDatasetOntologySchema = import_zod27.z.object({
  labels: import_zod27.z.array(autoinspectorDatasetLabelSchema).min(1).describe(
    "Colecci\xF3n de labels declaradas por el grupo de anotaciones y disponibles para ser referenciadas desde las anotaciones."
  )
}).describe(
  "Ontolog\xEDa del grupo de anotaciones que define el vocabulario controlado disponible para anotaciones y navegaci\xF3n."
);
var autoinspectorDatasetAnnotationGroupSchema = import_zod27.z.object({
  id: import_zod27.z.string().min(1).describe(
    "Identificador estable y can\xF3nico del grupo de anotaciones dentro del snapshot."
  ),
  name: import_zod27.z.string().min(1).describe("Nombre legible del grupo de anotaciones."),
  ontology: autoinspectorDatasetOntologySchema,
  taskType: import_zod27.z.enum(autoinspectorDatasetFormatTaskTypes).describe("Tipo de tarea soportado por el grupo de anotaciones.")
}).describe(
  "Grupo de anotaciones versionado dentro del snapshot. Cada grupo tiene su propia ontolog\xEDa y un \xFAnico tipo de tarea."
);
var autoinspectorDatasetAssetSourceS3Schema = import_zod27.z.object({
  bucket: import_zod27.z.string().describe("Bucket de S3 donde vive el asset."),
  key: import_zod27.z.string().describe("Object key del asset dentro del bucket."),
  region: import_zod27.z.string().optional().describe("Regi\xF3n opcional del bucket de S3."),
  type: import_zod27.z.literal("s3")
}).describe("Referencia del asset almacenado en S3.");
var autoinspectorDatasetAssetSourceUrlSchema = import_zod27.z.object({
  type: import_zod27.z.literal("url"),
  url: import_zod27.z.string().url().describe("URL p\xFAblica o privada del asset de origen.")
}).describe("Referencia del asset por URL directa.");
var autoinspectorDatasetAssetSourceSchema = import_zod27.z.discriminatedUnion("type", [
  autoinspectorDatasetAssetSourceS3Schema,
  autoinspectorDatasetAssetSourceUrlSchema
]).describe("Origen del asset asociado al registro.");
var autoinspectorDatasetImageAssetSpecsSchema = import_zod27.z.object({
  height: import_zod27.z.number().describe("Alto original de la imagen."),
  width: import_zod27.z.number().describe("Ancho original de la imagen.")
}).describe("Especificaciones t\xE9cnicas del asset de tipo imagen.");
var autoinspectorDatasetBaseAnnotationSchema = import_zod27.z.object({
  annotationGroupId: import_zod27.z.string().min(1).describe(
    "Referencia al identificador del grupo de anotaciones declarado en snapshot.annotationGroups."
  ),
  attributes: autoinspectorDatasetAnnotationAttributesSchema.optional(),
  description: import_zod27.z.string().min(1).optional().describe(
    "Descripci\xF3n humana opcional que agrega contexto explicativo para revisi\xF3n sin modificar la sem\xE1ntica de la anotaci\xF3n."
  ),
  labelId: import_zod27.z.string().min(1).describe(
    "Referencia al identificador de una label declarada en la ontolog\xEDa del grupo de anotaciones referenciado por annotationGroupId."
  ),
  score: import_zod27.z.number().min(0).max(1).optional().describe("Confianza opcional normalizada entre 0 y 1."),
  target: autoinspectorDatasetAnnotationTargetSchema.optional()
});
var autoinspectorDatasetClassificationAnnotationSchema = autoinspectorDatasetBaseAnnotationSchema.extend({
  type: import_zod27.z.literal("classification")
}).describe("Anotaci\xF3n de clasificaci\xF3n.");
var autoinspectorDatasetBboxAnnotationSchema = autoinspectorDatasetBaseAnnotationSchema.extend({
  bbox: autoinspectorDatasetBboxSchema,
  type: import_zod27.z.literal("bbox")
}).describe("Anotaci\xF3n de detecci\xF3n con bounding box.");
var autoinspectorDatasetPolygonAnnotationSchema = autoinspectorDatasetBaseAnnotationSchema.extend({
  polygons: import_zod27.z.array(import_zod27.z.array(autoinspectorDatasetPointSchema).min(3)).min(1).describe(
    "Polygon masks expresados como un array de anillos compuestos por puntos."
  ),
  type: import_zod27.z.literal("polygon")
}).describe(
  "Anotaci\xF3n de segmentaci\xF3n por instancia basada en polygon masks."
);
var autoinspectorDatasetTextAnnotationSchema = autoinspectorDatasetBaseAnnotationSchema.extend({
  type: import_zod27.z.literal("text"),
  value: import_zod27.z.string().min(1).describe(
    "Valor de texto exacto de ground truth. Se preserva sin trimming ni normalizaci\xF3n."
  )
}).describe("Anotaci\xF3n de texto para extracci\xF3n OCR de campos etiquetados.");
var autoinspectorDatasetAnnotationSchema = import_zod27.z.discriminatedUnion("type", [
  autoinspectorDatasetClassificationAnnotationSchema,
  autoinspectorDatasetBboxAnnotationSchema,
  autoinspectorDatasetPolygonAnnotationSchema,
  autoinspectorDatasetTextAnnotationSchema
]).describe("Anotaci\xF3n individual del dataset.");
var autoinspectorDatasetImageAssetSchema = import_zod27.z.object({
  source: autoinspectorDatasetAssetSourceSchema,
  specs: autoinspectorDatasetImageAssetSpecsSchema,
  type: import_zod27.z.literal("image")
}).describe("Asset de tipo imagen.");
var autoinspectorDatasetVideoAssetSchema = import_zod27.z.object({
  durationMs: import_zod27.z.number().optional().describe("Duraci\xF3n opcional del video en milisegundos."),
  height: import_zod27.z.number().describe("Alto original del video."),
  source: autoinspectorDatasetAssetSourceSchema,
  type: import_zod27.z.literal("video"),
  width: import_zod27.z.number().describe("Ancho original del video.")
}).describe("Asset de tipo video.");
var autoinspectorDatasetDocumentAssetSchema = import_zod27.z.object({
  contentType: import_zod27.z.string().min(1).optional().describe(
    "MIME type opcional del documento, por ejemplo application/pdf."
  ),
  fileName: import_zod27.z.string().min(1).optional().describe("Nombre de archivo opcional del documento."),
  pageCount: import_zod27.z.number().optional().describe("Cantidad opcional de p\xE1ginas del documento."),
  source: autoinspectorDatasetAssetSourceSchema,
  type: import_zod27.z.literal("document")
}).describe("Asset de tipo documento.");
var autoinspectorDatasetAssetSchema = import_zod27.z.discriminatedUnion("type", [
  autoinspectorDatasetImageAssetSchema,
  autoinspectorDatasetVideoAssetSchema,
  autoinspectorDatasetDocumentAssetSchema
]).describe("Asset principal asociado al registro del dataset.");
var autoinspectorDatasetMemberSchema = import_zod27.z.object({
  asset: autoinspectorDatasetAssetSchema.describe(
    "Asset adicional que forma parte del registro agrupado."
  ),
  id: import_zod27.z.string().min(1).describe(
    "Identificador estable del miembro adicional dentro del registro agrupado."
  ),
  metadata: import_zod27.z.record(import_zod27.z.string(), import_zod27.z.unknown()).optional().describe("Metadatos custom opcionales del miembro adicional.")
}).describe("Miembro adicional de un registro agrupado.");
var autoinspectorDatasetViewRegionSchema = import_zod27.z.object({
  height: import_zod27.z.number().describe(
    "Alto del recorte o regi\xF3n de la vista derivada expresado en coordenadas del asset origen."
  ),
  width: import_zod27.z.number().describe(
    "Ancho del recorte o regi\xF3n de la vista derivada expresado en coordenadas del asset origen."
  ),
  x: import_zod27.z.number().describe(
    "Coordenada horizontal del origen de la vista derivada dentro del asset origen."
  ),
  y: import_zod27.z.number().describe(
    "Coordenada vertical del origen de la vista derivada dentro del asset origen."
  )
}).describe(
  "Regi\xF3n del asset origen que dio lugar a la vista derivada. Se expresa en el sistema de coordenadas del asset ra\xEDz."
);
var autoinspectorDatasetCropViewSchema = import_zod27.z.object({
  asset: autoinspectorDatasetAssetSchema.describe(
    "Asset materializado de la vista derivada, por ejemplo la imagen del crop."
  ),
  id: import_zod27.z.string().describe(
    "Identificador estable de la vista derivada dentro del registro."
  ),
  region: autoinspectorDatasetViewRegionSchema,
  type: import_zod27.z.literal("crop")
}).describe(
  "Vista derivada de tipo crop que representa un recorte del asset original."
);
var autoinspectorDatasetViewSchema = import_zod27.z.discriminatedUnion("type", [autoinspectorDatasetCropViewSchema]).describe(
  "Vista derivada opcional de un registro, por ejemplo un crop o patch que nace del asset original."
);
var autoinspectorDatasetRecordSchema = import_zod27.z.object({
  annotations: import_zod27.z.array(autoinspectorDatasetAnnotationSchema).min(1).describe(
    "Anotaciones asociadas al registro padre, opcionalmente dirigidas a su asset ra\xEDz, a un miembro adicional o a una vista del asset ra\xEDz."
  ),
  asset: autoinspectorDatasetAssetSchema,
  id: import_zod27.z.string().describe("Identificador estable del registro."),
  metadata: import_zod27.z.record(import_zod27.z.string(), import_zod27.z.unknown()).optional().describe("Metadatos custom opcionales del registro."),
  members: import_zod27.z.array(autoinspectorDatasetMemberSchema).min(1).optional().describe(
    "Miembros adicionales ordenados del registro agrupado. El campo asset del registro es siempre el miembro ra\xEDz impl\xEDcito con id root."
  ),
  views: import_zod27.z.array(autoinspectorDatasetViewSchema).optional().describe(
    "Colecci\xF3n opcional de vistas derivadas del asset original, como crops o patches usados por el pipeline."
  )
}).superRefine((record, ctx) => {
  var _a, _b;
  (_a = record.members) == null ? void 0 : _a.forEach((member, memberIndex, members) => {
    if (member.id === "root") {
      ctx.addIssue({
        code: import_zod27.z.ZodIssueCode.custom,
        message: "El identificador root est\xE1 reservado para el asset principal del registro.",
        path: ["members", memberIndex, "id"]
      });
    }
    const firstMemberIndex = members.findIndex(
      (candidateMember) => candidateMember.id === member.id
    );
    if (firstMemberIndex === memberIndex)
      return;
    ctx.addIssue({
      code: import_zod27.z.ZodIssueCode.custom,
      message: "Los identificadores de record.members deben ser \xFAnicos.",
      path: ["members", memberIndex, "id"]
    });
  });
  (_b = record.views) == null ? void 0 : _b.forEach((view, viewIndex, views) => {
    const firstViewIndex = views.findIndex(
      (candidateView) => candidateView.id === view.id
    );
    if (firstViewIndex === viewIndex)
      return;
    ctx.addIssue({
      code: import_zod27.z.ZodIssueCode.custom,
      message: "Los identificadores de record.views deben ser \xFAnicos.",
      path: ["views", viewIndex, "id"]
    });
  });
  const validAssetIds = [
    "root",
    ...(record.members || []).map((member) => member.id)
  ];
  const validViewIds = (record.views || []).map((view) => view.id);
  record.annotations.forEach((annotation, annotationIndex) => {
    var _a2, _b2;
    if (((_a2 = annotation.target) == null ? void 0 : _a2.type) === "asset") {
      if (annotation.type !== "text" && !record.members)
        return;
      if (validAssetIds.includes(annotation.target.assetId))
        return;
      ctx.addIssue({
        code: import_zod27.z.ZodIssueCode.custom,
        message: "annotation.target.assetId debe referenciar root o un miembro declarado en record.members.",
        path: ["annotations", annotationIndex, "target", "assetId"]
      });
    }
    if (((_b2 = annotation.target) == null ? void 0 : _b2.type) !== "view")
      return;
    if (annotation.type !== "text" && !record.views)
      return;
    if (validViewIds.includes(annotation.target.viewId))
      return;
    ctx.addIssue({
      code: import_zod27.z.ZodIssueCode.custom,
      message: "annotation.target.viewId debe referenciar una vista declarada en record.views.",
      path: ["annotations", annotationIndex, "target", "viewId"]
    });
  });
}).describe("Registro individual o grupo plano de archivos dentro del dataset.");
var autoinspectorDatasetSnapshotSchema = import_zod27.z.object({
  annotationGroups: import_zod27.z.array(autoinspectorDatasetAnnotationGroupSchema).min(1).describe(
    "Colecci\xF3n de grupos de anotaciones declarados por el snapshot. Cada grupo define su propia ontolog\xEDa y su tipo de tarea."
  ),
  createdAt: import_zod27.z.string().datetime().describe("Fecha de creaci\xF3n del snapshot en formato ISO 8601."),
  description: import_zod27.z.string().optional().describe("Descripci\xF3n funcional del snapshot."),
  id: import_zod27.z.string().describe("Identificador estable del snapshot."),
  mediaType: import_zod27.z.enum(autoinspectorDatasetFormatMediaTypes).describe("Tipo de media principal del dataset."),
  name: import_zod27.z.string().describe("Nombre legible del snapshot."),
  primaryAnnotationGroupId: import_zod27.z.string().min(1).optional().describe(
    "Identificador opcional del grupo de anotaciones principal para visualizaci\xF3n y defaults de UI."
  )
}).superRefine((snapshot, ctx) => {
  snapshot.annotationGroups.forEach((group, groupIndex, groups) => {
    const firstGroupIndex = groups.findIndex(
      (candidateGroup) => candidateGroup.id.toLowerCase() === group.id.toLowerCase()
    );
    if (firstGroupIndex !== groupIndex)
      ctx.addIssue({
        code: import_zod27.z.ZodIssueCode.custom,
        message: "Los identificadores de snapshot.annotationGroups deben ser \xFAnicos.",
        path: ["annotationGroups", groupIndex, "id"]
      });
    group.ontology.labels.forEach((label, labelIndex, labels) => {
      const firstLabelIndex = labels.findIndex(
        (candidateLabel) => candidateLabel.id.toLowerCase() === label.id.toLowerCase()
      );
      if (firstLabelIndex === labelIndex)
        return;
      ctx.addIssue({
        code: import_zod27.z.ZodIssueCode.custom,
        message: "Los identificadores de snapshot.annotationGroups[].ontology.labels deben ser \xFAnicos dentro del grupo.",
        path: [
          "annotationGroups",
          groupIndex,
          "ontology",
          "labels",
          labelIndex,
          "id"
        ]
      });
    });
  });
  if (!snapshot.primaryAnnotationGroupId)
    return;
  const matchedPrimaryGroup = snapshot.annotationGroups.find(
    (group) => group.id === snapshot.primaryAnnotationGroupId
  );
  if (matchedPrimaryGroup)
    return;
  ctx.addIssue({
    code: import_zod27.z.ZodIssueCode.custom,
    message: "snapshot.primaryAnnotationGroupId debe referenciar un grupo declarado en snapshot.annotationGroups.",
    path: ["primaryAnnotationGroupId"]
  });
}).describe("Metadatos del snapshot importado.");
var autoinspectorDatasetFormatHeaderSchema = import_zod27.z.object({
  format: import_zod27.z.literal("autoinspector.dataset.v1").describe("Versi\xF3n del contrato del Autoinspector Dataset Format."),
  snapshot: autoinspectorDatasetSnapshotSchema,
  type: import_zod27.z.literal("header").describe("Tipo de l\xEDnea JSONL que declara los metadatos del snapshot.")
}).superRefine((value, ctx) => {
  value.snapshot.annotationGroups.forEach((annotationGroup, groupIndex) => {
    const compatibleMediaTypes = autoinspectorDatasetMediaTypesByTaskType[annotationGroup.taskType];
    if (compatibleMediaTypes.some(
      (mediaType) => mediaType === value.snapshot.mediaType
    ))
      return;
    ctx.addIssue({
      code: import_zod27.z.ZodIssueCode.custom,
      message: `El taskType ${annotationGroup.taskType} no es compatible con snapshot.mediaType ${value.snapshot.mediaType}.`,
      path: ["snapshot", "annotationGroups", groupIndex, "taskType"]
    });
  });
}).describe(
  "L\xEDnea inicial del archivo JSONL que define la versi\xF3n del formato y el snapshot compartido."
);
var autoinspectorDatasetFormatRecordLineSchema = import_zod27.z.object({
  record: autoinspectorDatasetRecordSchema,
  type: import_zod27.z.literal("record").describe("Tipo de l\xEDnea JSONL que representa una entrada del dataset.")
}).describe(
  "L\xEDnea JSONL que representa una entrada completa del dataset con asset y anotaciones."
);
var autoinspectorDatasetFormatLineSchema = import_zod27.z.union([
  autoinspectorDatasetFormatHeaderSchema,
  autoinspectorDatasetFormatRecordLineSchema
]).describe(
  "L\xEDnea individual del archivo JSONL de Autoinspector Dataset Format."
);
var autoinspectorDatasetFormatSchema = import_zod27.z.object({
  format: import_zod27.z.literal("autoinspector.dataset.v1").describe("Versi\xF3n del contrato del Autoinspector Dataset Format."),
  records: import_zod27.z.array(autoinspectorDatasetRecordSchema).min(1).describe("Colecci\xF3n de registros que componen el dataset."),
  snapshot: autoinspectorDatasetSnapshotSchema
}).superRefine((value, ctx) => {
  value.snapshot.annotationGroups.forEach((annotationGroup, groupIndex) => {
    const compatibleMediaTypes = autoinspectorDatasetMediaTypesByTaskType[annotationGroup.taskType];
    if (compatibleMediaTypes.some(
      (mediaType) => mediaType === value.snapshot.mediaType
    ))
      return;
    ctx.addIssue({
      code: import_zod27.z.ZodIssueCode.custom,
      message: `El taskType ${annotationGroup.taskType} no es compatible con snapshot.mediaType ${value.snapshot.mediaType}.`,
      path: ["snapshot", "annotationGroups", groupIndex, "taskType"]
    });
  });
  value.records.forEach((record, index) => {
    var _a;
    if (record.asset.type !== value.snapshot.mediaType) {
      ctx.addIssue({
        code: import_zod27.z.ZodIssueCode.custom,
        message: "El tipo de asset debe coincidir con snapshot.mediaType.",
        path: ["records", index, "asset", "type"]
      });
    }
    (_a = record.members) == null ? void 0 : _a.forEach((member, memberIndex) => {
      if (member.asset.type === value.snapshot.mediaType)
        return;
      ctx.addIssue({
        code: import_zod27.z.ZodIssueCode.custom,
        message: "El tipo de asset de cada miembro debe coincidir con snapshot.mediaType.",
        path: ["records", index, "members", memberIndex, "asset", "type"]
      });
    });
  });
  value.records.forEach((record, recordIndex, records) => {
    const firstRecordIndex = records.findIndex(
      (candidateRecord) => candidateRecord.id === record.id
    );
    if (firstRecordIndex === recordIndex)
      return;
    ctx.addIssue({
      code: import_zod27.z.ZodIssueCode.custom,
      message: "Los identificadores de records deben ser \xFAnicos.",
      path: ["records", recordIndex, "id"]
    });
  });
  value.records.forEach((record, recordIndex) => {
    record.annotations.forEach((annotation, annotationIndex) => {
      const resolvedGroup = value.snapshot.annotationGroups.find(
        (group) => group.id === annotation.annotationGroupId
      );
      if (!resolvedGroup) {
        ctx.addIssue({
          code: import_zod27.z.ZodIssueCode.custom,
          message: "annotation.annotationGroupId debe referenciar un grupo declarado en snapshot.annotationGroups.",
          path: [
            "records",
            recordIndex,
            "annotations",
            annotationIndex,
            "annotationGroupId"
          ]
        });
        return;
      }
      const resolvedLabel = resolvedGroup.ontology.labels.find(
        (label) => label.id === annotation.labelId
      );
      if (!resolvedLabel) {
        ctx.addIssue({
          code: import_zod27.z.ZodIssueCode.custom,
          message: "annotation.labelId debe referenciar una label declarada en la ontolog\xEDa del grupo de anotaciones seleccionado.",
          path: [
            "records",
            recordIndex,
            "annotations",
            annotationIndex,
            "labelId"
          ]
        });
      }
      const expectedAnnotationType = autoinspectorDatasetAnnotationTypeByTaskType[resolvedGroup.taskType];
      if (annotation.type === expectedAnnotationType)
        return;
      ctx.addIssue({
        code: import_zod27.z.ZodIssueCode.custom,
        message: "annotation.type debe ser compatible con el taskType del grupo de anotaciones seleccionado.",
        path: [
          "records",
          recordIndex,
          "annotations",
          annotationIndex,
          "type"
        ]
      });
    });
  });
}).describe("Contrato del Autoinspector Dataset Format.");
var autoinspectorDatasetFormatExample = {
  format: "autoinspector.dataset.v1",
  records: [
    {
      annotations: [
        {
          annotationGroupId: "damage-segmentation",
          labelId: "scratch",
          target: {
            type: "view",
            viewId: "crop-0"
          },
          polygons: [
            [
              { x: 88, y: 72 },
              { x: 154, y: 66 },
              { x: 172, y: 102 },
              { x: 101, y: 110 }
            ]
          ],
          type: "polygon"
        },
        {
          annotationGroupId: "car-parts",
          bbox: {
            height: 54,
            width: 96,
            x: 404,
            y: 320
          },
          labelId: "front_bumper",
          score: 0.98,
          target: {
            assetId: "root",
            type: "asset"
          },
          type: "bbox"
        }
      ],
      asset: {
        source: {
          bucket: "autoinspector-evals",
          key: "damage-benchmark/front-bumper-001.jpg",
          region: "us-east-1",
          type: "s3"
        },
        specs: {
          height: 1080,
          width: 1920
        },
        type: "image"
      },
      id: "front-bumper-001",
      metadata: {
        inspectionId: "67e26c1c5d4c9b1d4d5f1123",
        split: "validation",
        status: "reviewed"
      },
      views: [
        {
          asset: {
            source: {
              bucket: "autoinspector-evals",
              key: "damage-benchmark/front-bumper-001-crop-0.jpg",
              region: "us-east-1",
              type: "s3"
            },
            specs: {
              height: 512,
              width: 512
            },
            type: "image"
          },
          id: "crop-0",
          region: {
            height: 512,
            width: 512,
            x: 320,
            y: 240
          },
          type: "crop"
        }
      ]
    }
  ],
  snapshot: {
    annotationGroups: [
      {
        id: "damage-segmentation",
        name: "Vehicle damages",
        ontology: {
          labels: [
            {
              id: "scratch",
              name: "Scratch"
            },
            {
              id: "paint_loss",
              name: "Paint loss"
            }
          ]
        },
        taskType: "instance_segmentation"
      },
      {
        id: "car-parts",
        name: "Car parts",
        ontology: {
          labels: [
            {
              id: "front_bumper",
              name: "Front bumper"
            },
            {
              id: "rear_bumper",
              name: "Rear bumper"
            }
          ]
        },
        taskType: "detection"
      }
    ],
    createdAt: "2026-03-25T14:20:00.000Z",
    description: "Snapshot de validaci\xF3n importado desde el formato interno de Autoinspector.",
    id: "damage-benchmark-2026-03-25",
    mediaType: "image",
    name: "Damage Benchmark",
    primaryAnnotationGroupId: "damage-segmentation"
  }
};
var autoinspectorDatasetFormatJsonSchema = (0, import_zod_openapi2.generateSchema)(
  autoinspectorDatasetFormatSchema
);
var autoinspectorDatasetFormatHeaderJsonSchema = (0, import_zod_openapi2.generateSchema)(
  autoinspectorDatasetFormatHeaderSchema
);
var autoinspectorDatasetFormatRecordLineJsonSchema = (0, import_zod_openapi2.generateSchema)(
  autoinspectorDatasetFormatRecordLineSchema
);

// src/schemas/autoinspector-eval-result-format.ts
var import_zod_openapi3 = require("@anatine/zod-openapi");
var import_zod28 = require("zod");
var autoinspectorEvalResultFormatRecordTargetSchema = import_zod28.z.object({
  type: import_zod28.z.literal("record")
}).describe("Target que representa al registro padre completo.");
var autoinspectorEvalResultFormatTargetSchema = import_zod28.z.discriminatedUnion("type", [
  autoinspectorEvalResultFormatRecordTargetSchema,
  ...autoinspectorDatasetAnnotationTargetSchema.options
]).describe(
  "Unidad independiente evaluada por esta l\xEDnea: registro padre, asset o vista."
);
var autoinspectorEvalResultFormatPredictionAttributesSchema = import_zod28.z.record(import_zod28.z.string(), import_zod28.z.unknown()).describe("Atributos adicionales del output crudo del pipeline.");
var autoinspectorEvalResultFormatClassificationPredictionSchema = import_zod28.z.object({
  attributes: autoinspectorEvalResultFormatPredictionAttributesSchema.optional(),
  labelId: import_zod28.z.string().min(1).describe("Label predicha por el pipeline."),
  rank: import_zod28.z.number().int().min(1).optional().describe(
    "Posici\xF3n opcional de la predicci\xF3n dentro del ranking devuelto por el pipeline."
  ),
  score: import_zod28.z.number().min(0).max(1).optional().describe("Score o confianza opcional normalizada entre 0 y 1."),
  target: autoinspectorDatasetAnnotationTargetSchema.optional().describe(
    "Target opcional de la predicci\xF3n. Debe omitirse para clasificaci\xF3n a nivel del registro agrupado y usar type asset con assetId para una predicci\xF3n espec\xEDfica de un miembro."
  )
}).describe("Predicci\xF3n de clasificaci\xF3n cruda emitida por el pipeline.");
var autoinspectorEvalResultFormatDetectionPredictionSchema = import_zod28.z.object({
  attributes: autoinspectorEvalResultFormatPredictionAttributesSchema.optional(),
  bbox: autoinspectorDatasetBboxSchema,
  labelId: import_zod28.z.string().min(1).describe("Label predicha para el bounding box."),
  score: import_zod28.z.number().min(0).max(1).describe(
    "Score o confianza normalizada entre 0 y 1. Es requerida para que Autoinspector pueda calcular AP y m\xE9tricas derivadas por threshold."
  ),
  target: autoinspectorDatasetAnnotationTargetSchema.optional().describe(
    "Target opcional que identifica el miembro del registro agrupado al que pertenece el bounding box."
  )
}).describe(
  "Predicci\xF3n de detecci\xF3n cruda con bounding box. El bbox permite calcular IoU y el score permite calcular AP y mAP."
);
var autoinspectorEvalResultFormatSegmentationPredictionSchema = import_zod28.z.object({
  attributes: autoinspectorEvalResultFormatPredictionAttributesSchema.optional(),
  labelId: import_zod28.z.string().min(1).describe("Label predicha para la m\xE1scara o pol\xEDgono."),
  polygons: import_zod28.z.array(import_zod28.z.array(autoinspectorDatasetPointSchema).min(3)).min(1).describe("M\xE1scara segmentada expresada como polygon masks."),
  score: import_zod28.z.number().min(0).max(1).describe(
    "Score o confianza normalizada entre 0 y 1. Es requerida para que Autoinspector pueda calcular AP y m\xE9tricas derivadas por threshold."
  ),
  target: autoinspectorDatasetAnnotationTargetSchema.optional().describe(
    "Target opcional que identifica el miembro del registro agrupado al que pertenece la m\xE1scara o pol\xEDgono."
  )
}).describe(
  "Predicci\xF3n de segmentaci\xF3n por instancia basada en pol\xEDgonos. Los pol\xEDgonos permiten calcular IoU y el score permite calcular AP y mAP."
);
var autoinspectorEvalResultFormatInstanceListPredictionSchema = import_zod28.z.object({
  attributes: autoinspectorEvalResultFormatPredictionAttributesSchema.optional(),
  labelId: import_zod28.z.string().min(1).describe("Label predicha para una instancia no espacial."),
  score: import_zod28.z.number().min(0).max(1).describe(
    "Score o confianza normalizada entre 0 y 1. Se usa para ordenar predicciones cuando hay m\xE1s instancias predichas que ground truth."
  ),
  target: autoinspectorDatasetAnnotationTargetSchema.optional().describe(
    "Target opcional que identifica el miembro del registro agrupado al que pertenece la instancia."
  )
}).describe(
  "Predicci\xF3n de instancia no espacial. Se usa cuando el pipeline devuelve instancias por label sin geometr\xEDa cruda."
);
var autoinspectorEvalResultFormatOcrPredictionSchema = import_zod28.z.object({
  labelId: import_zod28.z.string().min(1).describe("Label del campo de texto extra\xEDdo."),
  metadata: autoinspectorEvalResultFormatPredictionAttributesSchema.optional(),
  score: import_zod28.z.number().min(0).max(1).optional().describe("Score o confianza opcional normalizada entre 0 y 1."),
  target: autoinspectorDatasetAnnotationTargetSchema.optional().describe(
    "Target opcional del campo extra\xEDdo. Si se omite, corresponde al asset ra\xEDz."
  ),
  value: import_zod28.z.string().describe(
    "Valor de texto predicho. Puede ser vac\xEDo y se preserva sin normalizaci\xF3n."
  )
}).describe("Predicci\xF3n OCR de un campo de texto etiquetado.");
var autoinspectorEvalResultFormatClassificationOutputSchema = import_zod28.z.object({
  predictions: import_zod28.z.array(autoinspectorEvalResultFormatClassificationPredictionSchema).min(1).describe(
    "Ranking de predicciones crudas del pipeline para el registro evaluado."
  ),
  type: import_zod28.z.literal("classification")
}).describe("Output crudo de clasificaci\xF3n para un registro del dataset.");
var autoinspectorEvalResultFormatDetectionOutputSchema = import_zod28.z.object({
  predictions: import_zod28.z.array(autoinspectorEvalResultFormatDetectionPredictionSchema).describe(
    "Colecci\xF3n de bounding boxes predichos por el pipeline para el registro evaluado."
  ),
  type: import_zod28.z.literal("detection")
}).describe("Output crudo de detecci\xF3n para un registro del dataset.");
var autoinspectorEvalResultFormatSegmentationOutputSchema = import_zod28.z.object({
  predictions: import_zod28.z.array(autoinspectorEvalResultFormatSegmentationPredictionSchema).describe(
    "Colecci\xF3n de m\xE1scaras o pol\xEDgonos predichos por el pipeline para el registro evaluado."
  ),
  type: import_zod28.z.literal("instance_segmentation")
}).describe(
  "Output crudo de segmentaci\xF3n por instancia para un registro del dataset."
);
var autoinspectorEvalResultFormatInstanceListOutputSchema = import_zod28.z.object({
  predictions: import_zod28.z.array(autoinspectorEvalResultFormatInstanceListPredictionSchema).describe(
    "Colecci\xF3n de instancias no espaciales predichas por el pipeline para el registro evaluado."
  ),
  type: import_zod28.z.literal("instance_list")
}).describe(
  "Output crudo de instancias no espaciales para un registro del dataset."
);
var autoinspectorEvalResultFormatOcrOutputSchema = import_zod28.z.object({
  predictions: import_zod28.z.array(autoinspectorEvalResultFormatOcrPredictionSchema).describe(
    "Campos de texto extra\xEDdos. Un array vac\xEDo significa que no se extrajo ning\xFAn campo."
  ),
  type: import_zod28.z.literal("ocr")
}).describe("Output OCR de campos etiquetados para un registro del dataset.");
var autoinspectorEvalResultFormatOutputSchema = import_zod28.z.discriminatedUnion("type", [
  autoinspectorEvalResultFormatClassificationOutputSchema,
  autoinspectorEvalResultFormatDetectionOutputSchema,
  autoinspectorEvalResultFormatSegmentationOutputSchema,
  autoinspectorEvalResultFormatInstanceListOutputSchema,
  autoinspectorEvalResultFormatOcrOutputSchema
]).describe("Output crudo del pipeline para un registro del dataset.");
var autoinspectorEvalResultFormatCostSchema = import_zod28.z.object({
  usd_cents: import_zod28.z.number().min(0).describe(
    "Costo opcional del pipeline expresado en usd_cents para este registro."
  )
}).describe(
  "Resumen opcional del costo consumido por la invocaci\xF3n completa del pipeline para este registro o grupo de archivos."
);
var autoinspectorEvalResultFormatItemBaseSchema = import_zod28.z.object({
  cost: autoinspectorEvalResultFormatCostSchema.optional(),
  latencyMs: import_zod28.z.number().int().min(0).optional().describe(
    "Latencia opcional de la invocaci\xF3n completa del pipeline para este registro o grupo de archivos, expresada en milisegundos."
  ),
  metadata: import_zod28.z.record(import_zod28.z.string(), import_zod28.z.unknown()).optional().describe("Metadatos adicionales de la ejecuci\xF3n para este registro."),
  rawOutput: import_zod28.z.unknown().optional().describe(
    "Payload crudo original devuelto por el pipeline. Se persiste solo para auditor\xEDa o debugging."
  ),
  recordId: import_zod28.z.string().min(1).describe(
    "Identificador del registro padre del dataset al que corresponde este resultado. Un grupo completo produce una sola l\xEDnea con este recordId."
  ),
  target: autoinspectorEvalResultFormatTargetSchema.optional().describe(
    "Target opcional de la unidad evaluada. Si aparece en una l\xEDnea, debe aparecer en todas las l\xEDneas del archivo y las predicciones no pueden declarar targets anidados."
  )
});
var autoinspectorEvalResultFormatProcessedItemSchema = autoinspectorEvalResultFormatItemBaseSchema.extend({
  diagnosticAnnotations: import_zod28.z.array(autoinspectorDatasetAnnotationSchema).optional().describe(
    "Anotaciones diagn\xF3sticas producidas por el pipeline para visualizaci\xF3n y auditor\xEDa. No participan en el c\xE1lculo de m\xE9tricas."
  ),
  output: autoinspectorEvalResultFormatOutputSchema,
  status: import_zod28.z.literal("processed")
}).describe(
  "Resultado procesado exitosamente para un registro padre, incluyendo todos sus archivos cuando es un grupo."
);
var autoinspectorEvalResultFormatErrorItemSchema = autoinspectorEvalResultFormatItemBaseSchema.extend({
  errorMessage: import_zod28.z.string().min(1).describe(
    "Mensaje de error devuelto por el pipeline para este registro."
  ),
  status: import_zod28.z.literal("error")
}).describe("Resultado fallido para un registro del dataset.");
var autoinspectorEvalResultFormatSkippedItemSchema = autoinspectorEvalResultFormatItemBaseSchema.extend({
  reason: import_zod28.z.string().min(1).optional().describe("Motivo opcional por el que el registro fue omitido."),
  status: import_zod28.z.literal("skipped")
}).describe("Resultado omitido para un registro del dataset.");
var autoinspectorEvalResultFormatItemSchema = import_zod28.z.discriminatedUnion("status", [
  autoinspectorEvalResultFormatProcessedItemSchema,
  autoinspectorEvalResultFormatErrorItemSchema,
  autoinspectorEvalResultFormatSkippedItemSchema
]).describe(
  "Resultado crudo individual de un registro padre del dataset. Las predicciones pueden apuntar a miembros mediante target.assetId sin cambiar la estructura de la l\xEDnea."
).superRefine((item, context) => {
  if (!item.target || item.status !== "processed")
    return;
  item.output.predictions.forEach((prediction, predictionIndex) => {
    if (!prediction.target)
      return;
    context.addIssue({
      code: import_zod28.z.ZodIssueCode.custom,
      message: "Las predicciones no pueden declarar target cuando la l\xEDnea ya tiene un target de unidad.",
      path: ["output", "predictions", predictionIndex, "target"]
    });
  });
});
var autoinspectorEvalResultFormatRecordLineSchema = autoinspectorEvalResultFormatItemSchema.describe(
  "L\xEDnea JSONL individual que representa directamente el resultado crudo de un registro del dataset."
);
var autoinspectorEvalResultFormatLineSchema = autoinspectorEvalResultFormatItemSchema.describe(
  "L\xEDnea individual v\xE1lida dentro del archivo JSONL de evaluaci\xF3n."
);
var autoinspectorEvalResultFormatProcessedItemJsonSchema = (0, import_zod_openapi3.generateSchema)(autoinspectorEvalResultFormatProcessedItemSchema);
var autoinspectorEvalResultFormatRecordLineJsonSchema = (0, import_zod_openapi3.generateSchema)(
  autoinspectorEvalResultFormatRecordLineSchema
);
var autoinspectorEvalResultFormatClassificationRecordExample = {
  cost: {
    usd_cents: 2.41
  },
  latencyMs: 142,
  output: {
    predictions: [
      {
        labelId: "scratch",
        rank: 1,
        score: 0.98
      },
      {
        labelId: "paint_loss",
        rank: 2,
        score: 0.14
      }
    ],
    type: "classification"
  },
  recordId: "front-bumper-001",
  status: "processed"
};
var autoinspectorEvalResultFormatDetectionRecordExample = {
  cost: {
    usd_cents: 3.18
  },
  latencyMs: 187,
  output: {
    predictions: [
      {
        bbox: {
          height: 142,
          width: 226,
          x: 418,
          y: 236
        },
        labelId: "dent",
        score: 0.96
      },
      {
        bbox: {
          height: 94,
          width: 158,
          x: 702,
          y: 318
        },
        labelId: "scratch",
        score: 0.71
      }
    ],
    type: "detection"
  },
  recordId: "rear-door-014",
  status: "processed"
};
var autoinspectorEvalResultFormatInstanceSegmentationRecordExample = {
  cost: {
    usd_cents: 4.07
  },
  latencyMs: 204,
  output: {
    predictions: [
      {
        labelId: "scratch",
        polygons: [
          [
            {
              x: 315,
              y: 248
            },
            {
              x: 361,
              y: 240
            },
            {
              x: 392,
              y: 278
            },
            {
              x: 344,
              y: 296
            }
          ]
        ],
        score: 0.93
      }
    ],
    type: "instance_segmentation"
  },
  recordId: "front-bumper-018",
  status: "processed"
};
var autoinspectorEvalResultFormatInstanceListRecordExample = {
  cost: {
    usd_cents: 1.66
  },
  latencyMs: 166,
  output: {
    predictions: [
      {
        attributes: {
          partLabels: ["front_bumper"],
          severity: "minor",
          viewId: "front-bumper-018-crop-0"
        },
        labelId: "scratch",
        score: 0.93,
        target: {
          type: "view",
          viewId: "front-bumper-018-crop-0"
        }
      },
      {
        attributes: {
          partLabels: ["front_bumper"],
          severity: "moderate",
          viewId: "front-bumper-018-crop-0"
        },
        labelId: "dent",
        score: 0.77,
        target: {
          type: "view",
          viewId: "front-bumper-018-crop-0"
        }
      }
    ],
    type: "instance_list"
  },
  recordId: "front-bumper-018",
  status: "processed"
};
var autoinspectorEvalResultFormatOcrRecordExample = {
  cost: {
    usd_cents: 1.21
  },
  latencyMs: 121,
  output: {
    predictions: [
      {
        labelId: "invoice_number",
        score: 0.99,
        value: "A 0001-00001234"
      },
      {
        labelId: "line_item",
        target: {
          assetId: "back",
          type: "asset"
        },
        value: "Servicio t\xE9cnico"
      }
    ],
    type: "ocr"
  },
  recordId: "invoice-001",
  status: "processed"
};
var autoinspectorEvalResultFormatErrorRecordExample = {
  errorMessage: "Timeout leyendo el endpoint del pipeline.",
  latencyMs: 3e3,
  recordId: "front-bumper-003",
  status: "error"
};
var autoinspectorEvalResultFormatSkippedRecordExample = {
  reason: "El asset no cumpl\xEDa los prerequisitos del pipeline.",
  recordId: "front-bumper-004",
  status: "skipped"
};
var autoinspectorEvalResultFormatExample = {
  items: [
    autoinspectorEvalResultFormatClassificationRecordExample,
    autoinspectorEvalResultFormatDetectionRecordExample,
    autoinspectorEvalResultFormatInstanceSegmentationRecordExample,
    autoinspectorEvalResultFormatInstanceListRecordExample,
    autoinspectorEvalResultFormatOcrRecordExample,
    autoinspectorEvalResultFormatErrorRecordExample,
    autoinspectorEvalResultFormatSkippedRecordExample
  ]
};

// src/schemas/autoinspector-eval-analysis.ts
var import_zod29 = require("zod");
var MAX_EVAL_ANALYSIS_SELECTION_LABELS = 200;
var autoinspectorEvalLabelAttributeFilterSchema = import_zod29.z.object({
  key: import_zod29.z.string().min(1).max(100),
  value: import_zod29.z.union([import_zod29.z.string(), import_zod29.z.number().finite(), import_zod29.z.boolean(), import_zod29.z.null()])
}).strict();
var autoinspectorEvalAnalysisGroupValueSchema = import_zod29.z.union([
  import_zod29.z.string(),
  import_zod29.z.number().finite(),
  import_zod29.z.boolean(),
  import_zod29.z.null()
]);
var autoinspectorEvalAnalysisGroupThresholdSchema = import_zod29.z.object({
  groupValue: autoinspectorEvalAnalysisGroupValueSchema,
  value: import_zod29.z.number().finite().min(0).max(1)
}).strict();
var autoinspectorEvalAnalysisLabelGroupThresholdSchema = autoinspectorEvalAnalysisGroupThresholdSchema.extend({
  labelId: import_zod29.z.string().min(1).max(200)
});
var analysisNameSchema = import_zod29.z.string().trim().min(1).max(100);
var autoinspectorEvalAnalysisKnobSchema = import_zod29.z.object({
  id: import_zod29.z.string().regex(
    /^[a-zA-Z0-9_-]{1,64}$/,
    "Use letters, numbers, hyphens, or underscores for the knob ID."
  ),
  name: analysisNameSchema,
  operator: import_zod29.z.enum(["gte", "lte"]),
  scope: import_zod29.z.discriminatedUnion("type", [
    import_zod29.z.object({ type: import_zod29.z.literal("all") }).strict(),
    import_zod29.z.object({ type: import_zod29.z.literal("per_label") }).strict(),
    import_zod29.z.object({
      type: import_zod29.z.literal("per_group"),
      key: import_zod29.z.string().trim().min(1).max(100),
      values: import_zod29.z.array(autoinspectorEvalAnalysisGroupValueSchema).min(1).max(MAX_EVAL_ANALYSIS_SELECTION_LABELS)
    }).strict(),
    import_zod29.z.object({
      type: import_zod29.z.literal("per_label_group"),
      key: import_zod29.z.string().trim().min(1).max(100),
      values: import_zod29.z.array(autoinspectorEvalAnalysisGroupValueSchema).min(1).max(MAX_EVAL_ANALYSIS_SELECTION_LABELS)
    }).strict()
  ]).optional(),
  source: import_zod29.z.discriminatedUnion("type", [
    import_zod29.z.object({ type: import_zod29.z.literal("score") }).strict(),
    import_zod29.z.object({
      key: import_zod29.z.string().trim().min(1).max(100),
      type: import_zod29.z.literal("attribute")
    }).strict()
  ]),
  values: import_zod29.z.array(import_zod29.z.number().finite()).min(2, "Add at least two threshold values.")
}).strict().superRefine((knob, context) => {
  var _a, _b, _c, _d, _e;
  if ((((_a = knob.scope) == null ? void 0 : _a.type) === "per_label" || ((_b = knob.scope) == null ? void 0 : _b.type) === "per_group" || ((_c = knob.scope) == null ? void 0 : _c.type) === "per_label_group") && knob.source.type !== "score")
    context.addIssue({
      code: import_zod29.z.ZodIssueCode.custom,
      message: "Per-label and per-group calibration require a score source.",
      path: ["source"]
    });
  if (((_d = knob.scope) == null ? void 0 : _d.type) === "per_group" || ((_e = knob.scope) == null ? void 0 : _e.type) === "per_label_group") {
    const members = knob.scope.values;
    members.forEach((member, index) => {
      if (members.findIndex((candidate) => candidate === member) !== index)
        context.addIssue({
          code: import_zod29.z.ZodIssueCode.custom,
          message: "Group members must be unique.",
          path: ["scope", "values", index]
        });
    });
  }
  knob.values.forEach((value, index) => {
    if (index > 0 && value <= knob.values[index - 1])
      context.addIssue({
        code: import_zod29.z.ZodIssueCode.custom,
        message: "Values must be unique and strictly increasing.",
        path: ["values", index]
      });
    if (knob.source.type === "score" && (value < 0 || value > 1))
      context.addIssue({
        code: import_zod29.z.ZodIssueCode.custom,
        message: "Score thresholds must be between 0 and 1.",
        path: ["values", index]
      });
  });
});
var autoinspectorEvalAnalysisConfigSchema = import_zod29.z.object({
  groupBy: import_zod29.z.array(
    import_zod29.z.object({
      key: import_zod29.z.string().trim().min(1).max(100),
      name: analysisNameSchema,
      predictionKey: import_zod29.z.string().trim().min(1).max(100).optional()
    }).strict()
  ).default([]),
  knobs: import_zod29.z.array(autoinspectorEvalAnalysisKnobSchema).default([])
}).strict().superRefine((configuration, context) => {
  if (!configuration.knobs.length && !configuration.groupBy.length)
    context.addIssue({
      code: import_zod29.z.ZodIssueCode.custom,
      message: "Configure at least one knob or grouping attribute.",
      path: ["knobs"]
    });
  configuration.knobs.forEach((knob, index) => {
    const scope = knob.scope;
    if (((scope == null ? void 0 : scope.type) === "per_group" || (scope == null ? void 0 : scope.type) === "per_label_group") && !configuration.groupBy.some((group) => group.key === scope.key))
      context.addIssue({
        code: import_zod29.z.ZodIssueCode.custom,
        message: "Per-group calibration requires a configured grouping attribute.",
        path: ["knobs", index, "scope", "key"]
      });
    if (configuration.knobs.findIndex(({ id }) => id === knob.id) !== index)
      context.addIssue({
        code: import_zod29.z.ZodIssueCode.custom,
        message: "Knob identifiers must be unique.",
        path: ["knobs", index, "id"]
      });
  });
  configuration.groupBy.forEach((group, index) => {
    if (configuration.groupBy.findIndex(({ key }) => key === group.key) !== index)
      context.addIssue({
        code: import_zod29.z.ZodIssueCode.custom,
        message: "Grouping attribute keys must be unique.",
        path: ["groupBy", index, "key"]
      });
  });
});
var autoinspectorEvalAnalysisLabelThresholdSchema = import_zod29.z.object({
  labelId: import_zod29.z.string().min(1).max(200),
  value: import_zod29.z.number().finite().min(0).max(1)
}).strict();
var autoinspectorEvalAnalysisSelectionRequestSchema = import_zod29.z.object({
  revision: import_zod29.z.string().min(1).max(100),
  knobId: import_zod29.z.string().min(1).max(64),
  thresholds: import_zod29.z.array(autoinspectorEvalAnalysisLabelThresholdSchema).max(MAX_EVAL_ANALYSIS_SELECTION_LABELS).default([]),
  labelGroupThresholds: import_zod29.z.array(autoinspectorEvalAnalysisLabelGroupThresholdSchema).max(MAX_EVAL_ANALYSIS_SELECTION_LABELS).optional(),
  groupThresholds: import_zod29.z.array(autoinspectorEvalAnalysisGroupThresholdSchema).max(MAX_EVAL_ANALYSIS_SELECTION_LABELS).optional()
}).strict().superRefine((selection, context) => {
  var _a, _b, _c, _d;
  if (!selection.thresholds.length && !((_a = selection.groupThresholds) == null ? void 0 : _a.length) && !((_b = selection.labelGroupThresholds) == null ? void 0 : _b.length))
    context.addIssue({
      code: import_zod29.z.ZodIssueCode.custom,
      message: "Provide class thresholds or group member thresholds.",
      path: ["thresholds"]
    });
  const vectors = [
    selection.thresholds,
    selection.groupThresholds,
    selection.labelGroupThresholds
  ];
  if (vectors.filter((vector) => vector == null ? void 0 : vector.length).length !== 1)
    context.addIssue({
      code: import_zod29.z.ZodIssueCode.custom,
      message: "Provide exactly one threshold vector.",
      path: ["thresholds"]
    });
  (_c = selection.labelGroupThresholds) == null ? void 0 : _c.forEach((threshold, index) => {
    var _a2;
    if (((_a2 = selection.labelGroupThresholds) == null ? void 0 : _a2.findIndex(
      (candidate) => candidate.labelId === threshold.labelId && candidate.groupValue === threshold.groupValue
    )) !== index)
      context.addIssue({
        code: import_zod29.z.ZodIssueCode.custom,
        message: "Each class and group pair must appear exactly once.",
        path: ["labelGroupThresholds", index]
      });
  });
  (_d = selection.groupThresholds) == null ? void 0 : _d.forEach((threshold, index) => {
    var _a2;
    if (((_a2 = selection.groupThresholds) == null ? void 0 : _a2.findIndex(
      (candidate) => candidate.groupValue === threshold.groupValue
    )) !== index)
      context.addIssue({
        code: import_zod29.z.ZodIssueCode.custom,
        message: "Each group member must appear exactly once.",
        path: ["groupThresholds", index, "groupValue"]
      });
  });
  selection.thresholds.forEach((threshold, index) => {
    if (selection.thresholds.findIndex(
      (candidate) => candidate.labelId === threshold.labelId
    ) !== index)
      context.addIssue({
        code: import_zod29.z.ZodIssueCode.custom,
        message: "Each evaluated label must appear exactly once.",
        path: ["thresholds", index, "labelId"]
      });
  });
});
var countEvalAnalysisCombinations = (config, evaluatedLabelCount) => config.knobs.reduce((total, knob) => {
  var _a, _b;
  if (((_a = knob.scope) == null ? void 0 : _a.type) === "per_label_group")
    return total;
  const dimensionsByScope = {
    all: () => 0,
    per_label_group: () => 0,
    per_label: () => evaluatedLabelCount,
    per_group: () => {
      var _a2;
      return ((_a2 = knob.scope) == null ? void 0 : _a2.type) === "per_group" ? knob.scope.values.length : 0;
    }
  };
  const dimensions = dimensionsByScope[((_b = knob.scope) == null ? void 0 : _b.type) ?? "all"]();
  if (dimensions === 0)
    return total + knob.values.length;
  return total + knob.values.length ** dimensions;
}, 1);
var isRepresentableEvalAnalysisCombinationCount = (count) => Number.isSafeInteger(count);

// src/contracts/invoice.contract.ts
var import_ai_constants19 = require("ai-constants");
var import_zod30 = __toESM(require("zod"));
var invoiceSchema = import_zod30.default.object({
  companyId: import_zod30.default.string().min(1, "Company ID is required"),
  invoiceNumber: import_zod30.default.string({
    required_error: "Campo requerido"
  }).nullish(),
  issuingDate: import_zod30.default.coerce.date({
    required_error: "Campo requerido",
    invalid_type_error: "Fecha inv\xE1lida"
  }),
  dueDate: import_zod30.default.coerce.date({
    required_error: "Campo requerido",
    invalid_type_error: "Fecha inv\xE1lida"
  }).nullish(),
  status: import_zod30.default.enum(import_ai_constants19.invoiceStatuses, {
    required_error: "Campo requerido"
  }),
  currency: import_zod30.default.enum(import_ai_constants19.currencies, {
    required_error: "Campo requerido"
  }),
  amount: import_zod30.default.number({
    required_error: "Campo requerido"
  }).min(0, "Amount must be greater than 0"),
  fileToken: import_zod30.default.string().min(1, "File token is required"),
  paymentDate: import_zod30.default.coerce.date({
    required_error: "Campo requerido",
    invalid_type_error: "Fecha inv\xE1lida"
  }).nullish()
});
var createInvoiceRequestBody = invoiceSchema;
var applyInvoiceRefinements = (schema) => (
  //@ts-ignore
  schema.superRefine((data, ctx) => {
    if (data.status === "paid" && !data.paymentDate) {
      ctx.addIssue({
        code: import_zod30.default.ZodIssueCode.custom,
        message: "Fecha de pago requerida",
        path: ["paymentDate"]
      });
    }
  })
);
var createInvoiceResponseBody = import_zod30.default.object({
  _id: import_zod30.default.string()
});
var listInvoicesRequestQuery = dataTableRequestQuerySchema;
var listInvoicesResponseBody = createPaginationResponseSchema(
  invoiceSchema.extend({
    company: companySchema,
    _id: import_zod30.default.string(),
    file: import_zod30.default.object({
      originalName: import_zod30.default.string(),
      storedName: import_zod30.default.string(),
      size: import_zod30.default.number(),
      type: import_zod30.default.string(),
      extension: import_zod30.default.string(),
      mimetype: import_zod30.default.string(),
      originalUploadedAt: import_zod30.default.coerce.date().nullish(),
      url: import_zod30.default.string().nullish()
    })
  })
);
var updateInvoiceRequestBody = invoiceSchema.omit({
  companyId: true
});
var invoiceRequestParams = import_zod30.default.object({
  invoiceId: import_zod30.default.string().min(1, "Invoice ID is required")
});

// src/schemas/file.ts
var import_zod31 = require("zod");
var tokenizeFileRequestBody = import_zod31.z.object({
  name: import_zod31.z.string(),
  size: import_zod31.z.number()
});

// src/schemas/billing.ts
var import_ai_constants20 = require("ai-constants");
var import_zod32 = __toESM(require("zod"));
var import_ai_constants21 = require("ai-constants");
var retrieveCompanySubscriptionResponseBody = import_zod32.default.object({
  subscription: import_zod32.default.object({
    startDate: import_zod32.default.coerce.date().nullish(),
    endDate: import_zod32.default.coerce.date().nullish(),
    status: import_zod32.default.enum(import_ai_constants20.subscriptionStatuses),
    plan: planSchema,
    addonPlans: import_zod32.default.array(
      addonPlanSchemaBase.extend({
        _id: import_zod32.default.any(),
        status: import_zod32.default.enum(import_ai_constants20.subscriptionStatuses),
        canceledAt: import_zod32.default.coerce.date().nullish()
      })
    )
  }),
  currentBillingPeriod: import_zod32.default.object({
    startDate: import_zod32.default.object({
      formatted: import_zod32.default.string(),
      isoValue: import_zod32.default.string()
    }),
    endDate: import_zod32.default.object({
      formatted: import_zod32.default.string(),
      isoValue: import_zod32.default.string()
    })
  }),
  nextBillingPeriod: import_zod32.default.object({
    startDate: import_zod32.default.coerce.date()
  }),
  usage: import_zod32.default.array(
    import_zod32.default.object({
      resource: import_zod32.default.enum(import_ai_constants20.planLimitResources),
      currentUsage: import_zod32.default.number(),
      limit: import_zod32.default.number(),
      subscriptionId: import_zod32.default.any(),
      periodStart: import_zod32.default.coerce.date(),
      periodEnd: import_zod32.default.coerce.date().nullish(),
      limitReached: import_zod32.default.boolean().nullish(),
      model: import_zod32.default.enum(import_ai_constants21.planLimitModels)
    })
  ),
  aggregatedLimits: import_zod32.default.array(planLimitSchema),
  usagePeriods: import_zod32.default.array(
    import_zod32.default.object({
      periodStart: import_zod32.default.object({
        formatted: import_zod32.default.string(),
        isoValue: import_zod32.default.string()
      }),
      periodEnd: import_zod32.default.object({
        formatted: import_zod32.default.string(),
        isoValue: import_zod32.default.string()
      })
    })
  )
});
var retrieveCompanySubscriptionRequestQuery = import_zod32.default.object({
  startDate: import_zod32.default.coerce.date().nullish(),
  endDate: import_zod32.default.coerce.date().nullish()
});

// src/schemas/guest.ts
var import_zod33 = __toESM(require("zod"));
var import_validator6 = require("validator");
var retrieveGuestRequestParams = import_zod33.default.object({
  guestId: import_zod33.default.string().refine(import_validator6.isMongoId)
});
var retrieveGuestRequestQuery = import_zod33.default.object({
  token: import_zod33.default.string()
});
var retrieveGuestResponseBody = import_zod33.default.object({
  _id: import_zod33.default.any(),
  createdAt: import_zod33.default.coerce.date(),
  policyName: import_zod33.default.string().nullish(),
  token: import_zod33.default.string(),
  email: import_zod33.default.string(),
  internalId: import_zod33.default.string().nullish(),
  company: companySchema.pick({
    _id: true,
    societyReason: true,
    fantasyName: true,
    authConfig: true,
    language: true
  }),
  host: import_zod33.default.object({
    name: import_zod33.default.string(),
    email: import_zod33.default.string(),
    username: import_zod33.default.string()
  }).nullish()
});
var registerUserGuestRequestBody = import_zod33.default.object({
  firstName: import_zod33.default.string().min(1, "Campo requerido"),
  lastName: import_zod33.default.string().min(1, "Campo requerido"),
  password: import_zod33.default.string().min(1, "Campo requerido").min(5, "M\xEDnimo 5 caracteres"),
  acceptTerms: import_zod33.default.boolean().refine((value) => !!value, {
    message: "Debe aceptar los t\xE9rminos y condiciones"
  })
});

// src/schemas/user.ts
var import_ai_constants22 = require("ai-constants");
var import_zod34 = require("zod");
var loginUserIDPRequestBody = import_zod34.z.object({
  provider: import_zod34.z.enum(["google"]),
  token: import_zod34.z.string()
});
var registerInvitationIDPRequestBody = loginUserIDPRequestBody;
var signInMethodSchema = import_zod34.z.enum(["google", "microsoft", "email"]);
var registerUserEventRequestBody = import_zod34.z.object({
  events: import_zod34.z.array(
    import_zod34.z.discriminatedUnion("event", [
      import_zod34.z.object({
        event: import_zod34.z.literal("page_viewed"),
        data: import_zod34.z.object({
          page: import_zod34.z.enum(import_ai_constants22.eventPages),
          can_create_inspection: import_zod34.z.boolean().optional(),
          can_view_inspection: import_zod34.z.boolean().optional()
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("home_cta_clicked"),
        data: import_zod34.z.object({
          component: import_zod34.z.enum(import_ai_constants22.homeCtaComponents),
          cta: import_zod34.z.enum(import_ai_constants22.homeCtaActions),
          card: import_zod34.z.enum(import_ai_constants22.homeCtaCards).optional(),
          destination: import_zod34.z.string()
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("home_cta_impression"),
        data: import_zod34.z.object({
          component: import_zod34.z.enum(import_ai_constants22.homeCtaComponents),
          cta: import_zod34.z.enum(import_ai_constants22.homeCtaActions),
          card: import_zod34.z.enum(import_ai_constants22.homeCtaCards).optional(),
          destination: import_zod34.z.string()
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("home_filter_changed"),
        data: import_zod34.z.object({
          context: import_zod34.z.enum(import_ai_constants22.homeFilterContexts),
          filter: import_zod34.z.enum(import_ai_constants22.homeFilterKeys),
          value: import_zod34.z.enum(import_ai_constants22.homeFilterValues)
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("create_inspection_page_viewed"),
        data: import_zod34.z.object({
          inspection_type: import_zod34.z.enum(import_ai_constants22.inspectionTypes)
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("inspection_list_filters_applied"),
        data: import_zod34.z.object({}),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("template_updated"),
        data: import_zod34.z.object({
          template_id: import_zod34.z.string(),
          template_name: import_zod34.z.string(),
          template_type: import_zod34.z.enum(import_ai_constants22.templateTypes),
          inspection_type: import_zod34.z.enum(import_ai_constants22.inspectionTypes)
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("view_wrapped_button_clicked"),
        data: import_zod34.z.object({
          year: import_zod34.z.number()
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("view_wrapped_button_impression"),
        data: import_zod34.z.object({
          year: import_zod34.z.number()
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("wrapped_slide_viewed"),
        data: import_zod34.z.object({
          year: import_zod34.z.number(),
          slide: import_zod34.z.enum([
            "intro",
            "inspections-count",
            "weeks-active",
            "hours-saved",
            "fraud-alerts",
            "user-profile",
            "thank-you"
          ])
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("view_wrapped_button_dismissed"),
        data: import_zod34.z.object({
          year: import_zod34.z.number()
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("wrapped_share_button_clicked"),
        data: import_zod34.z.object({
          year: import_zod34.z.number()
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("inspection_file_viewed"),
        data: import_zod34.z.object({
          inspection_id: import_zod34.z.string(),
          template_id: import_zod34.z.string(),
          template_name: import_zod34.z.string(),
          inspection_type: import_zod34.z.enum(import_ai_constants22.inspectionTypes),
          file_type: import_zod34.z.enum(["image", "audio", "video", "file", "document"]),
          file_name: import_zod34.z.string(),
          file_asset_label: import_zod34.z.string(),
          file_asset_type: import_zod34.z.enum(import_ai_constants22.assetTypes),
          file_asset_identifier: import_zod34.z.string()
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("inspection_validations_preview_opened"),
        data: import_zod34.z.object({
          inspection_id: import_zod34.z.string(),
          template_id: import_zod34.z.string(),
          template_name: import_zod34.z.string(),
          inspection_type: import_zod34.z.enum(import_ai_constants22.inspectionTypes),
          validations_type: import_zod34.z.enum(["required", "extra"]),
          validations_count: import_zod34.z.number()
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("inspection_detail_visibility_active"),
        data: import_zod34.z.object({
          inspection_id: import_zod34.z.string(),
          template_id: import_zod34.z.string(),
          template_name: import_zod34.z.string(),
          inspection_type: import_zod34.z.enum(import_ai_constants22.inspectionTypes),
          last_active_timestamp: import_zod34.z.number(),
          inactive_duration_ms: import_zod34.z.number(),
          unix_timestamp_seconds: import_zod34.z.number()
        }),
        timestamp: import_zod34.z.number()
      }),
      import_zod34.z.object({
        event: import_zod34.z.literal("inspection_detail_visibility_inactive"),
        data: import_zod34.z.object({
          inspection_id: import_zod34.z.string(),
          template_id: import_zod34.z.string(),
          template_name: import_zod34.z.string(),
          inspection_type: import_zod34.z.enum(import_ai_constants22.inspectionTypes),
          last_active_timestamp: import_zod34.z.number(),
          active_duration_ms: import_zod34.z.number(),
          unix_timestamp_seconds: import_zod34.z.number()
        }),
        timestamp: import_zod34.z.number()
      })
    ])
  )
});

// src/utils/compute-status-from-dates.ts
var import_date_fns3 = require("date-fns");
var computeStatusFromDates = (subscription) => {
  const now = /* @__PURE__ */ new Date();
  if (!subscription.startDate)
    return "pending";
  const isStarted = (0, import_date_fns3.isAfter)(now, subscription.startDate) || now.getTime() === subscription.startDate.getTime();
  if (!isStarted)
    return "pending";
  if (!subscription.endDate)
    return "active";
  const isEnded = (0, import_date_fns3.isAfter)(now, subscription.endDate);
  if (isEnded && subscription.status === "canceled")
    return "canceled";
  if (isEnded)
    return "terminated";
  return "active";
};

// src/utils/calendar-date.ts
var calendarDatePrefixRegex = /^(\d{4}-\d{2}-\d{2})(?:$|T)/;
var extractCalendarDate = (value) => {
  var _a;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime()))
      return;
    return value.toISOString().slice(0, 10);
  }
  const calendarDate = (_a = value.match(calendarDatePrefixRegex)) == null ? void 0 : _a[1];
  if (!calendarDate)
    return;
  const parsedCalendarDate = /* @__PURE__ */ new Date(`${calendarDate}T00:00:00.000Z`);
  if (Number.isNaN(parsedCalendarDate.getTime()))
    return;
  if (!parsedCalendarDate.toISOString().startsWith(`${calendarDate}T`))
    return;
  if (value !== calendarDate && Number.isNaN(new Date(value).getTime()))
    return;
  return calendarDate;
};
var isCalendarDateWithinBounds = ({
  value,
  minDate,
  maxDate
}) => {
  const calendarDate = extractCalendarDate(value);
  if (!calendarDate)
    return false;
  const minimumCalendarDate = minDate ? extractCalendarDate(minDate) : void 0;
  if (minDate && !minimumCalendarDate)
    return false;
  if (minimumCalendarDate && calendarDate < minimumCalendarDate)
    return false;
  const maximumCalendarDate = maxDate ? extractCalendarDate(maxDate) : void 0;
  if (maxDate && !maximumCalendarDate)
    return false;
  if (maximumCalendarDate && calendarDate > maximumCalendarDate)
    return false;
  return true;
};

// src/contracts/segment.contract.ts
var import_ai_constants23 = require("ai-constants");
var import_zod35 = require("zod");
var import_date_fns4 = require("date-fns");
var requiredErrorFieldMessage = "Campo requerido";
var segmentationSimulationSchema = import_zod35.z.object({
  identity: import_zod35.z.object({
    email: import_zod35.z.string().email()
  }),
  events: import_zod35.z.array(
    import_zod35.z.object({
      uid: import_zod35.z.string(),
      type: import_zod35.z.enum(import_ai_constants23.userEvents, {
        invalid_type_error: requiredErrorFieldMessage,
        required_error: requiredErrorFieldMessage,
        message: requiredErrorFieldMessage
      }),
      timestamp: import_zod35.z.coerce.date({
        errorMap: () => {
          return {
            message: "Fecha inv\xE1lida"
          };
        }
      })
    })
  ).min(1, {
    message: "Agrega al menos un evento"
  }),
  startDate: import_zod35.z.coerce.date({
    errorMap: () => {
      return {
        message: "Fecha inv\xE1lida"
      };
    }
  }),
  endDate: import_zod35.z.coerce.date({
    errorMap: () => {
      return {
        message: "Fecha inv\xE1lida"
      };
    }
  })
});
var applySegmentationSimulationRefinements = (schema) => schema.refine(
  (data) => !!data.startDate && !!data.endDate && (0, import_date_fns4.isAfter)(new Date(data.endDate), new Date(data.startDate)),
  {
    message: "La fecha de inicio debe ser anterior a la fecha de fin",
    path: ["startDate"]
  }
);
var executeSegmentationSimulationRequestBody = applySegmentationSimulationRefinements(segmentationSimulationSchema);
var segmentSchema = import_zod35.z.object({
  type: import_zod35.z.enum(import_ai_constants23.userSegmentTypes),
  timestamp: import_zod35.z.coerce.date(),
  _id: import_zod35.z.any(),
  metadata: import_zod35.z.custom().nullish()
});
var executeSegmentationSimulationResponseBody = import_zod35.z.object({
  simulation: segmentationSimulationSchema.merge(
    import_zod35.z.object({
      id: import_zod35.z.string()
    })
  ),
  segments: import_zod35.z.array(segmentSchema)
});
var retrieveSegmentationEvolutionRequestQuery = import_zod35.z.object({
  email: import_zod35.z.string().email().transform(normalizeEmail)
});
var retrieveSegmentationEvolutionResponseBody = import_zod35.z.object({
  segments: import_zod35.z.array(segmentSchema),
  activity: import_zod35.z.array(userActivityBaseSchema)
});

// src/utils/build-user-name.ts
var buildUserName = (user) => [user.firstName, user.lastName].filter(Boolean).join(" ");

// src/utils/dataset-ontology-colors.ts
var datasetOntologyColorPalette = [
  "#D92D20",
  "#2563EB",
  "#15803D",
  "#C2410C",
  "#7C3AED",
  "#BE185D",
  "#0891B2",
  "#CA8A04",
  "#0F766E",
  "#4F46E5",
  "#B91C1C",
  "#1D4ED8",
  "#047857",
  "#9333EA",
  "#EA580C",
  "#0E7490",
  "#A21CAF",
  "#2B6CB0",
  "#166534",
  "#C026D3",
  "#9A3412",
  "#0369A1",
  "#4338CA",
  "#B45309"
];
var buildStableStringHash = (value) => Array.from(value).reduce(
  (hash, character) => hash * 31 + character.charCodeAt(0) >>> 0,
  7
);
var buildDatasetOntologyFallbackColorHex = (labelId) => {
  const paletteIndex = buildStableStringHash(labelId) % datasetOntologyColorPalette.length;
  return datasetOntologyColorPalette[paletteIndex];
};
var assignDatasetOntologyLabelColors = (labels) => {
  const usedColors = [];
  return [...labels].sort((left, right) => left.id.localeCompare(right.id)).map((label) => {
    const preferredColorIndex = buildStableStringHash(label.id) % datasetOntologyColorPalette.length;
    const nextColorCandidate = datasetOntologyColorPalette.map((_, index) => {
      const paletteIndex = (preferredColorIndex + index) % datasetOntologyColorPalette.length;
      return datasetOntologyColorPalette[paletteIndex];
    }).find((paletteColor) => !usedColors.includes(paletteColor));
    const nextColor = nextColorCandidate || buildDatasetOntologyFallbackColorHex(label.id);
    usedColors.push(nextColor);
    return {
      ...label,
      colorHex: nextColor
    };
  });
};
var resolveDatasetOntologyLabelColorHex = (input) => input.colorHex || buildDatasetOntologyFallbackColorHex(input.labelId);
var convertHexToRgbaString = (input) => {
  const normalizedHex = input.colorHex.replace("#", "");
  const red = Number.parseInt(normalizedHex.slice(0, 2), 16);
  const green = Number.parseInt(normalizedHex.slice(2, 4), 16);
  const blue = Number.parseInt(normalizedHex.slice(4, 6), 16);
  return `rgba(${red}, ${green}, ${blue}, ${input.alpha})`;
};

// src/inspection-result.ts
var INSPECTION_RESULT_BY_LEGACY_VEREDICT = {
  true: "approved",
  false: "disapproved"
};

// src/utils/sort-logic-rules.ts
var sortLogicRules = (logicRules = []) => {
  return [...logicRules].sort((left, right) => left.order - right.order);
};

// src/utils/sort-validations-by-order.ts
var sortValidationsByOrder = (validations) => validations.map((validation, index) => ({ validation, index })).sort((left, right) => {
  const leftHasOrder = typeof left.validation.order === "number";
  const rightHasOrder = typeof right.validation.order === "number";
  if (leftHasOrder && rightHasOrder) {
    const orderDifference = (left.validation.order ?? Number.MAX_SAFE_INTEGER) - (right.validation.order ?? Number.MAX_SAFE_INTEGER);
    if (orderDifference)
      return orderDifference;
    return left.index - right.index;
  }
  if (leftHasOrder)
    return -1;
  if (rightHasOrder)
    return 1;
  return left.index - right.index;
}).map(({ validation }) => validation);

// src/schemas/cardd-group.ts
var import_zod36 = require("zod");
var carddDamageNames = [
  "dent",
  "scratch_paint",
  "crack",
  "corrosion",
  "light_broken",
  "glass_broken",
  "missing",
  "dislocation"
];
var carddDamageSizes = ["small", "medium", "large"];
var carddDamageSeverities = [
  "minor",
  "moderate",
  "severe",
  "missing",
  "unknown"
];
var carddUnknownPartName = "unknown";
var carddPolygonPointSchema = import_zod36.z.object({
  x: import_zod36.z.number().int(),
  y: import_zod36.z.number().int()
});
var carddImageDamageSchema = import_zod36.z.object({
  damage: import_zod36.z.enum(carddDamageNames),
  part: import_zod36.z.string().min(1),
  size: import_zod36.z.enum(carddDamageSizes).optional(),
  severity: import_zod36.z.enum(carddDamageSeverities).optional(),
  confidence: import_zod36.z.number().finite().min(0).max(1).optional(),
  polygons: import_zod36.z.array(import_zod36.z.array(carddPolygonPointSchema))
});
var carddImageDimensionsSchema = import_zod36.z.object({
  width: import_zod36.z.number().int().nonnegative(),
  height: import_zod36.z.number().int().nonnegative()
});
var carddImageResultSchema = import_zod36.z.object({
  image: carddImageDimensionsSchema,
  damages: import_zod36.z.array(carddImageDamageSchema),
  pipeline: import_zod36.z.object({}).passthrough().optional()
});
var carddDamageAssetSchema = carddImageDimensionsSchema.extend({
  type: import_zod36.z.literal("image"),
  identifier: import_zod36.z.string().min(1),
  instanceId: import_zod36.z.string().min(1)
});
var carddGroupDamageSchema = carddImageDamageSchema.extend({
  asset: carddDamageAssetSchema
});
var carddGroupOutputSchema = import_zod36.z.object({
  damages: import_zod36.z.array(carddGroupDamageSchema),
  lean_damages: import_zod36.z.array(
    import_zod36.z.object({
      damage: import_zod36.z.enum(carddDamageNames),
      part: import_zod36.z.string().min(1),
      severity: import_zod36.z.enum(carddDamageSeverities).optional()
    })
  ).optional()
});

// src/schemas/autoinspector-eval-optimization.ts
var import_zod37 = require("zod");
var budgetSchema = import_zod37.z.discriminatedUnion("type", [
  import_zod37.z.object({ type: import_zod37.z.literal("fp_per_gt"), maximum: import_zod37.z.number().min(0).max(1) }).strict(),
  import_zod37.z.object({
    type: import_zod37.z.literal("fp_count"),
    maximum: import_zod37.z.number().int().nonnegative()
  }).strict(),
  import_zod37.z.object({ type: import_zod37.z.literal("none") }).strict()
]);
var evalOptimizationObjectiveSchema = import_zod37.z.discriminatedUnion("type", [
  import_zod37.z.object({
    type: import_zod37.z.literal("recall"),
    aggregation: import_zod37.z.enum(["pooled", "macro_label"])
  }).strict(),
  import_zod37.z.object({
    type: import_zod37.z.literal("f1"),
    aggregation: import_zod37.z.enum(["macro_label_group", "macro_label"])
  }).strict()
]);
var unboundedBudgetSupport = {
  recall: false,
  f1: true
};
var evalOptimizationRequestSchema = import_zod37.z.object({
  strategy: import_zod37.z.discriminatedUnion("type", [
    import_zod37.z.object({ type: import_zod37.z.literal("cached_grid") }).strict(),
    import_zod37.z.object({
      type: import_zod37.z.literal("local_refinement"),
      seedOptimizationId: import_zod37.z.string().regex(/^[a-fA-F0-9]{24}$/),
      step: import_zod37.z.number().min(1e-3).max(0.1),
      radius: import_zod37.z.number().min(1e-3).max(0.1)
    }).strict()
  ]).optional(),
  revision: import_zod37.z.string().min(1).max(100),
  sourceKnobId: import_zod37.z.string().min(1).max(64),
  targetKnobId: import_zod37.z.string().min(1).max(64),
  objective: evalOptimizationObjectiveSchema,
  rules: import_zod37.z.array(
    import_zod37.z.object({
      groupValue: autoinspectorEvalAnalysisGroupValueSchema,
      budget: budgetSchema,
      minimumRecall: import_zod37.z.number().min(0).max(1).default(0)
    }).strict()
  ).min(1).max(10)
}).strict().superRefine((request, context) => {
  var _a;
  if (((_a = request.strategy) == null ? void 0 : _a.type) === "local_refinement" && request.strategy.radius < request.strategy.step)
    context.addIssue({
      code: import_zod37.z.ZodIssueCode.custom,
      path: ["strategy", "radius"],
      message: "Radius must be at least the step."
    });
  request.rules.forEach((rule, index) => {
    if (rule.budget.type === "none" && !unboundedBudgetSupport[request.objective.type])
      context.addIssue({
        code: import_zod37.z.ZodIssueCode.custom,
        path: ["rules", index, "budget"],
        message: "Recall objectives require an FP budget for every group."
      });
    if (request.rules.findIndex(
      (candidate) => candidate.groupValue === rule.groupValue
    ) !== index)
      context.addIssue({
        code: import_zod37.z.ZodIssueCode.custom,
        path: ["rules", index],
        message: "Group budgets must be unique."
      });
  });
  if (request.sourceKnobId === request.targetKnobId)
    context.addIssue({
      code: import_zod37.z.ZodIssueCode.custom,
      path: ["targetKnobId"],
      message: "Select separate group and label-by-group knobs."
    });
});
var evalOptimizationCellSchema = import_zod37.z.object({
  labelId: import_zod37.z.string(),
  groupValue: autoinspectorEvalAnalysisGroupValueSchema,
  threshold: import_zod37.z.number(),
  groundTruth: import_zod37.z.number().int().nonnegative(),
  truePositive: import_zod37.z.number().int().nonnegative(),
  falsePositive: import_zod37.z.number().int().nonnegative(),
  falseNegative: import_zod37.z.number().int().nonnegative(),
  allowedFalsePositive: import_zod37.z.number().int().nonnegative().nullable(),
  fpPerGt: import_zod37.z.number().nullable(),
  recall: import_zod37.z.number().nullable(),
  precision: import_zod37.z.number().nullable(),
  passes: import_zod37.z.boolean()
});
var resultSchema = import_zod37.z.object({
  thresholds: import_zod37.z.array(autoinspectorEvalAnalysisLabelGroupThresholdSchema),
  cells: import_zod37.z.array(evalOptimizationCellSchema),
  objectiveValue: import_zod37.z.number(),
  candidateCount: import_zod37.z.number().int().nonnegative(),
  fixedGroups: import_zod37.z.array(autoinspectorEvalAnalysisGroupValueSchema),
  guarantee: import_zod37.z.enum([
    "optimal_on_cached_grid",
    "optimal_on_local_refinement_grid"
  ]),
  refinement: import_zod37.z.object({
    seedOptimizationId: import_zod37.z.string(),
    step: import_zod37.z.number(),
    radius: import_zod37.z.number(),
    seedObjectiveValue: import_zod37.z.number(),
    scoredRecordStates: import_zod37.z.number().int(),
    reusedRecordStates: import_zod37.z.number().int()
  }).optional(),
  searchMs: import_zod37.z.number().nonnegative()
});
var base = import_zod37.z.object({
  id: import_zod37.z.string(),
  evalId: import_zod37.z.string(),
  revision: import_zod37.z.string(),
  request: evalOptimizationRequestSchema,
  createdAt: import_zod37.z.string(),
  evaluatedCandidates: import_zod37.z.number().int().nonnegative()
});
var evalOptimizationResponseSchema = import_zod37.z.discriminatedUnion("status", [
  base.extend({ status: import_zod37.z.literal("queued") }),
  base.extend({ status: import_zod37.z.literal("searching") }),
  base.extend({
    status: import_zod37.z.literal("verifying"),
    verificationStartedAt: import_zod37.z.string().datetime(),
    result: resultSchema,
    selectionId: import_zod37.z.string()
  }),
  base.extend({
    status: import_zod37.z.literal("completed"),
    result: resultSchema,
    selectionId: import_zod37.z.string(),
    verifiedAt: import_zod37.z.string()
  }),
  base.extend({ status: import_zod37.z.literal("infeasible"), reason: import_zod37.z.string() }),
  base.extend({ status: import_zod37.z.literal("failed"), reason: import_zod37.z.string() }),
  base.extend({ status: import_zod37.z.literal("cancelled"), reason: import_zod37.z.string() })
]);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DEFAULT_SEARCH_PARAMS_ACCESS_TOKEN_STRATEGY,
  EXTERNAL_ENVIRONMENT_DEFAULT_DATA_SHARING_MODE,
  EXTERNAL_ENVIRONMENT_SYNC_API_KEY_HEADER,
  EXTERNAL_ENVIRONMENT_SYNC_CONTRACT_VERSION,
  EXTERNAL_ENVIRONMENT_SYNC_DETAIL_URL_MAX_LENGTH,
  EXTERNAL_ENVIRONMENT_SYNC_MAX_BATCH_SIZE,
  INSPECTION_COST_USAGE_ANALYSIS_DEFAULT_WINDOW_DAYS,
  INSPECTION_COST_USAGE_ANALYSIS_MAX_WINDOW_DAYS,
  INSPECTION_RESULT_BY_LEGACY_VEREDICT,
  InspectionCompletedBy,
  InspectionResult,
  MAX_EVAL_ANALYSIS_SELECTION_LABELS,
  VerificationStatusEnum,
  actionSources,
  addonPlanSchema,
  addonPlanSchemaBase,
  aggregatePaginateUsersRequestQuery,
  aggregatePaginateUsersResponseBody,
  aggregatedAssetTypes,
  aggregatedFileAssetTypes,
  applyAddonPlanCustomValidations,
  applyInvoiceRefinements,
  assetsSchema,
  assignDatasetOntologyLabelColors,
  autoinspectorDatasetAnnotationGroupSchema,
  autoinspectorDatasetAnnotationSchema,
  autoinspectorDatasetAnnotationTargetSchema,
  autoinspectorDatasetAnnotationTypeByTaskType,
  autoinspectorDatasetAssetSchema,
  autoinspectorDatasetAssetSourceSchema,
  autoinspectorDatasetBboxSchema,
  autoinspectorDatasetFormatExample,
  autoinspectorDatasetFormatHeaderJsonSchema,
  autoinspectorDatasetFormatHeaderSchema,
  autoinspectorDatasetFormatJsonSchema,
  autoinspectorDatasetFormatLineSchema,
  autoinspectorDatasetFormatMediaTypes,
  autoinspectorDatasetFormatRecordLineJsonSchema,
  autoinspectorDatasetFormatRecordLineSchema,
  autoinspectorDatasetFormatSchema,
  autoinspectorDatasetFormatTaskTypes,
  autoinspectorDatasetMediaTypesByTaskType,
  autoinspectorDatasetMemberSchema,
  autoinspectorDatasetPointSchema,
  autoinspectorDatasetRecordSchema,
  autoinspectorDatasetSnapshotSchema,
  autoinspectorDatasetTextAnnotationSchema,
  autoinspectorDatasetViewSchema,
  autoinspectorEvalAnalysisConfigSchema,
  autoinspectorEvalAnalysisGroupThresholdSchema,
  autoinspectorEvalAnalysisGroupValueSchema,
  autoinspectorEvalAnalysisKnobSchema,
  autoinspectorEvalAnalysisLabelGroupThresholdSchema,
  autoinspectorEvalAnalysisLabelThresholdSchema,
  autoinspectorEvalAnalysisSelectionRequestSchema,
  autoinspectorEvalLabelAttributeFilterSchema,
  autoinspectorEvalResultFormatClassificationRecordExample,
  autoinspectorEvalResultFormatDetectionRecordExample,
  autoinspectorEvalResultFormatErrorRecordExample,
  autoinspectorEvalResultFormatExample,
  autoinspectorEvalResultFormatInstanceListRecordExample,
  autoinspectorEvalResultFormatInstanceSegmentationRecordExample,
  autoinspectorEvalResultFormatLineSchema,
  autoinspectorEvalResultFormatOcrRecordExample,
  autoinspectorEvalResultFormatProcessedItemJsonSchema,
  autoinspectorEvalResultFormatProcessedItemSchema,
  autoinspectorEvalResultFormatRecordLineJsonSchema,
  autoinspectorEvalResultFormatRecordLineSchema,
  autoinspectorEvalResultFormatSkippedRecordExample,
  autoinspectorEvalResultFormatTargetSchema,
  backofficeReviewSchema,
  backofficeReviewStageSchema,
  batchSendInspectionsRequestBody,
  batchSendInspectionsResponseBody,
  buildInspectionDetailImageUrlDiagnostics,
  buildUserName,
  carddDamageAssetSchema,
  carddDamageNames,
  carddDamageSeverities,
  carddDamageSizes,
  carddGroupDamageSchema,
  carddGroupOutputSchema,
  carddImageDamageSchema,
  carddImageDimensionsSchema,
  carddImageResultSchema,
  carddPolygonPointSchema,
  carddUnknownPartName,
  commitStagedInferenceResultsResponseBody,
  companySchema,
  computeStatusFromDates,
  convertHexToRgbaString,
  countEvalAnalysisCombinations,
  createAuthorizationURLRequestBody,
  createAuthorizationURLResponseBody,
  createInspectionAnnotationRequestBody,
  createInspectionAnnotationResponseBody,
  createInspectionPublicApiV2ResponseBodySchema,
  createInvoiceRequestBody,
  createInvoiceResponseBody,
  createSubscriptionRequestBody,
  createSubscriptionRequestParams,
  createSubscriptionResponseBody,
  createWebhookPublicApiV2RequestBodySchema,
  createWebhookPublicApiV2ResponseBodySchema,
  createZodTypeSafeEnumOpenApi,
  damageCostAnalysisJobSchema,
  damageCostAnalysisStatusSchema,
  dataTableFiltersSchema,
  dataTableRequestQuerySchema,
  dataTableSortSchema,
  defaultInspectionTableColumns,
  deleteInspectionAnnotationResponseBody,
  deleteWebhookPublicApiV2ResponseBodySchema,
  downloadInspectionsReportRequestBody,
  evalOptimizationCellSchema,
  evalOptimizationObjectiveSchema,
  evalOptimizationRequestSchema,
  evalOptimizationResponseSchema,
  executeSegmentationSimulationRequestBody,
  executeSegmentationSimulationResponseBody,
  externalEnvironmentCostUsageTokenDirections,
  externalEnvironmentDataClasses,
  externalEnvironmentDataSharingModes,
  externalEnvironmentDataSharingSchema,
  externalEnvironmentPipelineCostKinds,
  externalEnvironmentSyncAcceptedItemStatuses,
  externalEnvironmentSyncAssetBindingSchema,
  externalEnvironmentSyncAssetContentSchema,
  externalEnvironmentSyncAssetTypes,
  externalEnvironmentSyncContractAlignment,
  externalEnvironmentSyncContractVersions,
  externalEnvironmentSyncDetailUrlSchema,
  externalEnvironmentSyncInferenceContentSchema,
  externalEnvironmentSyncInferenceStatuses,
  externalEnvironmentSyncInspectionResults,
  externalEnvironmentSyncInspectionStatuses,
  externalEnvironmentSyncJsonSchemaDocumentSchema,
  externalEnvironmentSyncJsonValueSchema,
  externalEnvironmentSyncKeySchema,
  externalEnvironmentSyncObjectIdSchema,
  externalEnvironmentSyncRejectionReasons,
  externalEnvironmentSyncRejectionRetryability,
  externalEnvironmentSyncValidationReasoningSchema,
  externalEnvironmentSyncValidationResults,
  extractCalendarDate,
  formatDateToLocale,
  formatDateToLocaleDays,
  getCompaniesPaginationResponseBody,
  getCurrentDate,
  getTestingCurrentDate,
  getVehicleAngleModelUrlResponseBody,
  getVehicleCompletenessModelConfigResponseBody,
  homeStatsDateWindowUnits,
  identityProviders,
  inspectionAnnotationAttachmentSchema,
  inspectionAnnotationMentionSchema,
  inspectionAnnotationSchema,
  inspectionAnnotationTargetSchema,
  inspectionAssetContentAvailabilities,
  inspectionAssetProcessedWebhookPayloadAssetSchema,
  inspectionAssetProcessedWebhookPayloadSchema,
  inspectionChangelogStatusFilters,
  inspectionClientCompletedEventV2Schema,
  inspectionClientCompletedPayloadV2Schema,
  inspectionClientCompletionResponseBody,
  inspectionCostUsageAggregateSchema,
  inspectionCostUsageAnalysisBaseQuery,
  inspectionCostUsageAnalysisCategoryTotalSchema,
  inspectionCostUsageAnalysisCompanyDriverRowSchema,
  inspectionCostUsageAnalysisDeliveryChannelTotalSchema,
  inspectionCostUsageAnalysisDriverDimensionSchema,
  inspectionCostUsageAnalysisDriverDimensions,
  inspectionCostUsageAnalysisDriverRowSchema,
  inspectionCostUsageAnalysisDriverSortFieldSchema,
  inspectionCostUsageAnalysisDriverSortFields,
  inspectionCostUsageAnalysisDriversRequestQuery,
  inspectionCostUsageAnalysisDriversResponseBody,
  inspectionCostUsageAnalysisInspectionRowSchema,
  inspectionCostUsageAnalysisInspectionsRequestQuery,
  inspectionCostUsageAnalysisInspectionsResponseBody,
  inspectionCostUsageAnalysisModelVersionDriverRowSchema,
  inspectionCostUsageAnalysisRequestQuery,
  inspectionCostUsageAnalysisResponseBody,
  inspectionCostUsageAnalysisSortDirectionSchema,
  inspectionCostUsageAnalysisSummarySchema,
  inspectionCostUsageAnalysisTemplateDriverRowSchema,
  inspectionCostUsageAnalysisTrendPointSchema,
  inspectionCostUsagePricingCostUsageSchema,
  inspectionCostUsagePricingHistoryItemSchema,
  inspectionCostUsagePricingItemSchema,
  inspectionCostUsagePricingKeyByDeliveryChannel,
  inspectionCostUsagePricingKeySchema,
  inspectionCostUsageReportAssetDeclarationSchema,
  inspectionCostUsageReportCategorySchema,
  inspectionCostUsageReportLineItemSchema,
  inspectionCostUsageReportSourceSchema,
  inspectionCostUsageReportStatusSchema,
  inspectionDetailDamagesResponseBody,
  inspectionDetailIframeRequestQuerySchema,
  inspectionDetailImageErrorAssetContextSchema,
  inspectionDetailImageErrorBrowserContextSchema,
  inspectionDetailImageErrorEvents,
  inspectionDetailImageErrorFailureSchema,
  inspectionDetailImageErrorPageContextSchema,
  inspectionDetailImageErrorReportRequestBodySchema,
  inspectionDetailImageErrorReportResponseBodySchema,
  inspectionDetailImagePerformanceContextSchema,
  inspectionDetailImagePerformanceEntrySchema,
  inspectionDetailImageRedactedQueryParamKinds,
  inspectionDetailImageRenderContexts,
  inspectionDetailImageSupportedFileExtensions,
  inspectionDetailImageUrlDiagnosticsSchema,
  inspectionDetailImageUrlExpiryStates,
  inspectionLinkStatusUpdatedWebhookEventPayloadSchema,
  inspectionLinkStatusUpdatedWebhookPayloadSchema,
  inspectionOriginSummarySchema,
  inspectionResults,
  inspectionSamplingListItemSchema,
  invitationTokenHeaderName,
  invitationTokenRequestQuery,
  inviteUsersRequestBody,
  inviteUsersResponseBody,
  invoiceRequestParams,
  isCalendarDateWithinBounds,
  isInspectionDetailImageTelemetryEligible,
  isMongoObjectIdString,
  isRepresentableEvalAnalysisCombinationCount,
  listAllCompaniesResponseBody,
  listAssetInferenceChangelogsRequestQuery,
  listCompaniesRequestQuery,
  listCompanySubscriptionsResponseBody,
  listInferenceChangelogsResponseBodySchema,
  listInspectionAnnotationsResponseBody,
  listInspectionChangelogsRequestQuery,
  listInspectionChangelogsResponseBodySchema,
  listInspectionCostUsagePricingResponseBody,
  listInspectionSamplingRequestQuery,
  listInspectionSamplingResponseBody,
  listInvoicesRequestQuery,
  listInvoicesResponseBody,
  listOfficeInspectionsRequestQuery,
  listOfficeInspectionsResponseBody,
  listOfficeNotificationsRequestQuery,
  listOfficeNotificationsResponseBody,
  listTemplatesPublicApiV2RequestQuerySchema,
  listTemplatesPublicApiV2ResponseBodySchema,
  listWebhooksPublicApiV2ItemSchema,
  listWebhooksPublicApiV2RequestQuerySchema,
  listWebhooksPublicApiV2ResponseBodySchema,
  loginBouncedRequestQuery,
  loginUserIDPRequestBody,
  loginUserRequestBody,
  modelOperationalDiagnosticsIndicatorSchema,
  modelOperationalDiagnosticsMetadataSchema,
  modelOperationalDiagnosticsResponseBodySchema,
  modelOperationalDiagnosticsStatusSchema,
  mongoObjectIdStringSchema,
  normalizeEmail,
  officeInspectionDetailAssetSchema,
  officeInspectionDetailInferenceSchema,
  officeInspectionDetailValidationSchema,
  officeInspectionListItemSchema,
  officeNotificationListStatuses,
  officeNotificationMetadataSchema,
  officeNotificationSchema,
  officeUpdateTemplateRequestBody,
  onboardingInviteUsersRequestBody,
  persistedDeclaredAssetSchema,
  planLimitSchema,
  planSchema,
  prepareInvoiceDownloadRequestParams,
  prepareInvoiceDownloadResponseBody,
  presignInspectionAnnotationAttachmentRequestBody,
  presignInspectionAnnotationAttachmentResponseBody,
  publicInspectionAssetBindingSchema,
  publicInspectionInferenceSchema,
  publicInspectionInferenceValueSchema,
  publicInspectionTemplateValidationSchema,
  publicInspectionValidationSchema,
  publicSpecTemplateBindingAssetTypes,
  publicSpecTemplateInferenceSchema,
  publicSpecTemplateValidationSchema,
  readOfficeNotificationResponseBody,
  redactInspectionDetailImageErrorSensitiveText,
  registerClientInspectionEventRequestBody,
  registerClientInspectionEventResponseBody,
  registerCompanyRequestBody,
  registerCompanyResponseBody,
  registerEmailMembershipInvitationRequestBody,
  registerEmailMembershipInvitationRequestParams,
  registerEmailMembershipInvitationResponseBody,
  registerInspectionErrorRequestBody,
  registerInvitationIDPRequestBody,
  registerUserEventRequestBody,
  registerUserGuestRequestBody,
  requiredErrorFieldMessage,
  resendInvitationEmailAdminRequestBody,
  resendInvitationEmailAdminResponseBody,
  resolveDatasetOntologyLabelColorHex,
  resolveInspectionCostUsageAnalysisDateRange,
  resolveInspectionDetailImageSourceExtension,
  retrieveActiveWeeksStreakRequestQuery,
  retrieveActiveWeeksStreakResponseBody,
  retrieveActivityStatsRequestBody,
  retrieveActivityStatsResponseBody,
  retrieveCompanyRequestParams,
  retrieveCompanyResponseBody,
  retrieveCompanySubscriptionRequestQuery,
  retrieveCompanySubscriptionResponseBody,
  retrieveDamageCostAnalysisRequestParams,
  retrieveDamageCostAnalysisResponseBody,
  retrieveGuestRequestParams,
  retrieveGuestRequestQuery,
  retrieveGuestResponseBody,
  retrieveHomeStatsCalendarToDateRequestBodySchema,
  retrieveHomeStatsInTheLastRequestBodySchema,
  retrieveHomeStatsRequestBody,
  retrieveHomeStatsResponseBody,
  retrieveInspectionCostUsageReportsParams,
  retrieveInspectionCostUsageReportsResponseBody,
  retrieveInspectionProgressResponseBody,
  retrieveInspectionPublicApiV2ResponseBodySchema,
  retrieveInspectionSummaryRequestParams,
  retrieveMembershipFromInvitationRequestParams,
  retrieveMembershipFromInvitationResponseBody,
  retrieveOfficeInspectionDetailParamsSchema,
  retrieveOfficeInspectionDetailResponseBodySchema,
  retrieveSamplingAccuracyMetricsRequestQuery,
  retrieveSamplingAccuracyMetricsResponseBody,
  retrieveSegmentationEvolutionRequestQuery,
  retrieveSegmentationEvolutionResponseBody,
  retrieveSubscriptionRequestParams,
  retrieveSyncCheckpointResponseBodySchema,
  retrieveSyncEnvironmentResponseBodySchema,
  retrieveTemplatePublicApiV2RequestParamsSchema,
  retrieveTemplatePublicApiV2RequestQuerySchema,
  retrieveTemplatePublicApiV2ResponseAssetsExample,
  retrieveTemplatePublicApiV2ResponseBodyExample,
  retrieveTemplatePublicApiV2ResponseBodySchema,
  retrieveTemplatePublicApiV2ResponseInferencesExample,
  retrieveTemplatePublicApiV2ResponseSchemaExample,
  retrieveTemplatePublicApiV2ResponseValidationsExample,
  reviewInspectionSamplingResponseBody,
  rollbackInspectionSamplingReviewResponseBody,
  samplingAccuracyTemplateMetricSchema,
  searchPlanRequestQuery,
  searchPlanResponseBody,
  signInMethodSchema,
  similaritySearchRequestParams,
  similaritySearchRequestQuery,
  similaritySearchResponseBody,
  similaritySearchSupportedAssetTypes,
  sortLogicRules,
  sortValidationsByOrder,
  startDamageCostAnalysisRequestParams,
  startDamageCostAnalysisResponseBody,
  subscribeToAddonPlanRequestBody,
  syncBatchResponseBodySchema,
  syncCostUsageReportBindingV1Schema,
  syncCostUsageReportChargeV1Schema,
  syncCostUsageReportParamsSchema,
  syncCostUsageReportV1Schema,
  syncCostUsageReportsBatchRequestBodySchema,
  syncCostUsageUnitV1Schema,
  syncImplementedModelVersionReferenceV1Schema,
  syncInspectionAssetV1Schema,
  syncInspectionInferenceV1Schema,
  syncInspectionParamsSchema,
  syncInspectionV1Schema,
  syncInspectionValidationV1Schema,
  syncInspectionsBatchRequestBodySchema,
  syncItemResultV1Schema,
  syncModelV1Schema,
  syncModelVersionReferenceV1Schema,
  syncModelVersionV1Schema,
  syncModelsBatchRequestBodySchema,
  syncPipelineCostV1Schema,
  templateInputWalkaroundAssetSchema,
  templateInputWalkaroundSchema,
  templateValidationFeedbackSchema,
  timeAgo,
  toInspectionResultOption,
  tokenizeFileRequestBody,
  updateCompanyConfigRequestBody,
  updateCompanyRequestBody,
  updateCompanyRequestParams,
  updateInspectionCostUsagePricingParams,
  updateInspectionCostUsagePricingRequestBody,
  updateInspectionCostUsagePricingResponseBody,
  updateInvoiceRequestBody,
  updatePlanRequestBody,
  updatePlanRequestParams,
  updateSubscriptionRequestBody,
  updateTemplateRequestParams,
  userActivityBaseSchema,
  variableActionReferences,
  vehicleCompletenessModelContractSchema,
  webhookApiVersionPublicApiV2Schema,
  webhookEventPublicApiV2Schema,
  webhookPublicApiV2EventsSpec
});
